(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode('@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_100-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_100-webfont.woff) format("woff");font-display:swap;font-style:normal;font-weight:100;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_100_Italic-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_100_Italic-webfont.woff) format("woff");font-display:swap;font-style:italic;font-weight:100;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_300-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_300-webfont.woff) format("woff");font-display:swap;font-style:normal;font-weight:300;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_300_Italic-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_300_Italic-webfont.woff) format("woff");font-display:swap;font-style:italic;font-weight:300;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_500-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_500-webfont.woff) format("woff");font-display:swap;font-style:normal;font-weight:500;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_500_Italic-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_500_Italic-webfont.woff) format("woff");font-display:swap;font-style:italic;font-weight:500;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_700-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_700-webfont.woff) format("woff");font-display:swap;font-style:normal;font-weight:700;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_700_Italic-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_700_Italic-webfont.woff) format("woff");font-display:swap;font-style:italic;font-weight:700;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_900-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_900-webfont.woff) format("woff");font-display:swap;font-style:normal;font-weight:900;font-stretch:normal}@font-face{font-family:Museo Sans;src:url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_900_Italic-webfont.woff2) format("woff2"),url(https://cdn.services.ajbell.co.uk/fonts/museoSans/MuseoSans_900_Italic-webfont.woff) format("woff");font-display:swap;font-style:italic;font-weight:900;font-stretch:normal}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.oxum-relative{position:relative}.oxum-bottom-0{bottom:0}.oxum-order-1{order:1}.oxum-order-2{order:2}.oxum-col-span-1{grid-column:span 1 / span 1}.oxum-col-span-2{grid-column:span 2 / span 2}.oxum-float-right{float:right}.oxum-m-auto{margin:auto}.oxum-mx-2{margin-left:.5rem;margin-right:.5rem}.oxum-mx-4{margin-left:1rem;margin-right:1rem}.oxum-my-4{margin-top:1rem;margin-bottom:1rem}.oxum-mb-10{margin-bottom:2.5rem}.oxum-mb-5{margin-bottom:1.25rem}.oxum-ml-2{margin-left:.5rem}.oxum-ml-3{margin-left:.75rem}.oxum-ml-4{margin-left:1rem}.oxum-mr-2{margin-right:.5rem}.oxum-mr-4{margin-right:1rem}.oxum-mt-0{margin-top:0}.oxum-mt-2{margin-top:.5rem}.oxum-mt-4{margin-top:1rem}.oxum-mt-5{margin-top:1.25rem}.oxum-block{display:block}.oxum-inline-block{display:inline-block}.oxum-inline{display:inline}.oxum-flex{display:flex}.oxum-grid{display:grid}.oxum-hidden{display:none}.oxum-w-1\\/6{width:16.666667%}.oxum-w-11\\/12{width:91.666667%}.oxum-w-5\\/6{width:83.333333%}.oxum-w-auto{width:auto}.oxum-w-full{width:100%}.oxum-grow{flex-grow:1}.oxum-grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.oxum-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.oxum-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.oxum-flex-col{flex-direction:column}.oxum-flex-wrap{flex-wrap:wrap}.oxum-flex-nowrap{flex-wrap:nowrap}.oxum-justify-between{justify-content:space-between}.oxum-gap-0{gap:0px}.oxum-gap-4{gap:1rem}.oxum-overflow-hidden{overflow:hidden}.oxum-px-4{padding-left:1rem;padding-right:1rem}.oxum-py-10{padding-top:2.5rem;padding-bottom:2.5rem}.oxum-py-20{padding-top:5rem;padding-bottom:5rem}.oxum-pb-5{padding-bottom:1.25rem}.oxum-pr-3{padding-right:.75rem}.oxum-pr-7{padding-right:1.75rem}.oxum-pt-5{padding-top:1.25rem}.oxum-text-sm{font-size:.875rem;line-height:1.25rem}.oxum-font-bold{font-weight:700}.oxum-text-black{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity))}.sbdocs-content{min-width:100%}.sb-show-main.sb-main-padded{padding:0}html{font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif}.ajbl-fe-comp{font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif;font-size:1.25rem;line-height:3rem;font-weight:300}.ajbl-fe-comp a{font-weight:unset}.ajbl-fe-comp *:focus{outline:none}.ajbl-fe-comp nav{height:unset;color:unset}@media (width >= 601px){.ajbl-fe-comp nav{height:unset}}.ajbl-fe-comp .flex{height:unset}.ajbl-fe-comp h1,.ajbl-fe-comp .h1{font-size:4rem;font-style:normal;font-weight:300;line-height:4.5rem}.ajbl-fe-comp h2,.ajbl-fe-comp .h2{font-size:3rem;font-style:normal;font-weight:300;line-height:4rem}.ajbl-fe-comp h3,.ajbl-fe-comp .h3{font-size:2rem;font-style:normal;font-weight:300;line-height:3rem}.ajbl-fe-comp h4,.ajbl-fe-comp .h4{font-size:1.5rem;font-style:normal;font-weight:300;line-height:2rem}.paragraph--type--menu-content h4{font-size:2rem;font-style:normal;font-weight:300;line-height:2rem;margin-bottom:1.5rem}.abjl-anti-legacy-style .desktop-nav li{float:none!important}.abjl-anti-legacy-style input[type=text]:not(.browser-default):focus:not([readonly]){box-shadow:unset!important;border-bottom:2px solid #000000!important}.abjl-anti-legacy-style .ajbl-button.ajbl-button--light:not(.no-animation):hover,.abjl-anti-legacy-style .ajbl-button.ajbl-button--light:not(.no-animation):focus{background-color:#fff!important}.abjl-anti-legacy-style .ajbl-button.ajbl-button--dark:not(.no-animation):hover{color:#000!important}.abjl-anti-legacy-style input:not(.browser-default):focus:not([readonly]){box-shadow:none!important}.abjl-anti-legacy-style .ajbl-mega-nav__login-btn:not(.no-animation):hover{color:#000!important}.abjl-anti-legacy-style .ajbl-mega-nav__login-btn:not(.no-animation):focus{background-color:#373741}.abjl-anti-legacy-style .main-nav-logout:hover{color:#373741!important}.abjl-anti-legacy-style .main-nav-logout:focus{background-color:#fff!important}.abjl-anti-legacy-style .ajbl-mega-nav__search-btn:focus{background-color:#fff}.abjl-anti-legacy-style .desktop-search-sub-nav_search-input:focus,.abjl-anti-legacy-style .mobile-search-sub-nav_search-input:focus{border-bottom:1px solid #000000!important}.abjl-anti-legacy-style .input[type=text]:not(.browser-default):focus:not([readonly]).ajbl-mega-nav__sub-level-search-input-container{border-bottom-color:#373741!important}.abjl-anti-legacy-style a:hover{text-decoration:none!important}.abjl-anti-legacy-style .ajbl-button svg,.abjl-anti-legacy-style a.ajbl-button svg,.abjl-anti-legacy-style button.ajbl-button svg{display:inline-block!important;vertical-align:-.125em}.abjl-anti-legacy-style .ajbl-button:focus,.abjl-anti-legacy-style .ajbl-button:hover,.abjl-anti-legacy-style .ajbl-button--selected,.abjl-anti-legacy-style a.ajbl-button:focus,.abjl-anti-legacy-style a.ajbl-button:hover,.abjl-anti-legacy-style a.ajbl-button--selected,.abjl-anti-legacy-style button.ajbl-button:focus,.abjl-anti-legacy-style button.ajbl-button:hover,.abjl-anti-legacy-style button.ajbl-button--selected{text-decoration:none!important}.abjl-anti-legacy-style .ajbl-button--dark:not(.no-animation):focus,.abjl-anti-legacy-style .ajbl-button--dark:not(.no-animation):hover,.abjl-anti-legacy-style .ajbl-button--dark:not(.no-animation).ajbl-button--selected,.abjl-anti-legacy-style a.ajbl-button--dark:not(.no-animation):focus,.abjl-anti-legacy-style a.ajbl-button--dark:not(.no-animation):hover,.abjl-anti-legacy-style a.ajbl-button--dark:not(.no-animation).ajbl-button--selected,.abjl-anti-legacy-style button.ajbl-button--dark:not(.no-animation):focus,.abjl-anti-legacy-style button.ajbl-button--dark:not(.no-animation):hover,.abjl-anti-legacy-style button.ajbl-button--dark:not(.no-animation).ajbl-button--selected{color:#373741!important;background-color:#373741!important}.abjl-anti-legacy-style .nav-item:not(.no-animation):hover,.abjl-anti-legacy-style .nav-item:not(.no-animation).nav-item--selected,.abjl-anti-legacy-style button.nav-item:not(.no-animation):hover,.abjl-anti-legacy-style button.nav-item:not(.no-animation).nav-item--selected,.abjl-anti-legacy-style a.nav-item:not(.no-animation):hover,.abjl-anti-legacy-style a.nav-item:not(.no-animation).nav-item--selected{color:#d50032;text-decoration:none!important}.abjl-anti-legacy-style .nav-item:not(.no-animation):hover:after,.abjl-anti-legacy-style .nav-item:not(.no-animation).nav-item--selected:after,.abjl-anti-legacy-style button.nav-item:not(.no-animation):hover:after,.abjl-anti-legacy-style button.nav-item:not(.no-animation).nav-item--selected:after,.abjl-anti-legacy-style a.nav-item:not(.no-animation):hover:after,.abjl-anti-legacy-style a.nav-item:not(.no-animation).nav-item--selected:after{width:100%;opacity:1}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-button:after{display:none!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__login-btn:focus{background-color:#373741!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__login-btn.ajbl-button--light:focus{color:#fff!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-login-btn:hover{color:#373741!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn.ajbl-button--light:focus{background-color:#fff!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn.ajbl-button--dark:focus{background-color:#000!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-button--light.ajbl-mega-nav__search-btn:focus,.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__sub-level-close-btn:focus{background-color:#fff!important}.abjl-anti-legacy-style.ajbl-mega-nav .desktop-sub-nav a.nav-item{text-decoration:none!important}.abjl-anti-legacy-style.ajbl-mega-nav.ajbl-main-footer a.nav-item:hover{text-decoration:none!important;color:#373741!important}.abjl-anti-legacy-style.ajbl-mega-nav .desktop-nav button.nav-item:after,.abjl-anti-legacy-style.ajbl-mega-nav .desktop-nav a.nav-item:after{left:0;margin-bottom:0;transform:none;padding:0}.abjl-anti-legacy-style.ajbl-mega-nav .desktop-nav button.nav-item:before,.abjl-anti-legacy-style.ajbl-mega-nav .desktop-nav a.nav-item:before{transform:translate(0);border-top:none}.abjl-anti-legacy-style.ajbl-mega-nav .desktop-nav [aria-label]:not([data-balloon-pos]):hover:after{left:0}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__sub-level [aria-label]:not([data-balloon-pos],.screenerField):before{display:none}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu a.ajbl-button--dark:hover,.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu a.ajbl-button--dark:focus,.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu button.ajbl-button--dark:hover,.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu button.ajbl-button--dark:focus{color:#fff!important}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu [aria-label]:not([data-balloon-pos]):after{left:0;margin-bottom:0;transform:none;padding:0}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu [aria-label]:not([data-balloon-pos]):hover:after{transform:none}.abjl-anti-legacy-style.ajbl-mega-nav .ajbl-mega-nav__top-level--right-menu [aria-label]:not(.screenerField):before{display:none}@media (min-width: 640px){.sm\\:oxum-inline{display:inline}}@media (min-width: 768px){.md\\:oxum-order-1{order:1}.md\\:oxum-order-2{order:2}.md\\:oxum-mt-0{margin-top:0}.md\\:oxum-flex{display:flex}.md\\:oxum-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:oxum-flex-row{flex-direction:row}.md\\:oxum-space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}}@media (min-width: 1024px){.lg\\:oxum-absolute{position:absolute}.lg\\:oxum-right-0{right:0}.lg\\:oxum-ml-3{margin-left:.75rem}.lg\\:oxum-mt-0{margin-top:0}.lg\\:oxum-inline-block{display:inline-block}.lg\\:oxum-w-1\\/2{width:50%}.lg\\:oxum-w-3\\/12{width:25%}.lg\\:oxum-w-auto{width:auto}.lg\\:oxum-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.lg\\:oxum-text-right{text-align:right}}@media (min-width: 1280px){.xl\\:oxum-w-2\\/3{width:66.666667%}}@keyframes shimmer{to{-webkit-mask-position:left;mask-position:left}}.ajbl-Loadingshimmer span{background-color:#eee;display:block;-webkit-mask:linear-gradient(-60deg,#000000 30%,rgba(0,0,0,.3333333333),#000000 70%) right/350% 100%;mask:linear-gradient(-60deg,#000000 30%,rgba(0,0,0,.3333333333),#000000 70%) right/350% 100%;animation:shimmer 1.5s infinite;width:100%;height:50px;position:relative}.nav-item,button.nav-item,a.nav-item{font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif;color:#373741;font-size:16px;line-height:24px;position:relative;display:inline-block;transition-duration:.1s;cursor:pointer;padding:unset;background:unset;border:unset}.nav-item svg,button.nav-item svg,a.nav-item svg{height:13px;width:13px}.nav-item:focus-visible,button.nav-item:focus-visible,a.nav-item:focus-visible{box-shadow:0 0 1px 2px #0b3caa;z-index:10}.nav-item:after,button.nav-item:after,a.nav-item:after{content:"";height:3px;background-color:#d50032;width:0;opacity:0;bottom:-.5rem;left:0;position:absolute;transition-duration:.15s}.nav-item .nav-item__left-icon,.nav-item .nav-item__right-icon,button.nav-item .nav-item__left-icon,button.nav-item .nav-item__right-icon,a.nav-item .nav-item__left-icon,a.nav-item .nav-item__right-icon{display:inline-block;position:relative;top:0;left:0;font-size:13px;margin-top:5px;transition-duration:.15s}.nav-item .nav-item__left-icon,button.nav-item .nav-item__left-icon,a.nav-item .nav-item__left-icon{margin-right:.5rem;float:left}.nav-item .nav-item__right-icon,button.nav-item .nav-item__right-icon,a.nav-item .nav-item__right-icon{margin-left:.5rem;float:right}.nav-item:hover,.nav-item--selected,button.nav-item:hover,button.nav-item--selected,a.nav-item:hover,a.nav-item--selected{color:#d50032}.nav-item:hover:after,.nav-item--selected:after,button.nav-item:hover:after,button.nav-item--selected:after,a.nav-item:hover:after,a.nav-item--selected:after{width:100%;opacity:1}.nav-item:not(.no-animation):hover.nav-item--up .nav-item__left-icon,.nav-item:not(.no-animation):hover.nav-item--up .nav-item__right-icon,button.nav-item:not(.no-animation):hover.nav-item--up .nav-item__left-icon,button.nav-item:not(.no-animation):hover.nav-item--up .nav-item__right-icon,a.nav-item:not(.no-animation):hover.nav-item--up .nav-item__left-icon,a.nav-item:not(.no-animation):hover.nav-item--up .nav-item__right-icon{top:-2px}.nav-item:not(.no-animation):hover.nav-item--down .nav-item__left-icon,.nav-item:not(.no-animation):hover.nav-item--down .nav-item__right-icon,button.nav-item:not(.no-animation):hover.nav-item--down .nav-item__left-icon,button.nav-item:not(.no-animation):hover.nav-item--down .nav-item__right-icon,a.nav-item:not(.no-animation):hover.nav-item--down .nav-item__left-icon,a.nav-item:not(.no-animation):hover.nav-item--down .nav-item__right-icon{top:2px}.nav-item:not(.no-animation):hover.nav-item--left .nav-item__left-icon,.nav-item:not(.no-animation):hover.nav-item--left .nav-item__right-icon,button.nav-item:not(.no-animation):hover.nav-item--left .nav-item__left-icon,button.nav-item:not(.no-animation):hover.nav-item--left .nav-item__right-icon,a.nav-item:not(.no-animation):hover.nav-item--left .nav-item__left-icon,a.nav-item:not(.no-animation):hover.nav-item--left .nav-item__right-icon{left:-2px}.nav-item:not(.no-animation):hover.nav-item--right .nav-item__left-icon,.nav-item:not(.no-animation):hover.nav-item--right .nav-item__right-icon,button.nav-item:not(.no-animation):hover.nav-item--right .nav-item__left-icon,button.nav-item:not(.no-animation):hover.nav-item--right .nav-item__right-icon,a.nav-item:not(.no-animation):hover.nav-item--right .nav-item__left-icon,a.nav-item:not(.no-animation):hover.nav-item--right .nav-item__right-icon{left:2px}.nav-item--tab-variant,button.nav-item--tab-variant,a.nav-item--tab-variant{display:block;width:100%;text-align:left;padding:1.5rem 1rem;border:1px solid #d7d7d9;margin:0;transition-duration:.15s;transition-property:background-color,opacity,color;background-color:#fff}.nav-item--tab-variant:hover,button.nav-item--tab-variant:hover,a.nav-item--tab-variant:hover{background-color:#f8f8f8}.nav-item--tab-variant:after,button.nav-item--tab-variant:after,a.nav-item--tab-variant:after{display:none}.nav-item.no-animation,button.nav-item.no-animation,a.nav-item.no-animation{transition-duration:0s}.nav-item.no-animation:after,button.nav-item.no-animation:after,a.nav-item.no-animation:after{transition-duration:0s}.ajbl-button{font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif;background-color:#d50032;color:#fff;border:2px solid #d50032;border-radius:5.5rem;font-size:1rem;line-height:22px;position:relative;display:inline-block;transition-duration:.15s;padding:.5rem 1rem 6px;cursor:pointer}.ajbl-button svg{width:13px;height:13px}.ajbl-button:focus-visible{box-shadow:0 0 1px 2px #0b3caa;z-index:10}.ajbl-button__left-icon,.ajbl-button__right-icon{display:inline-block;position:relative;left:0;font-size:13px;top:-1px;transition-duration:.15s}.ajbl-button__left-icon{margin-right:.5rem}.ajbl-button__right-icon{margin-left:.5rem}.ajbl-button:not(.no-animation):focus,.ajbl-button:not(.no-animation):hover,.ajbl-button:not(.no-animation) --selected{background-color:#fff;color:#d50032}.ajbl-button:not(.no-animation):focus.ajbl-button--up .ajbl-button__left-icon,.ajbl-button:not(.no-animation):focus.ajbl-button--up .ajbl-button__right-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--up .ajbl-button__left-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--up .ajbl-button__right-icon{top:-2px}.ajbl-button:not(.no-animation):focus.ajbl-button--down .ajbl-button__left-icon,.ajbl-button:not(.no-animation):focus.ajbl-button--down .ajbl-button__right-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--down .ajbl-button__left-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--down .ajbl-button__right-icon{top:2px}.ajbl-button:not(.no-animation):focus.ajbl-button--left .ajbl-button__left-icon,.ajbl-button:not(.no-animation):focus.ajbl-button--left .ajbl-button__right-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--left .ajbl-button__left-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--left .ajbl-button__right-icon{left:-2px}.ajbl-button:not(.no-animation):focus.ajbl-button--right .ajbl-button__left-icon,.ajbl-button:not(.no-animation):focus.ajbl-button--right .ajbl-button__right-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--right .ajbl-button__left-icon,.ajbl-button:not(.no-animation):hover.ajbl-button--right .ajbl-button__right-icon{left:2px}.ajbl-button--dark{background-color:#373741;border-color:#373741;color:#fff}.ajbl-button--dark:not(.no-animation):focus,.ajbl-button--dark:not(.no-animation):hover,.ajbl-button--dark:not(.no-animation).ajbl-button--selected{background-color:#fff;color:#373741}.ajbl-button--light{background-color:#fff;border-color:#373741;color:#373741}.ajbl-button--light:not(.no-animation):focus,.ajbl-button--light:not(.no-animation):hover,.ajbl-button--light:not(.no-animation).ajbl-button--selected{background-color:#373741;color:#fff}.ajbl-button--no-children .ajbl-button__left-icon,.ajbl-button--no-children .ajbl-button__right-icon{margin-left:0;margin-right:0}.ajbl-content-card{padding:2rem 1.5rem;border-radius:1rem;background-color:#fff;border:1px solid #d7d7d9;display:block;box-shadow:0 3px 20px #00000014}.ajbl-select{position:relative}.ajbl-select .select__input{height:100%;z-index:5}.ajbl-select:focus-within .css-b62m3t-container{outline:2px solid rgb(11,60,170);border-radius:10px}.ajbl-select .select__control{margin-bottom:.5rem;margin-top:.5rem;font-size:1rem;border:1px solid #5f5f68;background-color:#fff;border-radius:.5rem;padding:.5rem;font-style:italic;cursor:pointer}.ajbl-select .select__control:focus{outline:none}.ajbl-select .select__indicator-separator{display:none}.ajbl-select .ajbl-select__caret{position:absolute;width:10px;right:30px;top:50%;transform:translateY(-50%);z-index:1}.ajbl-select .select__dropdown-indicator svg{visibility:hidden}.ajbl-select .select__dropdown-indicator:after{content:"";position:relative;right:16px;top:7px;width:0;height:0;border-style:solid;border-width:8px;border-color:#373741 transparent transparent transparent;border-radius:4px}.ajbl-select .ajbl-select__label{font-size:1.5rem;font-weight:700;line-height:1.5rem;color:#000;display:block;margin-bottom:.5rem}.ajbl-select .ajbl-select__hint{color:#5f5f68;font-size:1rem;font-style:normal;font-weight:700;line-height:1.5rem;margin-bottom:.5rem}.ajbl-select .ajbl-select__sysmsg{font-size:1.25rem;font-weight:500;line-height:1.5rem;margin-bottom:.5rem}.ajbl-select--selected .ajbl-select__sysmsg,.ajbl-select--success .ajbl-select__sysmsg{color:#009f00}.ajbl-select--selected .select__control,.ajbl-select--success .select__control{border:.25rem solid #009f00;background-color:#f9fff0}.ajbl-select--error .ajbl-select__sysmsg{color:red}.ajbl-select--error .select__control{border:.25rem solid #ff0000;background-color:#fdf6f7}.ajbl-select--disabled .ajbl-select__label,.ajbl-select--disabled .ajbl-select__hint,.ajbl-select--disabled .ajbl-select__sysmsg{color:#87878e}.ajbl-select--disabled .ajbl-select__hint:last-of-type{color:#d7d7d9}.ajbl-select--disabled .select__control{border:none;background-color:#d7d7d9}.ajbl-select--disabled .select__dropdown-indicator:after{border-color:#87878e transparent transparent transparent}.ajbl-select .select__menu{position:relative;top:1.5rem}.ajbl-select .select__menu .select__option{transition-duration:.15s;cursor:pointer;color:#000;font-size:1rem;line-height:1.5rem}.ajbl-select .select__menu .select__option--is-focused{background-color:#f8f8f8;color:#000}.ajbl-select .select__menu .select__option--is-selected{background-color:transparent;color:#d50032}.ajbl-select .select__menu:before{content:"";position:absolute;display:block;width:30px;height:30px;background-color:#fff;top:-15px;left:25px;transform:rotate(45deg);border-top:1px solid #E5E5E5;border-left:1px solid #E5E5E5}.ajbl-select--abs-dropdown .select__menu{top:75px;left:0;position:absolute}.ajbl-select input{height:1px;margin:0;padding:0}.ajbl-select:not(.ajbl-select--error,.ajbl-select--selected) .css-13cymwt-control,.ajbl-select:not(.ajbl-select--error,.ajbl-select--selected) .css-t3ipsp-control{box-shadow:none}.ajbl-select:not(.ajbl-select--error,.ajbl-select--selected) .css-13cymwt-control:hover,.ajbl-select:not(.ajbl-select--error,.ajbl-select--selected) .css-t3ipsp-control:hover{border:1px solid #000000}.ajbl-checkselect{position:relative;width:100%;display:block}.ajbl-checkselect .ajbl-checkselect__select-box{cursor:pointer;position:relative;margin-bottom:.5rem;margin-top:.5rem;font-size:1rem;border:1px solid #5f5f68;background-color:#fff;border-radius:.5rem;padding:.5rem 1rem;font-style:italic;line-height:34px;width:100%;transition-duration:.15s;font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif}.ajbl-checkselect .ajbl-checkselect__select-box:focus{outline:none}.ajbl-checkselect .ajbl-checkselect__arrow{content:"";display:block;position:absolute;right:16px;top:60%;width:0;height:0;border-style:solid;border-width:8px;border-color:#373741 transparent transparent transparent;border-radius:4px;transform:translateY(-50%)}.ajbl-checkselect .ajbl-checkselect__dropdown{position:relative;margin-top:30px;margin-bottom:15px;padding-top:15px;left:0;width:100%;border-radius:.5rem;box-shadow:0 0 0 1px #0000001a,0 4px 11px #0000001a;z-index:1000;background-color:#fff}@media (max-width: 1280px){.ajbl-checkselect .ajbl-checkselect__dropdown{width:150%}}@media (max-width: 1024px){.ajbl-checkselect .ajbl-checkselect__dropdown{width:100%}}.ajbl-checkselect .ajbl-checkselect__dropdown:after{content:"";background:linear-gradient(180deg,#fff 10%,#fff0);display:block;width:100%;height:10%;top:10px;left:0;position:absolute;z-index:-1}.ajbl-checkselect .ajbl-checkselect__dropdown .ajbl-checkselect__options-list{max-height:182px;overflow-y:auto}.ajbl-checkselect .ajbl-checkselect__dropdown .ajbl-checkselect__dropdown-actions{text-align:center;padding:8px;border-top:1px solid #cccccc;background-color:#f2f2ea}.ajbl-checkselect .ajbl-checkselect__dropdown .ajbl-checkselect__dropdown-actions .ajbl-checkselect__clear-all{text-decoration:underline;font-weight:400;transition-duration:.15s;margin-top:.5rem;margin-bottom:.5rem;border:none}.ajbl-checkselect .ajbl-checkselect__dropdown .ajbl-checkselect__dropdown-actions .ajbl-checkselect__clear-all:hover{opacity:.5}.ajbl-checkselect .ajbl-checkselect__dropdown .ajbl-checkselect__dropdown-actions .ajbl-checkselect__clear-all:focus{background-color:transparent}.ajbl-checkselect .ajbl-checkselect__dropdown .ajbl-checkselect__dropdown-actions .ajbl-checkselect__save{padding-left:1rem;padding-right:1rem;margin-top:.5rem;margin-bottom:.5rem}.ajbl-checkselect .ajbl-checkselect__dropdown:before{content:"";position:absolute;display:block;width:30px;height:30px;background-color:#fff;top:-15px;left:25px;z-index:-3;transform:rotate(45deg);border-top:1px solid #e5e5e5;border-left:1px solid #e5e5e5}.ajbl-checkselect .ajbl-checkselect__dropdown--big-list{width:300%}.ajbl-checkselect .ajbl-checkselect__dropdown--big-list .ajbl-checkselect__option{width:33%}@media (max-width: 1024px){.ajbl-checkselect .ajbl-checkselect__dropdown--big-list,.ajbl-checkselect .ajbl-checkselect__dropdown--big-list .ajbl-checkselect__option{width:100%}}.ajbl-checkselect .ajbl-checkselect__label{font-size:1.5rem;font-weight:700;line-height:1.5rem;color:#000;display:block;margin-bottom:.5rem}.ajbl-checkselect .ajbl-checkselect__hint{color:#5f5f68;font-size:1rem;font-style:normal;font-weight:700;line-height:1.5rem;margin-bottom:.5rem}.ajbl-checkselect .ajbl-checkselect__sysmsg{font-size:1.25rem;font-weight:500;line-height:1.5rem;margin-bottom:.5rem}.ajbl-checkselect .ajbl-checkselect__option{position:relative;display:block;align-items:center;padding:.5rem;cursor:pointer;transition-duration:.1s;width:100%}.ajbl-checkselect .ajbl-checkselect__option:after{content:"";transition-duration:.15s;display:block;position:absolute;top:0;left:0;width:100%;height:100%;z-index:-3;opacity:0}.ajbl-checkselect .ajbl-checkselect__option:hover,.ajbl-checkselect .ajbl-checkselect__option:focus{color:#d50032}.ajbl-checkselect .ajbl-checkselect__option:hover:after,.ajbl-checkselect .ajbl-checkselect__option:focus:after{opacity:1}.ajbl-checkselect .ajbl-checkselect__option input[type=checkbox]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.ajbl-checkselect .ajbl-checkselect__option .custom-checkbox{position:relative;height:16px;width:16px;display:block;background-color:#eee;border-radius:4px;margin-right:8px}.ajbl-checkselect .ajbl-checkselect__option .custom-checkbox:after{content:"";position:absolute;display:block;opacity:0;transition-duration:.15s;left:5px;top:2px;width:4px;height:8px;border:solid #d50032;border-width:0 2px 2px 0;transform:rotate(0)}.ajbl-checkselect .ajbl-checkselect__option input[type=checkbox]:focus+.custom-checkbox{outline:3px solid #aaaaaa}.ajbl-checkselect .ajbl-checkselect__option .ajbl-checkselect__option-item{position:relative;display:block;margin-top:-20px;left:22px;width:80%;z-index:-2;text-align:left}.ajbl-checkselect .ajbl-checkselect__option .ajbl-checkselect__option-item:focus-visible{border:none;color:#d50032;outline:none}.ajbl-checkselect .ajbl-checkselect__option input:checked~.custom-checkbox{border:1px solid #d7d7d9;background-color:#fff}.ajbl-checkselect .ajbl-checkselect__option input:checked~.custom-checkbox:after{opacity:1;transform:rotate(45deg)}.ajbl-checkselect .ajbl-checkselect__custom-content{margin:8px 0;padding:.5rem;border-top:1px solid #d7d7d9;border-bottom:1px solid #d7d7d9;font-size:.9rem}.ajbl-checkselect--selected .ajbl-checkselect__sysmsg,.ajbl-checkselect--success .ajbl-checkselect__sysmsg{color:#009f00}.ajbl-checkselect--selected .ajbl-checkselect__select-box,.ajbl-checkselect--success .ajbl-checkselect__select-box{border:.25rem solid #009f00;background-color:#f9fff0}.ajbl-checkselect--error .ajbl-checkselect__sysmsg{color:red}.ajbl-checkselect--error .ajbl-checkselect__select-box{border:.25rem solid #ff0000;background-color:#fdf6f7}.ajbl-checkselect--disabled .ajbl-checkselect__label,.ajbl-checkselect--disabled .ajbl-checkselect__hint,.ajbl-checkselect--disabled .ajbl-checkselect__sysmsg{color:#87878e}.ajbl-checkselect--disabled .ajbl-checkselect__hint:last-of-type{color:#d7d7d9}.ajbl-checkselect--disabled .ajbl-checkselect__select-box{border:none;background-color:#d7d7d9;color:#bbb}.ajbl-checkselect--disabled .select__dropdown-indicator:after{border-color:#87878e transparent transparent transparent}.ajbl-checkselect--disabled .ajbl-checkselect__arrow{border-color:#87878e transparent transparent transparent}.ajbl-checkselect--abs-dropdown .ajbl-checkselect__dropdown{position:absolute;top:85px}@media (min-width: 768px){.ajbl-checkselect--right-side .ajbl-checkselect__dropdown{left:revert;right:0}.ajbl-checkselect--right-side .ajbl-checkselect__dropdown:before{left:revert;right:25px}}.ajbl-checkselect--variant-2 .ajbl-checkselect__label{font-size:1rem;font-weight:400;line-height:1.5rem}.ajbl-checkselect--variant-2 .ajbl-checkselect__select-box{border-radius:16px;color:#565656;border:1px solid #d9d9d9;font-style:normal;font-weight:300;transition-duration:.1s}.ajbl-checkselect--variant-2 .ajbl-checkselect__select-box:hover,.ajbl-checkselect--variant-2 .ajbl-checkselect__select-box:focus{border:1px solid #000000}.ajbl-checkselect--variant-2 .ajbl-checkselect__select-box:focus{outline:3px solid #aaaaaa}.ajbl-checkselect--variant-2.ajbl-checkselect--selected .ajbl-checkselect__select-box{border:solid #009f00;top:-3px}.ajbl-checkselect--variant-2 .ajbl-checkselect__option{font-size:1rem;font-weight:400}.ajbl-mega-nav,nav.ajbl-mega-nav{background-color:#fff;z-index:50;height:72px;top:0;left:0;width:100%;position:sticky}@media (min-width: 1180px){.ajbl-mega-nav,nav.ajbl-mega-nav{overflow:clip visible}}@media only screen and (width >= 320px) and (width <= 600px) and (orientation: landscape){.ajbl-mega-nav,nav.ajbl-mega-nav{position:absolute;z-index:100}}.ajbl-mega-nav.desktop-nav-active,nav.ajbl-mega-nav.desktop-nav-active{height:auto;margin-bottom:-100%}.ajbl-mega-nav .h4,.ajbl-mega-nav h4,nav.ajbl-mega-nav .h4,nav.ajbl-mega-nav h4{color:#373741;margin-bottom:0;padding-top:1.25rem}.ajbl-mega-nav .ajbl-mega-nav__top-level,nav.ajbl-mega-nav .ajbl-mega-nav__top-level{height:72px;padding:1rem;border-bottom:1px solid #d7d7d9;width:100%}@media (max-width: 1180px){.ajbl-mega-nav .ajbl-mega-nav__top-level,nav.ajbl-mega-nav .ajbl-mega-nav__top-level{padding:1rem;border-bottom:none}}@media (max-width: 375px){.ajbl-mega-nav .ajbl-mega-nav__top-level,nav.ajbl-mega-nav .ajbl-mega-nav__top-level{height:auto}}.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo{max-width:105px;transition-duration:0s;position:relative}@media (max-width: 1280px){.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo{max-width:95px}}@media (max-width: 1180px){.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo{top:.25rem;max-width:90px}}@media (max-width: 375px){.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-logo{max-width:60px}}.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item:before,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item:before{content:"";position:absolute;width:100%;height:200%;z-index:5;top:0;left:0}@media (min-width: 1280px){.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item{margin-right:1rem}}@media (max-width: 1500px){.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item{font-size:.9rem}}.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item--down .nav-item__left-icon,.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item--down .nav-item__right-icon,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item--down .nav-item__left-icon,nav.ajbl-mega-nav .ajbl-mega-nav__top-level .nav-item--down .nav-item__right-icon{left:2px}.ajbl-mega-nav .ajbl-mega-nav__sub-level,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level{padding-bottom:4rem;background-color:#fff;position:relative}.ajbl-mega-nav .ajbl-mega-nav__sub-level:after,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level:after{content:"";display:block;background-color:#5f5f68;width:100%;height:100vh;opacity:.4;position:absolute}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item{border-top-width:0;border-right-width:0}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item .sub-nav-title,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item .sub-nav-title{position:relative}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item .sub-nav-title:after,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item .sub-nav-title:after{display:block;content:"";height:2px;background-color:#d50032;position:absolute;width:0;opacity:0;bottom:-.75rem;transition-duration:0s}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item.nav-item--selected,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item.nav-item--selected{background-color:#f8f8f8}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item.nav-item--selected .sub-nav-title:after,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item.nav-item--selected .sub-nav-title:after{width:100%;opacity:1}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:first-child .ajbl-mega-nav__sub-item,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:first-child .ajbl-mega-nav__sub-item{border-right-width:0}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:last-child .ajbl-mega-nav__sub-item,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:last-child .ajbl-mega-nav__sub-item{border-right-width:1px}.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:last-child .ajbl-mega-nav__sub-item.ajbl-mega-nav__field-text-content,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:last-child .ajbl-mega-nav__sub-item.ajbl-mega-nav__field-text-content{border-right-width:0}.ajbl-mega-nav .ajbl-mega-nav__field-text-content,nav.ajbl-mega-nav .ajbl-mega-nav__field-text-content{padding:1.5rem;height:100%;border-left:1px solid #d7d7d9;position:relative;color:#373741;font-size:1rem}.ajbl-mega-nav .ajbl-mega-nav__field-text-content h4,.ajbl-mega-nav .ajbl-mega-nav__field-text-content .h4,nav.ajbl-mega-nav .ajbl-mega-nav__field-text-content h4,nav.ajbl-mega-nav .ajbl-mega-nav__field-text-content .h4{margin-bottom:1.5rem}.ajbl-mega-nav .ajbl-mega-nav__field-text-content p,.ajbl-mega-nav .ajbl-mega-nav__field-text-content .p,nav.ajbl-mega-nav .ajbl-mega-nav__field-text-content p,nav.ajbl-mega-nav .ajbl-mega-nav__field-text-content .p{font-variation-settings:normal;font-weight:500;line-height:1.5rem}.ajbl-mega-nav .ajbl-mega-nav__field-text-content:after,nav.ajbl-mega-nav .ajbl-mega-nav__field-text-content:after{content:"";position:absolute;top:0;left:0;height:3px;width:400%;background-color:#d50032}.ajbl-mega-nav .desktop-nav,nav.ajbl-mega-nav .desktop-nav{display:none}@media (min-width: 1180px){.ajbl-mega-nav .desktop-nav,nav.ajbl-mega-nav .desktop-nav{display:inline}}@media (max-width: 1180px){.ajbl-mega-nav .desktop-sub-nav,.ajbl-mega-nav .desktop-search-sub-nav,nav.ajbl-mega-nav .desktop-sub-nav,nav.ajbl-mega-nav .desktop-search-sub-nav{display:none}}.ajbl-mega-nav .mobile-sub-nav,nav.ajbl-mega-nav .mobile-sub-nav{transition-duration:0s;position:relative}.ajbl-mega-nav .mobile-sub-nav .nav-item,nav.ajbl-mega-nav .mobile-sub-nav .nav-item{border-right:none;border-left:none;border-top-width:0}.ajbl-mega-nav .mobile-sub-nav .nav-item:first-child,nav.ajbl-mega-nav .mobile-sub-nav .nav-item:first-child{border-top-width:0px;padding-bottom:.5rem}.ajbl-mega-nav .mobile-sub-nav .nav-item:last-child,nav.ajbl-mega-nav .mobile-sub-nav .nav-item:last-child{border-bottom-width:1px}.ajbl-mega-nav .mobile-sub-nav .ajbl-login-btn svg,nav.ajbl-mega-nav .mobile-sub-nav .ajbl-login-btn svg{width:13px;height:13px;margin-right:10px}@media (min-width: 1180px){.ajbl-mega-nav .mobile-sub-nav,nav.ajbl-mega-nav .mobile-sub-nav{display:none}}.ajbl-mega-nav .desktop-search-sub-nav_search-input,nav.ajbl-mega-nav .desktop-search-sub-nav_search-input{font-size:2rem;border-bottom:2px solid #000000;width:100%;padding-left:50px;box-sizing:border-box}.ajbl-mega-nav .desktop-search-sub-nav_search-input:focus,nav.ajbl-mega-nav .desktop-search-sub-nav_search-input:focus{border-color:#000}.ajbl-mega-nav .desktop-search-sub-nav_search-btn svg,nav.ajbl-mega-nav .desktop-search-sub-nav_search-btn svg{width:15px;height:15px;margin-right:5px}.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container{position:relative;margin-top:15px}.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container input,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container input{color:#373741}@media (max-width: 1180px){.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container input,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container input{font-size:1.125rem;padding:.5rem 2rem .5rem 2.5rem;border:2px solid #ffffff;border-bottom-color:#000;transition-duration:0s;color:#373741}.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container input:focus,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container input:focus{border:2px solid #000000;border-radius:3rem}.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container svg,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level-search-input-container svg{width:20px;height:20px;top:12px;left:10px}}.ajbl-mega-nav .desktop-search-sub-nav-search-input-icon,nav.ajbl-mega-nav .desktop-search-sub-nav-search-input-icon{position:absolute;top:3px;left:0;width:30px;height:30px;color:#000}.ajbl-mega-nav .ajbl-mega-nav__mobile-main-menu,nav.ajbl-mega-nav .ajbl-mega-nav__mobile-main-menu{display:inline-block;vertical-align:top}.ajbl-mega-nav .ajbl-mega-nav__mobile-main-menu h4,nav.ajbl-mega-nav .ajbl-mega-nav__mobile-main-menu h4{padding:1rem 1rem .5rem}.ajbl-mega-nav .ajbl-mega-nav__mobile-main-menu .nav-item--tab-variant,nav.ajbl-mega-nav .ajbl-mega-nav__mobile-main-menu .nav-item--tab-variant{padding:1rem .5rem 1rem 1rem}.ajbl-mega-nav .nav-item.mobile-subnav-back,nav.ajbl-mega-nav .nav-item.mobile-subnav-back{margin-left:0;padding-top:1rem;padding-bottom:.5rem;padding-left:1rem}.ajbl-mega-nav .nav-item.mobile-subnav-back:after,nav.ajbl-mega-nav .nav-item.mobile-subnav-back:after{height:1px;opacity:1;display:block;width:80%;background:#000;left:37px;bottom:8px}.ajbl-mega-nav .nav-item.mobile-subnav-back:hover:after,nav.ajbl-mega-nav .nav-item.mobile-subnav-back:hover:after{width:80%;background-color:#d50032}.ajbl-mega-nav .ajbl-mega-nav__account-notifyier-count,nav.ajbl-mega-nav .ajbl-mega-nav__account-notifyier-count{position:absolute;right:-9px;top:-12px;border:1px solid #ffffff;background-color:#d50032;border-radius:100%;font-size:.75rem;width:28px;height:26px;line-height:.75rem;text-align:center;box-sizing:border-box;padding-top:7px;font-weight:700;transform:scale(1);transition:0s;color:#fff}.ajbl-mega-nav .ajbl-mega-nav__account-notifyier-count.in-menu,nav.ajbl-mega-nav .ajbl-mega-nav__account-notifyier-count.in-menu{position:relative;display:inline-block;top:-3px;right:-5px;color:#fff}.ajbl-mega-nav .ajbl-button:hover .ajbl-mega-nav__account-notifyier-count,nav.ajbl-mega-nav .ajbl-button:hover .ajbl-mega-nav__account-notifyier-count{transform:scale(1.1)}.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview{background-color:#f2f2ea;padding:1rem}.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview h4,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview h4{padding-top:0}.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview .select__control,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview .select__control{font-size:1rem;padding:.25rem;line-height:normal;margin-bottom:0}@media (max-width: 1024px){.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview .ajbl-button svg,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level__accounts-overview .ajbl-button svg{float:right;top:5px}}.ajbl-mega-nav .ajbl-mega-nav__sub-level__below-nav,nav.ajbl-mega-nav .ajbl-mega-nav__sub-level__below-nav{padding:0 1rem}.ajbl-mega-nav .ajbl-meganav-header-left-panel,nav.ajbl-mega-nav .ajbl-meganav-header-left-panel{position:relative}.ajbl-mega-nav .mobile-logout-btn,nav.ajbl-mega-nav .mobile-logout-btn{text-align:center}.ajbl-mega-nav .mobile-logout-btn svg,nav.ajbl-mega-nav .mobile-logout-btn svg{width:18px;height:18px;margin:0 5px 0 0;position:relative}.ajbl-mega-nav .mobile-logout-btn:hover,nav.ajbl-mega-nav .mobile-logout-btn:hover{color:#5f5f68}.ajbl-mega-nav.ajbl-drupal-meganav-alignment a.ajbl-button,.ajbl-mega-nav.ajbl-drupal-meganav-alignment button.ajbl-button,.ajbl-mega-nav.ajbl-drupal-meganav-alignment span.ajbl-button,.ajbl-mega-nav.ajbl-drupal-meganav-alignment .nav-item,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment a.ajbl-button,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment button.ajbl-button,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment span.ajbl-button,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .nav-item{font-size:16px;font-variation-settings:normal;font-weight:600;line-height:22px;font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav{top:-7px;position:relative}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav a,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav a{text-decoration:none!important}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item:after,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item:after{height:4px;bottom:-.75rem}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item:hover:after,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item:hover:after{width:0;opacity:0}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item:hover svg,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item:hover svg{top:0}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item--selected:after,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item--selected:after{width:100%;opacity:1}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item--selected:hover:after,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .desktop-nav .nav-item--selected:hover:after{width:100%;opacity:1}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level{padding-bottom:0}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .oxum-grid,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .oxum-grid{height:700px}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col{border-left:1px solid #d7d7d9}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:last-child,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col:last-child{border-right:1px solid #d7d7d9}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col .ajbl-mega-nav__sub-item{border-right:none;border-left:none}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col a.nav-item--selected .sub-nav-title:after,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-mega-nav__sub-level .ajbl-mega-nav__sub-col a.nav-item--selected .sub-nav-title:after{display:none}.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-main-footer__footer-col a,nav.ajbl-mega-nav.ajbl-drupal-meganav-alignment .ajbl-main-footer__footer-col a{text-decoration:none!important}.ajbl-mega-nav a:focus,.ajbl-mega-nav .ajbl-mega-nav__sub-col .nav-item:focus,nav.ajbl-mega-nav a:focus,nav.ajbl-mega-nav .ajbl-mega-nav__sub-col .nav-item:focus{box-shadow:0 0 1px 2px #0b3caa;z-index:10}.ajbl-mega-nav a.nav-item[href="/investment/search/all"],nav.ajbl-mega-nav a.nav-item[href="/investment/search/all"]{display:none}@media (max-width: 1180px){.ajbl-mega-nav a.nav-item[href="/investment/search/all"],nav.ajbl-mega-nav a.nav-item[href="/investment/search/all"]{display:block}}.ajbl-mega-nav a.nav-item[href="/login/terminate"],nav.ajbl-mega-nav a.nav-item[href="/login/terminate"]{display:none}.ajbl-mega-nav .mobile-account-close-btn,nav.ajbl-mega-nav .mobile-account-close-btn{width:100%;text-align:right;border-bottom:1px solid #000000;padding-bottom:15px;margin-bottom:1rem;display:none}@media (max-width: 1180px){.ajbl-mega-nav .mobile-account-close-btn,nav.ajbl-mega-nav .mobile-account-close-btn{display:block}}.ajbl-mega-nav .mobile-account-close-btn:hover,nav.ajbl-mega-nav .mobile-account-close-btn:hover{color:#000}.ajbl-mega-nav .mobile-account-close-btn:hover:after,.ajbl-mega-nav .mobile-account-close-btn:hover:before,nav.ajbl-mega-nav .mobile-account-close-btn:hover:after,nav.ajbl-mega-nav .mobile-account-close-btn:hover:before{display:none}.ajbl-mega-nav .mobile-account-close-btn svg,nav.ajbl-mega-nav .mobile-account-close-btn svg{height:20px;width:20px;margin-left:10px;position:relative;display:inline-block;top:0;vertical-align:middle}.ajbl-mega-nav .ajbl-mega-nav__login-btn svg,.ajbl-mega-nav .ajbl-mega-nav__search-btn svg,.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn svg{position:relative}@media (max-width: 1280px){.ajbl-mega-nav .ajbl-mega-nav__login-btn,.ajbl-mega-nav .ajbl-mega-nav__search-btn,.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn{font-size:.9rem}}.ajbl-mega-nav .ajbl-mega-nav__login-btn svg,.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn svg{transform:scale(1.22)}.ajbl-mega-nav .ajbl-mega-nav__search-btn{padding:.5rem}.ajbl-mega-nav .ajbl-mega-nav__search-btn svg{width:24px;position:relative;left:-1px;margin-top:2px;transform:scale(1.2)}.ajbl-mega-nav .ajbl-mega-nav__login-btn,.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn,.ajbl-mega-nav .ajbl-mega-nav__sub-level-close-btn{margin-right:.5rem}@media (min-width: 640px){.ajbl-mega-nav .ajbl-mega-nav__login-btn,.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn,.ajbl-mega-nav .ajbl-mega-nav__sub-level-close-btn{margin-right:1rem}}.ajbl-mega-nav .ajbl-mega-nav__login-btn svg,.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn svg,.ajbl-mega-nav .ajbl-mega-nav__sub-level-close-btn svg{width:1rem;height:1rem;margin-right:.5rem}.ajbl-mega-nav .ajbl-mega-nav__sub-level-close-btn{border:none;position:absolute;z-index:1;right:.5rem;top:1rem}.ajbl-mega-nav .ajbl-mega-nav__sub-level-close-btn svg{margin-left:.5rem;margin-right:0;position:relative;top:1px}.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn{margin-right:0;white-space:nowrap}@media (max-width: 640px){.ajbl-mega-nav .ajbl-mega-nav__mobile-burger-btn{margin-bottom:.5rem}}.ajbl-mega-nav__top-level--right-menu{position:relative}@media (max-width: 375px){.ajbl-mega-nav__top-level--right-menu{text-align:right}.ajbl-mega-nav__top-level--right-menu .ajbl-mega-nav__login-btn{margin-bottom:.5rem}}@media (max-width: 640px){.ajbl-mega-nav__top-level--right-menu{display:flex}.ajbl-mega-nav__top-level--right-menu .ajbl-mega-nav__login-btn{white-space:nowrap;padding:.5rem .75rem 6px;margin-bottom:.5rem}.ajbl-mega-nav__top-level--right-menu .ajbl-mega-nav__login-btn svg{margin:0}}.main-nav-logout{padding:.5rem .7rem 6px;left:-7px;display:inline-block}.main-nav-logout svg{width:18px;height:18px;margin:0;position:relative}.ajbl-main-footer{padding:3rem 2rem 1rem}.ajbl-main-footer .ajbl-main-footer-nav{display:flex;width:100%;justify-content:center;align-items:flex-start;box-sizing:border-box;gap:1.5rem}.ajbl-main-footer .ajbl-main-footer-nav .footer-accordian-btn{background-color:transparent;border:none;width:100%;text-align:left;padding:0;line-height:1.9rem}.ajbl-main-footer .ajbl-main-footer-nav .footer-accordian-btn svg{width:25px}@media (max-width: 1180px){.ajbl-main-footer .ajbl-main-footer-nav .footer-accordian-btn{font-size:16px}}@media (min-width: 1180px){.ajbl-main-footer .ajbl-main-footer-nav .footer-accordian-btn svg{display:none}}@media (max-width: 1180px){.ajbl-main-footer .ajbl-main-footer-nav{display:block;padding:1rem 1rem 1rem 0;border-radius:.5rem}.ajbl-main-footer .ajbl-main-footer-nav h4{font-size:1rem;font-weight:700;padding-bottom:1rem;margin:0;color:#373741}}.ajbl-main-footer .ajbl-main-footer__footer-col{display:block;width:25%}@media (max-width: 1180px){.ajbl-main-footer .ajbl-main-footer__footer-col{width:100%;padding:1rem 1rem 0;border-radius:.5rem;border:1px solid #d7d7d9;margin-bottom:.5rem}}.ajbl-main-footer .ajbl-main-footer__footer-col .nav-item{border-right-width:0;border-left-width:0;border-top-width:0;padding:1rem;font-weight:700}.ajbl-main-footer .ajbl-main-footer__footer-col .nav-item:hover{color:#373741;background-color:#fff}@media (max-width: 1180px){.ajbl-main-footer .ajbl-main-footer__footer-col .nav-item{padding-left:0;display:none}.ajbl-main-footer .ajbl-main-footer__footer-col .nav-item:last-child{border-bottom:0}.ajbl-main-footer .ajbl-main-footer__footer-col.active .nav-item{padding-left:0;display:block}}.ajbl-main-footer .footer-legal-copy{font-size:1rem;line-height:1.5rem;font-weight:500}.ajbl-main-footer .footer-social-links{display:inline-block}.ajbl-main-footer .footer-social-links:hover svg,.ajbl-main-footer .footer-social-links:hover img{opacity:.7}.ajbl-main-footer .footer-social-links img,.ajbl-main-footer .footer-social-links svg{transition:.15s;position:relative}.ajbl-main-footer .footer-social-links svg{height:1.5rem;top:-5px}.ajbl-screener{font-family:Museo Sans,Adjusted Arial Fallback,Arial,Helvetica,sans-serif}@media (min-width: 768px){.ajbl-screener .ajbl-screener_bottom-options{border-top:1px solid #d9d9d9;margin-top:24px;padding-top:24px}}.ajbl-screener .ajbl-screener-fund-input-wrapper{position:relative;color:#000}.ajbl-screener .ajbl-screener-fund-input-wrapper .ajbl-screener__icon{position:absolute;top:51%;left:20px;transform:translateY(-50%);width:16px;height:16px;z-index:1}.ajbl-screener .ajbl-screener-fund-input-wrapper .ajbl-screener__fund-name-input{display:block;border:1px solid #d9d9d9;padding:16px 16px 16px 50px;border-radius:16px;width:100%;margin-bottom:24px;transition-duration:.15s;box-sizing:border-box;background-color:#fff;height:auto}.ajbl-screener .ajbl-screener-fund-input-wrapper .ajbl-screener__fund-name-input:hover,.ajbl-screener .ajbl-screener-fund-input-wrapper .ajbl-screener__fund-name-input:focus,.ajbl-screener .ajbl-screener-fund-input-wrapper .ajbl-screener__fund-name-input:active{border:1px solid #000000}.ajbl-screener .ajbl-screener__clear-button{font-size:1rem;line-height:1.5rem;text-decoration-line:underline;padding:0;transition-duration:.15s;color:#373741;border:none}.ajbl-screener .ajbl-screener__clear-button .ajbl-checkselect__option{color:#373741}.ajbl-screener .ajbl-screener__clear-button:hover{background-color:transparent;color:#000;opacity:.5}.ajbl-screener .ajbl-screener__clear-button:focus{background-color:transparent}.ajbl-screener button.ajbl-screener__advanced-filter{display:inline;background-color:transparent;border-color:#000;color:#000;margin-right:1rem}.ajbl-screener button.ajbl-screener__advanced-filter:focus{color:#373741;text-decoration:underline!important}.ajbl-screener button.ajbl-screener__advanced-filter.hidden{display:none}.ajbl-screener button.ajbl-screener__advanced-filter:hover{background-color:#000;color:#fff;text-decoration:underline!important}@media (min-width: 768px){.ajbl-screener button.ajbl-screener__advanced-filter{font-size:1rem;color:#373741;line-height:1.5rem;text-decoration-line:underline;padding:0;border:none;transition-duration:.15s}.ajbl-screener button.ajbl-screener__advanced-filter .ajbl-checkselect__option{color:#373741}.ajbl-screener button.ajbl-screener__advanced-filter:hover{background-color:transparent;color:#000;opacity:.5}}@media (max-width: 768px){.ajbl-screener button.ajbl-screener__advanced-filter{margin-bottom:24px;width:100%;margin-left:0;margin-right:0}.ajbl-screener .ajbl-screener__search-button{width:100%;margin-bottom:24px;margin-left:0;margin-right:0}}.ajbl-screener .ajbl-screener_filters-wrapper{margin-bottom:24px}.ajbl-screener .is-advanced{display:none}.ajbl-screener.is-advanced-active .is-advanced{display:block}.ajbl-screener .ajbl-screener-loader-rect-0.ajbl-Loadingshimmer span{height:30px;overflow:hidden}.ajbl-screener .screen-type-switcher:after{content:"";border-bottom:1px solid #d7d7d9;position:relative;width:calc(100% - 13px);left:7px;bottom:-15px;display:block}.ajbl-screener .screen-type-switcher:after:focus{background-color:transparent}.ajbl-screener .screen-type-switcher .nav-item{border:none}.ajbl-screener .screen-type-switcher .nav-item:after{bottom:-17px;border-radius:100px;z-index:1;transform:none;left:0;padding:0;margin:0}@media (max-width: 640px){.ajbl-screener .screen-type-switcher .nav-item:after{display:none}}.ajbl-screener .screen-type-switcher .nav-item:before{display:none}.ajbl-screener .screen-type-switcher .nav-item:focus{border-color:transparent;background-color:transparent}.ajbl-screener .screen-type-switcher .nav-item [aria-label]:not([data-balloon-pos]):after{left:0;margin-bottom:0;transform:none}.ajbl-screener .ajbl-screener__search-autocomplete-container{position:absolute;background-color:#fff;width:100%;display:block;border:1px solid #d7d7d9;z-index:2;top:45px;left:0;border-bottom-left-radius:1rem;border-bottom-right-radius:1rem;overflow:hidden}.ajbl-screener .ajbl-screener__search-autocomplete-container li{transition-duration:.15s;cursor:pointer}.ajbl-screener .ajbl-screener__search-autocomplete-container li .ajbl-screener__search-autocomplete-item{padding:1rem 1rem 0;display:block}.ajbl-screener .ajbl-screener__search-autocomplete-container li .nav-item{font-size:.85rem}.ajbl-screener .ajbl-screener__search-autocomplete-container li .nav-item:after{display:none}.ajbl-screener .ajbl-screener__search-autocomplete-container li .nav-item svg{color:#d50032;opacity:0}.ajbl-screener .ajbl-screener__search-autocomplete-container li span{position:relative;display:inline-block}.ajbl-screener .ajbl-screener__search-autocomplete-container li span:after{content:"";border-bottom:2px solid #000000;display:block;position:relative;width:0%;left:0;bottom:-2px;transition-duration:.15s}.ajbl-screener .ajbl-screener__search-autocomplete-container li:hover span:after{width:100%}.ajbl-screener .ajbl-screener__search-autocomplete-container li:hover .nav-item{color:#d50032}.ajbl-screener .ajbl-screener__search-autocomplete-container li:hover .nav-item svg{opacity:1;left:2px}.ajbl-screener .ajbl-screener__search-autocomplete-container li:last-child .ajbl-screener__search-autocomplete-item{padding:1rem}')),document.head.appendChild(a)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsx as v, jsxs as D, Fragment as Ke } from "react/jsx-runtime";
import he from "classnames";
import { FontAwesomeIcon as ce } from "@fortawesome/react-fontawesome";
import * as V from "react";
import { useState as te, useCallback as Ce, forwardRef as Ia, useContext as dn, useLayoutEffect as Pl, useRef as Ue, createContext as Jn, useMemo as De, Component as kl, Fragment as On, useEffect as ne, useReducer as Ca } from "react";
import { createPortal as Rl } from "react-dom";
const En = ({
  className: t
}) => /* @__PURE__ */ v(
  "div",
  {
    className: he("ajbl-Loadingshimmer", t),
    "data-testid": "loadingshimmer",
    children: /* @__PURE__ */ v("span", {})
  }
), Dl = {
  prefix: "fass",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M112 48L16 48l0 96 96 0 0-96zm80 16l-32 0 0 64 32 0 288 0 32 0 0-64-32 0L192 64zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zm0 160l-32 0 0 64 32 0 288 0 32 0 0-64-32 0-288 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z"]
}, Aa = {
  prefix: "fass",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M256 82.7l22.6 22.6 192 192L493.3 320 448 365.3l-22.6-22.6L256 173.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 192-192L256 82.7z"]
}, Hl = {
  prefix: "fass",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M320 0L288 0l0 64 32 0 82.7 0L201.4 265.4 178.7 288 224 333.3l22.6-22.6L448 109.3l0 82.7 0 32 64 0 0-32 0-160 0-32L480 0 320 0zM32 32L0 32 0 64 0 480l0 32 32 0 424 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448 64 96l96 0 32 0 0-64-32 0L32 32z"]
}, Ea = {
  prefix: "fass",
  iconName: "lock-open",
  icon: [576, 512, [], "f3c1", "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 0 32 64 0 0-32 0-48C576 64.5 511.5 0 432 0S288 64.5 288 144l0 48L0 192 0 512l448 0 0-320-96 0 0-48z"]
}, Ul = {
  prefix: "fass",
  iconName: "minus",
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 288l-32 0L48 288l-32 0 0-64 32 0 352 0 32 0 0 64z"]
}, Bt = {
  prefix: "fass",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, Ta = {
  prefix: "fass",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M256 429.3l22.6-22.6 192-192L493.3 192 448 146.7l-22.6 22.6L256 338.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 192 192L256 429.3z"]
}, Vl = {
  prefix: "fass",
  iconName: "circle-user",
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M391.9 391.6L368 320l-224 0-23.9 71.6C154.9 426.5 202.9 448 256 448s101.1-21.5 135.9-56.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
}, Wl = {
  prefix: "fass",
  iconName: "plus",
  icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80l0-32-64 0 0 32 0 144L48 224l-32 0 0 64 32 0 144 0 0 144 0 32 64 0 0-32 0-144 144 0 32 0 0-64-32 0-144 0 0-144z"]
}, Sa = {
  prefix: "fass",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z"]
}, ya = {
  prefix: "fass",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z"]
};
function _t(t) {
  if (t === void 0 || ["string", "number", "boolean", "undefined"].includes(typeof t))
    return !1;
  if (typeof t == "object" && t !== null) {
    for (const e in t)
      if (!(e in t) || typeof t[e] != typeof t[e])
        return !1;
    return !0;
  }
  return !1;
}
const Yn = ({
  data: t,
  basketCount: e,
  secureMessageCount: i
}) => {
  const a = [];
  for (const n in t) {
    const l = t[n], r = l.length - 1, c = l[r], s = l[0].name, u = c.type === 1 ? "primaryUser" : "secondaryUser", d = l.map(
      (p) => ({
        serviceName: p.productName,
        productType: p.productType,
        cashValuation: p.cashValuation,
        totalValuation: p.totalValuation,
        currencySymbol: p.currencySymbol,
        accountNumber: p.number
      })
    ), C = {
      accountID: n,
      basketCount: e,
      secureMessageCount: i,
      fullName: s,
      services: d,
      userType: u
    };
    a.push(C);
  }
  return a;
}, wa = /* @__PURE__ */ function() {
  const t = /* @__PURE__ */ new WeakMap();
  return function e(i, a) {
    if (i === a)
      return i !== 0 || 1 / i === 1 / a;
    if (typeof i == "number" && typeof a == "number" && isNaN(i) && isNaN(a))
      return !0;
    if (i == null || a == null)
      return i === a;
    if (i instanceof Date && a instanceof Date)
      return i.getTime() === a.getTime();
    if (i instanceof RegExp && a instanceof RegExp)
      return i.toString() === a.toString();
    if (Array.isArray(i) && Array.isArray(a)) {
      if (i.length !== a.length) return !1;
      for (let n = 0; n < i.length; n++)
        if (!e(i[n], a[n])) return !1;
      return !0;
    }
    if (i instanceof Map && a instanceof Map) {
      if (i.size !== a.size) return !1;
      for (const [n, l] of i)
        if (!a.has(n) || !e(l, a.get(n)))
          return !1;
      return !0;
    }
    if (i instanceof Set && a instanceof Set) {
      if (i.size !== a.size) return !1;
      for (const n of i)
        if (!a.has(n))
          return !1;
      return !0;
    }
    if (i && a && typeof i == "object" && typeof a == "object" && !Array.isArray(i) && !Array.isArray(a)) {
      if (t.get(i) === a) return !0;
      t.set(i, a);
      const n = Object.keys(i), l = Object.keys(a);
      if (n.length !== l.length) return !1;
      for (const r of n)
        if (!l.includes(r) || // eslint-disable-next-line
        !e(i[r], a[r]))
          return !1;
      return !0;
    }
    return !1;
  };
}(), Xl = (t) => typeof t != "number" ? "" : t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), Gi = (t) => {
  const e = t ?? "", i = [
    `${e} a[href]`,
    `${e} button:not([disabled])`,
    `${e} textarea:not([disabled])`,
    `${e} input:not([disabled]):not([type="hidden"])`,
    `${e} input[type="hidden"][tabindex]:not([disabled])`,
    `${e} select:not([disabled])`,
    `${e} [tabindex]:not([tabindex="-1"])`
  ];
  return Array.from(
    document.querySelectorAll(i.join(","))
  );
}, Fe = {
  Next: ({ keyboardNavRestrictionContainer: t }) => {
    const e = Gi(
      t
    );
    if (e.length === 0) {
      console.warn("No focusable elements found.");
      return;
    }
    const a = (e.indexOf(
      document.activeElement
    ) + 1) % e.length;
    e[a].focus();
  },
  Prev: ({ keyboardNavRestrictionContainer: t }) => {
    const e = Gi(
      t
    );
    if (e.length === 0) {
      console.warn("No focusable elements found.");
      return;
    }
    const a = (e.indexOf(
      document.activeElement
    ) - 1 + e.length) % e.length;
    e[a].focus();
  }
}, Mi = {
  left: Sa,
  right: ya,
  up: Aa,
  down: Ta,
  external: Hl
}, qe = ({
  children: t,
  label: e,
  className: i,
  href: a,
  chevron: n,
  chevronSide: l,
  onBlur: r,
  onClick: c,
  onFocus: o,
  onHover: s,
  role: u,
  isSelected: d,
  isDumb: C,
  ariaLabel: p,
  ariaExpanded: b,
  ariaControls: f,
  ariaOwns: g,
  variant: h,
  noAnimation: S,
  onKeyTab: E,
  onKeyCodeLeft: A,
  onKeyCodeRight: I,
  onKeyCodeUp: w,
  onKeyCodeDown: T,
  onKeyEnter: x,
  onKeyEscape: O,
  onKeyDown: W,
  keyboardNavRestrictionContainer: M,
  LinkComponent: L
}) => {
  const H = d ? "nav-item--selected" : null, K = h ? `nav-item--${h}-variant` : "nav-item--default-variant", k = [
    "nav-item",
    n ? n === "external" ? "nav-item--external" : `nav-item--${n}` : null,
    K,
    H,
    i,
    { "no-animation": S }
  ], oe = (Y) => {
    if (W) {
      W(Y);
      return;
    }
    switch (Y.code) {
      case "ArrowLeft":
        Y.preventDefault(), A ? A(Y) : Fe.Prev({ keyboardNavRestrictionContainer: M });
        break;
      case "ArrowRight":
        Y.preventDefault(), I ? I(Y) : Fe.Next({ keyboardNavRestrictionContainer: M });
        break;
      case "ArrowUp":
        Y.preventDefault(), w ? w(Y) : Fe.Prev({ keyboardNavRestrictionContainer: M });
        break;
      case "ArrowDown":
        Y.preventDefault(), T ? T(Y) : Fe.Next({ keyboardNavRestrictionContainer: M });
        break;
      case "Enter":
      case "Space":
        x?.(Y);
        break;
      case "Escape":
        Y.preventDefault(), O?.(Y);
        break;
      case "Tab":
        E?.(Y);
        break;
    }
  }, re = () => {
    c && c();
  }, fe = () => {
    r && r();
  }, ie = () => {
    o && o();
  }, X = () => {
    s && s();
  }, j = n === "external" ? "arrow-up-right-from-square" : `chevron-${n}`, U = /* @__PURE__ */ D(Ke, { children: [
    (l === "left" || l === "both") && n && /* @__PURE__ */ v(
      ce,
      {
        "data-testid": "font-awesome-icon",
        className: "nav-item__left-icon",
        icon: Mi[n]
      }
    ),
    e,
    " ",
    t,
    (l === "right" || l === "both") && n && /* @__PURE__ */ v(
      ce,
      {
        "data-testid": "font-awesome-icon",
        className: "nav-item__right-icon",
        icon: Mi[n]
      }
    )
  ] });
  return C ? /* @__PURE__ */ v(
    "span",
    {
      onBlur: fe,
      onFocus: ie,
      onMouseOver: X,
      onKeyDown: oe,
      tabIndex: 0,
      role: u,
      className: he(k),
      "aria-expanded": b,
      "aria-owns": g,
      "aria-controls": f,
      "data-testid": `nav-item-component-span-icon-${j}`,
      children: U
    }
  ) : L && a ? /* @__PURE__ */ v(
    L,
    {
      ...{ href: a, to: a },
      onBlur: fe,
      onFocus: ie,
      onMouseOver: X,
      onKeyDown: oe,
      tabIndex: 0,
      role: u,
      className: he(k),
      "aria-expanded": b,
      "aria-owns": g,
      "aria-controls": f,
      "data-testid": `nav-item-component-link-icon-${j}`,
      children: U
    }
  ) : a ? /* @__PURE__ */ v(
    "a",
    {
      href: a,
      onBlur: fe,
      onFocus: ie,
      onMouseOver: X,
      onKeyDown: oe,
      tabIndex: 0,
      role: u,
      className: he(k),
      "aria-expanded": b,
      "aria-owns": g,
      "aria-controls": f,
      "data-testid": `nav-item-component-link-icon-${j}`,
      children: U
    }
  ) : /* @__PURE__ */ v(
    "button",
    {
      onClick: re,
      onBlur: fe,
      onFocus: ie,
      role: u,
      onMouseOver: X,
      onKeyDown: oe,
      className: he(k),
      "aria-label": p,
      "aria-expanded": b,
      "aria-owns": g,
      "aria-controls": f,
      "data-testid": `nav-item-component-button-icon-${j}`,
      children: U
    }
  );
}, Bi = {
  left: Sa,
  right: ya,
  up: Aa,
  down: Ta
}, Ve = ({
  children: t,
  label: e,
  className: i,
  chevron: a,
  chevronSide: n,
  href: l,
  onBlur: r = () => {
  },
  onClick: c = () => {
  },
  onFocus: o = () => {
  },
  isSelected: s,
  ariaLabel: u,
  theme: d = "default",
  noAnimation: C,
  onKeyTab: p,
  onKeyCodeLeft: b,
  onKeyCodeRight: f,
  onKeyCodeUp: g,
  onKeyCodeDown: h,
  onKeyEnter: S,
  onKeyEscape: E,
  onKeyDown: A,
  role: I,
  keyboardNavRestrictionContainer: w,
  // New prop for polymorphic link usage
  LinkComponent: T
}) => {
  const O = {
    dark: "ajbl-button--dark",
    light: "ajbl-button--light",
    default: "ajbl-button--default"
  }[d], W = s ? "ajbl-button--selected" : "", M = !t && !e ? "ajbl-button--no-children" : "", L = a ? `ajbl-button--${a}` : "", H = (k) => {
    if (A) {
      A(k);
      return;
    }
    switch (k.code) {
      case "ArrowLeft":
        k.preventDefault(), b ? b(k) : Fe.Prev({ keyboardNavRestrictionContainer: w });
        break;
      case "ArrowRight":
        k.preventDefault(), f ? f(k) : Fe.Next({ keyboardNavRestrictionContainer: w });
        break;
      case "ArrowUp":
        k.preventDefault(), g ? g(k) : Fe.Prev({ keyboardNavRestrictionContainer: w });
        break;
      case "ArrowDown":
        k.preventDefault(), h ? h(k) : Fe.Next({ keyboardNavRestrictionContainer: w });
        break;
      case "Enter":
      case "Space":
        S?.(k);
        break;
      case "Escape":
        k.preventDefault(), E?.(k);
        break;
      case "Tab":
        p?.(k);
        break;
    }
  }, K = he(
    "ajbl-button",
    L,
    M,
    O,
    W,
    i,
    { "no-animation": C }
  ), z = /* @__PURE__ */ D(Ke, { children: [
    (n === "left" || n === "both") && a && /* @__PURE__ */ v(
      ce,
      {
        "data-testid": "left-chevron",
        className: "ajbl-button__left-icon",
        icon: Bi[a]
      }
    ),
    e,
    " ",
    t,
    (n === "right" || n === "both") && a && /* @__PURE__ */ v(
      ce,
      {
        "data-testid": "right-chevron",
        className: "ajbl-button__right-icon",
        icon: Bi[a]
      }
    )
  ] });
  return l ? l && T ? /* @__PURE__ */ v(
    T,
    {
      ...{ href: l, to: l },
      onBlur: r,
      "data-testid": "button-link-component",
      onFocus: o,
      role: I,
      onKeyDown: H,
      tabIndex: 0,
      className: K,
      "aria-label": u || e,
      children: z
    }
  ) : /* @__PURE__ */ v(
    "a",
    {
      href: l,
      onBlur: r,
      "data-testid": "button-link-component",
      onFocus: o,
      role: I,
      onKeyDown: H,
      tabIndex: 0,
      className: K,
      "aria-label": u || e,
      children: z
    }
  ) : /* @__PURE__ */ v(
    "button",
    {
      onClick: c,
      "data-testid": "button-component",
      onBlur: r,
      role: I,
      onFocus: o,
      onKeyDown: H,
      tabIndex: 0,
      className: K,
      "aria-label": u || e,
      children: z
    }
  );
}, _i = ({ children: t, className: e, section: i }) => i ? /* @__PURE__ */ v("section", { className: he("ajbl-content-card", e), children: t }) : /* @__PURE__ */ v("div", { className: he("ajbl-content-card", e), children: t });
function ct(t) {
  "@babel/helpers - typeof";
  return ct = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ct(t);
}
function Zl(t, e) {
  if (ct(t) != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var a = i.call(t, e || "default");
    if (ct(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function xa(t) {
  var e = Zl(t, "string");
  return ct(e) == "symbol" ? e : e + "";
}
function Mt(t, e, i) {
  return (e = xa(e)) in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function Li(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), i.push.apply(i, a);
  }
  return i;
}
function F(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Li(Object(i), !0).forEach(function(a) {
      Mt(t, a, i[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : Li(Object(i)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(i, a));
    });
  }
  return t;
}
function zl(t) {
  if (Array.isArray(t)) return t;
}
function Jl(t, e) {
  var i = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (i != null) {
    var a, n, l, r, c = [], o = !0, s = !1;
    try {
      if (l = (i = i.call(t)).next, e === 0) {
        if (Object(i) !== i) return;
        o = !1;
      } else for (; !(o = (a = l.call(i)).done) && (c.push(a.value), c.length !== e); o = !0) ;
    } catch (u) {
      s = !0, n = u;
    } finally {
      try {
        if (!o && i.return != null && (r = i.return(), Object(r) !== r)) return;
      } finally {
        if (s) throw n;
      }
    }
    return c;
  }
}
function Pn(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var i = 0, a = Array(e); i < e; i++) a[i] = t[i];
  return a;
}
function Ga(t, e) {
  if (t) {
    if (typeof t == "string") return Pn(t, e);
    var i = {}.toString.call(t).slice(8, -1);
    return i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set" ? Array.from(t) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Pn(t, e) : void 0;
  }
}
function Yl() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function et(t, e) {
  return zl(t) || Jl(t, e) || Ga(t, e) || Yl();
}
function jl(t, e) {
  if (t == null) return {};
  var i = {};
  for (var a in t) if ({}.hasOwnProperty.call(t, a)) {
    if (e.includes(a)) continue;
    i[a] = t[a];
  }
  return i;
}
function nt(t, e) {
  if (t == null) return {};
  var i, a, n = jl(t, e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(t);
    for (a = 0; a < l.length; a++) i = l[a], e.includes(i) || {}.propertyIsEnumerable.call(t, i) && (n[i] = t[i]);
  }
  return n;
}
var $l = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Ql(t) {
  var e = t.defaultInputValue, i = e === void 0 ? "" : e, a = t.defaultMenuIsOpen, n = a === void 0 ? !1 : a, l = t.defaultValue, r = l === void 0 ? null : l, c = t.inputValue, o = t.menuIsOpen, s = t.onChange, u = t.onInputChange, d = t.onMenuClose, C = t.onMenuOpen, p = t.value, b = nt(t, $l), f = te(c !== void 0 ? c : i), g = et(f, 2), h = g[0], S = g[1], E = te(o !== void 0 ? o : n), A = et(E, 2), I = A[0], w = A[1], T = te(p !== void 0 ? p : r), x = et(T, 2), O = x[0], W = x[1], M = Ce(function(re, fe) {
    typeof s == "function" && s(re, fe), W(re);
  }, [s]), L = Ce(function(re, fe) {
    var ie;
    typeof u == "function" && (ie = u(re, fe)), S(ie !== void 0 ? ie : re);
  }, [u]), H = Ce(function() {
    typeof C == "function" && C(), w(!0);
  }, [C]), K = Ce(function() {
    typeof d == "function" && d(), w(!1);
  }, [d]), z = c !== void 0 ? c : h, k = o !== void 0 ? o : I, oe = p !== void 0 ? p : O;
  return F(F({}, b), {}, {
    inputValue: z,
    menuIsOpen: k,
    onChange: M,
    onInputChange: L,
    onMenuClose: K,
    onMenuOpen: H,
    value: oe
  });
}
function P() {
  return P = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var a in i) ({}).hasOwnProperty.call(i, a) && (t[a] = i[a]);
    }
    return t;
  }, P.apply(null, arguments);
}
function Kl(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Ni(t, e) {
  for (var i = 0; i < e.length; i++) {
    var a = e[i];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, xa(a.key), a);
  }
}
function ql(t, e, i) {
  return e && Ni(t.prototype, e), i && Ni(t, i), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function kn(t, e) {
  return kn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, a) {
    return i.__proto__ = a, i;
  }, kn(t, e);
}
function eo(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && kn(t, e);
}
function tn(t) {
  return tn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, tn(t);
}
function Ma() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ma = function() {
    return !!t;
  })();
}
function to(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function no(t, e) {
  if (e && (ct(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return to(t);
}
function io(t) {
  var e = Ma();
  return function() {
    var i, a = tn(t);
    if (e) {
      var n = tn(this).constructor;
      i = Reflect.construct(a, arguments, n);
    } else i = a.apply(this, arguments);
    return no(this, i);
  };
}
function ao(t) {
  if (Array.isArray(t)) return Pn(t);
}
function lo(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function oo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jn(t) {
  return ao(t) || lo(t) || Ga(t) || oo();
}
var ro = !1;
function so(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function co(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var uo = /* @__PURE__ */ function() {
  function t(i) {
    var a = this;
    this._insertTag = function(n) {
      var l;
      a.tags.length === 0 ? a.insertionPoint ? l = a.insertionPoint.nextSibling : a.prepend ? l = a.container.firstChild : l = a.before : l = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(n, l), a.tags.push(n);
    }, this.isSpeedy = i.speedy === void 0 ? !ro : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, e.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(co(this));
    var n = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var l = so(n);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch {
      }
    } else
      n.appendChild(document.createTextNode(a));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(a) {
      var n;
      return (n = a.parentNode) == null ? void 0 : n.removeChild(a);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), Te = "-ms-", nn = "-moz-", $ = "-webkit-", Ba = "comm", $n = "rule", Qn = "decl", mo = "@import", _a = "@keyframes", fo = "@layer", po = Math.abs, mn = String.fromCharCode, go = Object.assign;
function ho(t, e) {
  return Ie(t, 0) ^ 45 ? (((e << 2 ^ Ie(t, 0)) << 2 ^ Ie(t, 1)) << 2 ^ Ie(t, 2)) << 2 ^ Ie(t, 3) : 0;
}
function La(t) {
  return t.trim();
}
function bo(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function Q(t, e, i) {
  return t.replace(e, i);
}
function Rn(t, e) {
  return t.indexOf(e);
}
function Ie(t, e) {
  return t.charCodeAt(e) | 0;
}
function Lt(t, e, i) {
  return t.slice(e, i);
}
function Ze(t) {
  return t.length;
}
function Kn(t) {
  return t.length;
}
function Vt(t, e) {
  return e.push(t), t;
}
function vo(t, e) {
  return t.map(e).join("");
}
var fn = 1, ht = 1, Na = 0, Me = 0, me = 0, bt = "";
function pn(t, e, i, a, n, l, r) {
  return { value: t, root: e, parent: i, type: a, props: n, children: l, line: fn, column: ht, length: r, return: "" };
}
function Et(t, e) {
  return go(pn("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function Io() {
  return me;
}
function Co() {
  return me = Me > 0 ? Ie(bt, --Me) : 0, ht--, me === 10 && (ht = 1, fn--), me;
}
function Be() {
  return me = Me < Na ? Ie(bt, Me++) : 0, ht++, me === 10 && (ht = 1, fn++), me;
}
function Je() {
  return Ie(bt, Me);
}
function $t() {
  return Me;
}
function Pt(t, e) {
  return Lt(bt, t, e);
}
function Nt(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Fa(t) {
  return fn = ht = 1, Na = Ze(bt = t), Me = 0, [];
}
function Oa(t) {
  return bt = "", t;
}
function Qt(t) {
  return La(Pt(Me - 1, Dn(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function Ao(t) {
  for (; (me = Je()) && me < 33; )
    Be();
  return Nt(t) > 2 || Nt(me) > 3 ? "" : " ";
}
function Eo(t, e) {
  for (; --e && Be() && !(me < 48 || me > 102 || me > 57 && me < 65 || me > 70 && me < 97); )
    ;
  return Pt(t, $t() + (e < 6 && Je() == 32 && Be() == 32));
}
function Dn(t) {
  for (; Be(); )
    switch (me) {
      case t:
        return Me;
      case 34:
      case 39:
        t !== 34 && t !== 39 && Dn(me);
        break;
      case 40:
        t === 41 && Dn(t);
        break;
      case 92:
        Be();
        break;
    }
  return Me;
}
function To(t, e) {
  for (; Be() && t + me !== 57; )
    if (t + me === 84 && Je() === 47)
      break;
  return "/*" + Pt(e, Me - 1) + "*" + mn(t === 47 ? t : Be());
}
function So(t) {
  for (; !Nt(Je()); )
    Be();
  return Pt(t, Me);
}
function yo(t) {
  return Oa(Kt("", null, null, null, [""], t = Fa(t), 0, [0], t));
}
function Kt(t, e, i, a, n, l, r, c, o) {
  for (var s = 0, u = 0, d = r, C = 0, p = 0, b = 0, f = 1, g = 1, h = 1, S = 0, E = "", A = n, I = l, w = a, T = E; g; )
    switch (b = S, S = Be()) {
      case 40:
        if (b != 108 && Ie(T, d - 1) == 58) {
          Rn(T += Q(Qt(S), "&", "&\f"), "&\f") != -1 && (h = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        T += Qt(S);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        T += Ao(b);
        break;
      case 92:
        T += Eo($t() - 1, 7);
        continue;
      case 47:
        switch (Je()) {
          case 42:
          case 47:
            Vt(wo(To(Be(), $t()), e, i), o);
            break;
          default:
            T += "/";
        }
        break;
      case 123 * f:
        c[s++] = Ze(T) * h;
      case 125 * f:
      case 59:
      case 0:
        switch (S) {
          case 0:
          case 125:
            g = 0;
          case 59 + u:
            h == -1 && (T = Q(T, /\f/g, "")), p > 0 && Ze(T) - d && Vt(p > 32 ? Oi(T + ";", a, i, d - 1) : Oi(Q(T, " ", "") + ";", a, i, d - 2), o);
            break;
          case 59:
            T += ";";
          default:
            if (Vt(w = Fi(T, e, i, s, u, n, c, E, A = [], I = [], d), l), S === 123)
              if (u === 0)
                Kt(T, e, w, w, A, l, d, c, I);
              else
                switch (C === 99 && Ie(T, 3) === 110 ? 100 : C) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Kt(t, w, w, a && Vt(Fi(t, w, w, 0, 0, n, c, E, n, A = [], d), I), n, I, d, c, a ? A : I);
                    break;
                  default:
                    Kt(T, w, w, w, [""], I, 0, c, I);
                }
        }
        s = u = p = 0, f = h = 1, E = T = "", d = r;
        break;
      case 58:
        d = 1 + Ze(T), p = b;
      default:
        if (f < 1) {
          if (S == 123)
            --f;
          else if (S == 125 && f++ == 0 && Co() == 125)
            continue;
        }
        switch (T += mn(S), S * f) {
          case 38:
            h = u > 0 ? 1 : (T += "\f", -1);
            break;
          case 44:
            c[s++] = (Ze(T) - 1) * h, h = 1;
            break;
          case 64:
            Je() === 45 && (T += Qt(Be())), C = Je(), u = d = Ze(E = T += So($t())), S++;
            break;
          case 45:
            b === 45 && Ze(T) == 2 && (f = 0);
        }
    }
  return l;
}
function Fi(t, e, i, a, n, l, r, c, o, s, u) {
  for (var d = n - 1, C = n === 0 ? l : [""], p = Kn(C), b = 0, f = 0, g = 0; b < a; ++b)
    for (var h = 0, S = Lt(t, d + 1, d = po(f = r[b])), E = t; h < p; ++h)
      (E = La(f > 0 ? C[h] + " " + S : Q(S, /&\f/g, C[h]))) && (o[g++] = E);
  return pn(t, e, i, n === 0 ? $n : c, o, s, u);
}
function wo(t, e, i) {
  return pn(t, e, i, Ba, mn(Io()), Lt(t, 2, -2), 0);
}
function Oi(t, e, i, a) {
  return pn(t, e, i, Qn, Lt(t, 0, a), Lt(t, a + 1, -1), a);
}
function gt(t, e) {
  for (var i = "", a = Kn(t), n = 0; n < a; n++)
    i += e(t[n], n, t, e) || "";
  return i;
}
function xo(t, e, i, a) {
  switch (t.type) {
    case fo:
      if (t.children.length) break;
    case mo:
    case Qn:
      return t.return = t.return || t.value;
    case Ba:
      return "";
    case _a:
      return t.return = t.value + "{" + gt(t.children, a) + "}";
    case $n:
      t.value = t.props.join(",");
  }
  return Ze(i = gt(t.children, a)) ? t.return = t.value + "{" + i + "}" : "";
}
function Go(t) {
  var e = Kn(t);
  return function(i, a, n, l) {
    for (var r = "", c = 0; c < e; c++)
      r += t[c](i, a, n, l) || "";
    return r;
  };
}
function Mo(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function Bo(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return e[i] === void 0 && (e[i] = t(i)), e[i];
  };
}
var _o = function(e, i, a) {
  for (var n = 0, l = 0; n = l, l = Je(), n === 38 && l === 12 && (i[a] = 1), !Nt(l); )
    Be();
  return Pt(e, Me);
}, Lo = function(e, i) {
  var a = -1, n = 44;
  do
    switch (Nt(n)) {
      case 0:
        n === 38 && Je() === 12 && (i[a] = 1), e[a] += _o(Me - 1, i, a);
        break;
      case 2:
        e[a] += Qt(n);
        break;
      case 4:
        if (n === 44) {
          e[++a] = Je() === 58 ? "&\f" : "", i[a] = e[a].length;
          break;
        }
      default:
        e[a] += mn(n);
    }
  while (n = Be());
  return e;
}, No = function(e, i) {
  return Oa(Lo(Fa(e), i));
}, Pi = /* @__PURE__ */ new WeakMap(), Fo = function(e) {
  if (!(e.type !== "rule" || !e.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  e.length < 1)) {
    for (var i = e.value, a = e.parent, n = e.column === a.column && e.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a) return;
    if (!(e.props.length === 1 && i.charCodeAt(0) !== 58 && !Pi.get(a)) && !n) {
      Pi.set(e, !0);
      for (var l = [], r = No(i, l), c = a.props, o = 0, s = 0; o < r.length; o++)
        for (var u = 0; u < c.length; u++, s++)
          e.props[s] = l[o] ? r[o].replace(/&\f/g, c[u]) : c[u] + " " + r[o];
    }
  }
}, Oo = function(e) {
  if (e.type === "decl") {
    var i = e.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
};
function Pa(t, e) {
  switch (ho(t, e)) {
    case 5103:
      return $ + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return $ + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return $ + t + nn + t + Te + t + t;
    case 6828:
    case 4268:
      return $ + t + Te + t + t;
    case 6165:
      return $ + t + Te + "flex-" + t + t;
    case 5187:
      return $ + t + Q(t, /(\w+).+(:[^]+)/, $ + "box-$1$2" + Te + "flex-$1$2") + t;
    case 5443:
      return $ + t + Te + "flex-item-" + Q(t, /flex-|-self/, "") + t;
    case 4675:
      return $ + t + Te + "flex-line-pack" + Q(t, /align-content|flex-|-self/, "") + t;
    case 5548:
      return $ + t + Te + Q(t, "shrink", "negative") + t;
    case 5292:
      return $ + t + Te + Q(t, "basis", "preferred-size") + t;
    case 6060:
      return $ + "box-" + Q(t, "-grow", "") + $ + t + Te + Q(t, "grow", "positive") + t;
    case 4554:
      return $ + Q(t, /([^-])(transform)/g, "$1" + $ + "$2") + t;
    case 6187:
      return Q(Q(Q(t, /(zoom-|grab)/, $ + "$1"), /(image-set)/, $ + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return Q(t, /(image-set\([^]*)/, $ + "$1$`$1");
    case 4968:
      return Q(Q(t, /(.+:)(flex-)?(.*)/, $ + "box-pack:$3" + Te + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $ + t + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Q(t, /(.+)-inline(.+)/, $ + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ze(t) - 1 - e > 6) switch (Ie(t, e + 1)) {
        case 109:
          if (Ie(t, e + 4) !== 45) break;
        case 102:
          return Q(t, /(.+:)(.+)-([^]+)/, "$1" + $ + "$2-$3$1" + nn + (Ie(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
        case 115:
          return ~Rn(t, "stretch") ? Pa(Q(t, "stretch", "fill-available"), e) + t : t;
      }
      break;
    case 4949:
      if (Ie(t, e + 1) !== 115) break;
    case 6444:
      switch (Ie(t, Ze(t) - 3 - (~Rn(t, "!important") && 10))) {
        case 107:
          return Q(t, ":", ":" + $) + t;
        case 101:
          return Q(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + $ + (Ie(t, 14) === 45 ? "inline-" : "") + "box$3$1" + $ + "$2$3$1" + Te + "$2box$3") + t;
      }
      break;
    case 5936:
      switch (Ie(t, e + 11)) {
        case 114:
          return $ + t + Te + Q(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return $ + t + Te + Q(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return $ + t + Te + Q(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return $ + t + Te + t + t;
  }
  return t;
}
var Po = function(e, i, a, n) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case Qn:
      e.return = Pa(e.value, e.length);
      break;
    case _a:
      return gt([Et(e, {
        value: Q(e.value, "@", "@" + $)
      })], n);
    case $n:
      if (e.length) return vo(e.props, function(l) {
        switch (bo(l, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return gt([Et(e, {
              props: [Q(l, /:(read-\w+)/, ":" + nn + "$1")]
            })], n);
          case "::placeholder":
            return gt([Et(e, {
              props: [Q(l, /:(plac\w+)/, ":" + $ + "input-$1")]
            }), Et(e, {
              props: [Q(l, /:(plac\w+)/, ":" + nn + "$1")]
            }), Et(e, {
              props: [Q(l, /:(plac\w+)/, Te + "input-$1")]
            })], n);
        }
        return "";
      });
  }
}, ko = [Po], Ro = function(e) {
  var i = e.key;
  if (i === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(f) {
      var g = f.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(f), f.setAttribute("data-s", ""));
    });
  }
  var n = e.stylisPlugins || ko, l = {}, r, c = [];
  r = e.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(f) {
      for (var g = f.getAttribute("data-emotion").split(" "), h = 1; h < g.length; h++)
        l[g[h]] = !0;
      c.push(f);
    }
  );
  var o, s = [Fo, Oo];
  {
    var u, d = [xo, Mo(function(f) {
      u.insert(f);
    })], C = Go(s.concat(n, d)), p = function(g) {
      return gt(yo(g), C);
    };
    o = function(g, h, S, E) {
      u = S, p(g ? g + "{" + h.styles + "}" : h.styles), E && (b.inserted[h.name] = !0);
    };
  }
  var b = {
    key: i,
    sheet: new uo({
      key: i,
      container: r,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: l,
    registered: {},
    insert: o
  };
  return b.sheet.hydrate(c), b;
}, Hn = { exports: {} }, q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ki;
function Do() {
  if (ki) return q;
  ki = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, n = t ? Symbol.for("react.strict_mode") : 60108, l = t ? Symbol.for("react.profiler") : 60114, r = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, o = t ? Symbol.for("react.async_mode") : 60111, s = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, C = t ? Symbol.for("react.suspense_list") : 60120, p = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, f = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, h = t ? Symbol.for("react.responder") : 60118, S = t ? Symbol.for("react.scope") : 60119;
  function E(I) {
    if (typeof I == "object" && I !== null) {
      var w = I.$$typeof;
      switch (w) {
        case e:
          switch (I = I.type, I) {
            case o:
            case s:
            case a:
            case l:
            case n:
            case d:
              return I;
            default:
              switch (I = I && I.$$typeof, I) {
                case c:
                case u:
                case b:
                case p:
                case r:
                  return I;
                default:
                  return w;
              }
          }
        case i:
          return w;
      }
    }
  }
  function A(I) {
    return E(I) === s;
  }
  return q.AsyncMode = o, q.ConcurrentMode = s, q.ContextConsumer = c, q.ContextProvider = r, q.Element = e, q.ForwardRef = u, q.Fragment = a, q.Lazy = b, q.Memo = p, q.Portal = i, q.Profiler = l, q.StrictMode = n, q.Suspense = d, q.isAsyncMode = function(I) {
    return A(I) || E(I) === o;
  }, q.isConcurrentMode = A, q.isContextConsumer = function(I) {
    return E(I) === c;
  }, q.isContextProvider = function(I) {
    return E(I) === r;
  }, q.isElement = function(I) {
    return typeof I == "object" && I !== null && I.$$typeof === e;
  }, q.isForwardRef = function(I) {
    return E(I) === u;
  }, q.isFragment = function(I) {
    return E(I) === a;
  }, q.isLazy = function(I) {
    return E(I) === b;
  }, q.isMemo = function(I) {
    return E(I) === p;
  }, q.isPortal = function(I) {
    return E(I) === i;
  }, q.isProfiler = function(I) {
    return E(I) === l;
  }, q.isStrictMode = function(I) {
    return E(I) === n;
  }, q.isSuspense = function(I) {
    return E(I) === d;
  }, q.isValidElementType = function(I) {
    return typeof I == "string" || typeof I == "function" || I === a || I === s || I === l || I === n || I === d || I === C || typeof I == "object" && I !== null && (I.$$typeof === b || I.$$typeof === p || I.$$typeof === r || I.$$typeof === c || I.$$typeof === u || I.$$typeof === g || I.$$typeof === h || I.$$typeof === S || I.$$typeof === f);
  }, q.typeOf = E, q;
}
var ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ri;
function Ho() {
  return Ri || (Ri = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, i = t ? Symbol.for("react.portal") : 60106, a = t ? Symbol.for("react.fragment") : 60107, n = t ? Symbol.for("react.strict_mode") : 60108, l = t ? Symbol.for("react.profiler") : 60114, r = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, o = t ? Symbol.for("react.async_mode") : 60111, s = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, C = t ? Symbol.for("react.suspense_list") : 60120, p = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, f = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, h = t ? Symbol.for("react.responder") : 60118, S = t ? Symbol.for("react.scope") : 60119;
    function E(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === a || G === s || G === l || G === n || G === d || G === C || typeof G == "object" && G !== null && (G.$$typeof === b || G.$$typeof === p || G.$$typeof === r || G.$$typeof === c || G.$$typeof === u || G.$$typeof === g || G.$$typeof === h || G.$$typeof === S || G.$$typeof === f);
    }
    function A(G) {
      if (typeof G == "object" && G !== null) {
        var Pe = G.$$typeof;
        switch (Pe) {
          case e:
            var be = G.type;
            switch (be) {
              case o:
              case s:
              case a:
              case l:
              case n:
              case d:
                return be;
              default:
                var Ne = be && be.$$typeof;
                switch (Ne) {
                  case c:
                  case u:
                  case b:
                  case p:
                  case r:
                    return Ne;
                  default:
                    return Pe;
                }
            }
          case i:
            return Pe;
        }
      }
    }
    var I = o, w = s, T = c, x = r, O = e, W = u, M = a, L = b, H = p, K = i, z = l, k = n, oe = d, re = !1;
    function fe(G) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ie(G) || A(G) === o;
    }
    function ie(G) {
      return A(G) === s;
    }
    function X(G) {
      return A(G) === c;
    }
    function j(G) {
      return A(G) === r;
    }
    function U(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function Y(G) {
      return A(G) === u;
    }
    function J(G) {
      return A(G) === a;
    }
    function de(G) {
      return A(G) === b;
    }
    function Ae(G) {
      return A(G) === p;
    }
    function pe(G) {
      return A(G) === i;
    }
    function Le(G) {
      return A(G) === l;
    }
    function Ye(G) {
      return A(G) === n;
    }
    function je(G) {
      return A(G) === d;
    }
    ee.AsyncMode = I, ee.ConcurrentMode = w, ee.ContextConsumer = T, ee.ContextProvider = x, ee.Element = O, ee.ForwardRef = W, ee.Fragment = M, ee.Lazy = L, ee.Memo = H, ee.Portal = K, ee.Profiler = z, ee.StrictMode = k, ee.Suspense = oe, ee.isAsyncMode = fe, ee.isConcurrentMode = ie, ee.isContextConsumer = X, ee.isContextProvider = j, ee.isElement = U, ee.isForwardRef = Y, ee.isFragment = J, ee.isLazy = de, ee.isMemo = Ae, ee.isPortal = pe, ee.isProfiler = Le, ee.isStrictMode = Ye, ee.isSuspense = je, ee.isValidElementType = E, ee.typeOf = A;
  }()), ee;
}
process.env.NODE_ENV === "production" ? Hn.exports = Do() : Hn.exports = Ho();
var Uo = Hn.exports, ka = Uo, Vo = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Wo = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Ra = {};
Ra[ka.ForwardRef] = Vo;
Ra[ka.Memo] = Wo;
var Xo = !0;
function Zo(t, e, i) {
  var a = "";
  return i.split(" ").forEach(function(n) {
    t[n] !== void 0 ? e.push(t[n] + ";") : n && (a += n + " ");
  }), a;
}
var Da = function(e, i, a) {
  var n = e.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Xo === !1) && e.registered[n] === void 0 && (e.registered[n] = i.styles);
}, zo = function(e, i, a) {
  Da(e, i, a);
  var n = e.key + "-" + i.name;
  if (e.inserted[i.name] === void 0) {
    var l = i;
    do
      e.insert(i === l ? "." + n : "", l, e.sheet, !0), l = l.next;
    while (l !== void 0);
  }
};
function Jo(t) {
  for (var e = 0, i, a = 0, n = t.length; n >= 4; ++a, n -= 4)
    i = t.charCodeAt(a) & 255 | (t.charCodeAt(++a) & 255) << 8 | (t.charCodeAt(++a) & 255) << 16 | (t.charCodeAt(++a) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, e = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (n) {
    case 3:
      e ^= (t.charCodeAt(a + 2) & 255) << 16;
    case 2:
      e ^= (t.charCodeAt(a + 1) & 255) << 8;
    case 1:
      e ^= t.charCodeAt(a) & 255, e = /* Math.imul(h, m): */
      (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = /* Math.imul(h, m): */
  (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Yo = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, jo = !1, $o = /[A-Z]|^ms/g, Qo = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ha = function(e) {
  return e.charCodeAt(1) === 45;
}, Di = function(e) {
  return e != null && typeof e != "boolean";
}, Tn = /* @__PURE__ */ Bo(function(t) {
  return Ha(t) ? t : t.replace($o, "-$&").toLowerCase();
}), Hi = function(e, i) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(Qo, function(a, n, l) {
          return ze = {
            name: n,
            styles: l,
            next: ze
          }, n;
        });
  }
  return Yo[e] !== 1 && !Ha(e) && typeof i == "number" && i !== 0 ? i + "px" : i;
}, Ko = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ft(t, e, i) {
  if (i == null)
    return "";
  var a = i;
  if (a.__emotion_styles !== void 0)
    return a;
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      var n = i;
      if (n.anim === 1)
        return ze = {
          name: n.name,
          styles: n.styles,
          next: ze
        }, n.name;
      var l = i;
      if (l.styles !== void 0) {
        var r = l.next;
        if (r !== void 0)
          for (; r !== void 0; )
            ze = {
              name: r.name,
              styles: r.styles,
              next: ze
            }, r = r.next;
        var c = l.styles + ";";
        return c;
      }
      return qo(t, e, i);
    }
    case "function": {
      if (t !== void 0) {
        var o = ze, s = i(t);
        return ze = o, Ft(t, e, s);
      }
      break;
    }
  }
  var u = i;
  return u;
}
function qo(t, e, i) {
  var a = "";
  if (Array.isArray(i))
    for (var n = 0; n < i.length; n++)
      a += Ft(t, e, i[n]) + ";";
  else
    for (var l in i) {
      var r = i[l];
      if (typeof r != "object") {
        var c = r;
        Di(c) && (a += Tn(l) + ":" + Hi(l, c) + ";");
      } else {
        if (l === "NO_COMPONENT_SELECTOR" && jo)
          throw new Error(Ko);
        if (Array.isArray(r) && typeof r[0] == "string" && e == null)
          for (var o = 0; o < r.length; o++)
            Di(r[o]) && (a += Tn(l) + ":" + Hi(l, r[o]) + ";");
        else {
          var s = Ft(t, e, r);
          switch (l) {
            case "animation":
            case "animationName": {
              a += Tn(l) + ":" + s + ";";
              break;
            }
            default:
              a += l + "{" + s + "}";
          }
        }
      }
    }
  return a;
}
var Ui = /label:\s*([^\s;{]+)\s*(;|$)/g, ze;
function Ua(t, e, i) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var a = !0, n = "";
  ze = void 0;
  var l = t[0];
  if (l == null || l.raw === void 0)
    a = !1, n += Ft(i, e, l);
  else {
    var r = l;
    n += r[0];
  }
  for (var c = 1; c < t.length; c++)
    if (n += Ft(i, e, t[c]), a) {
      var o = l;
      n += o[c];
    }
  Ui.lastIndex = 0;
  for (var s = "", u; (u = Ui.exec(n)) !== null; )
    s += "-" + u[1];
  var d = Jo(n) + s;
  return {
    name: d,
    styles: n,
    next: ze
  };
}
var er = function(e) {
  return e();
}, tr = V.useInsertionEffect ? V.useInsertionEffect : !1, nr = tr || er, ir = !1, Va = /* @__PURE__ */ V.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Ro({
    key: "css"
  }) : null
);
Va.Provider;
var ar = function(e) {
  return /* @__PURE__ */ Ia(function(i, a) {
    var n = dn(Va);
    return e(i, n, a);
  });
}, lr = /* @__PURE__ */ V.createContext({}), qn = {}.hasOwnProperty, Un = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", or = function(e, i) {
  var a = {};
  for (var n in i)
    qn.call(i, n) && (a[n] = i[n]);
  return a[Un] = e, a;
}, rr = function(e) {
  var i = e.cache, a = e.serialized, n = e.isStringTag;
  return Da(i, a, n), nr(function() {
    return zo(i, a, n);
  }), null;
}, sr = /* @__PURE__ */ ar(
  /* <any, any> */
  function(t, e, i) {
    var a = t.css;
    typeof a == "string" && e.registered[a] !== void 0 && (a = e.registered[a]);
    var n = t[Un], l = [a], r = "";
    typeof t.className == "string" ? r = Zo(e.registered, l, t.className) : t.className != null && (r = t.className + " ");
    var c = Ua(l, void 0, V.useContext(lr));
    r += e.key + "-" + c.name;
    var o = {};
    for (var s in t)
      qn.call(t, s) && s !== "css" && s !== Un && !ir && (o[s] = t[s]);
    return o.className = r, i && (o.ref = i), /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement(rr, {
      cache: e,
      serialized: c,
      isStringTag: typeof n == "string"
    }), /* @__PURE__ */ V.createElement(n, o));
  }
), cr = sr, N = function(e, i) {
  var a = arguments;
  if (i == null || !qn.call(i, "css"))
    return V.createElement.apply(void 0, a);
  var n = a.length, l = new Array(n);
  l[0] = cr, l[1] = or(e, i);
  for (var r = 2; r < n; r++)
    l[r] = a[r];
  return V.createElement.apply(null, l);
};
function ei() {
  for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++)
    e[i] = arguments[i];
  return Ua(e);
}
var ur = function() {
  var e = ei.apply(void 0, arguments), i = "animation-" + e.name;
  return {
    name: i,
    styles: "@keyframes " + i + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function dr(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}
const mr = Math.min, fr = Math.max, an = Math.round, Wt = Math.floor, ln = (t) => ({
  x: t,
  y: t
});
function pr(t) {
  const {
    x: e,
    y: i,
    width: a,
    height: n
  } = t;
  return {
    width: a,
    height: n,
    top: i,
    left: e,
    right: e + a,
    bottom: i + n,
    x: e,
    y: i
  };
}
function gn() {
  return typeof window < "u";
}
function Wa(t) {
  return Za(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function tt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Xa(t) {
  var e;
  return (e = (Za(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Za(t) {
  return gn() ? t instanceof Node || t instanceof tt(t).Node : !1;
}
function gr(t) {
  return gn() ? t instanceof Element || t instanceof tt(t).Element : !1;
}
function ti(t) {
  return gn() ? t instanceof HTMLElement || t instanceof tt(t).HTMLElement : !1;
}
function Vi(t) {
  return !gn() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof tt(t).ShadowRoot;
}
function za(t) {
  const {
    overflow: e,
    overflowX: i,
    overflowY: a,
    display: n
  } = ni(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + a + i) && !["inline", "contents"].includes(n);
}
function hr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function br(t) {
  return ["html", "body", "#document"].includes(Wa(t));
}
function ni(t) {
  return tt(t).getComputedStyle(t);
}
function vr(t) {
  if (Wa(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Vi(t) && t.host || // Fallback.
    Xa(t)
  );
  return Vi(e) ? e.host : e;
}
function Ja(t) {
  const e = vr(t);
  return br(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : ti(e) && za(e) ? e : Ja(e);
}
function on(t, e, i) {
  var a;
  e === void 0 && (e = []), i === void 0 && (i = !0);
  const n = Ja(t), l = n === ((a = t.ownerDocument) == null ? void 0 : a.body), r = tt(n);
  if (l) {
    const c = Vn(r);
    return e.concat(r, r.visualViewport || [], za(n) ? n : [], c && i ? on(c) : []);
  }
  return e.concat(n, on(n, [], i));
}
function Vn(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Ir(t) {
  const e = ni(t);
  let i = parseFloat(e.width) || 0, a = parseFloat(e.height) || 0;
  const n = ti(t), l = n ? t.offsetWidth : i, r = n ? t.offsetHeight : a, c = an(i) !== l || an(a) !== r;
  return c && (i = l, a = r), {
    width: i,
    height: a,
    $: c
  };
}
function ii(t) {
  return gr(t) ? t : t.contextElement;
}
function Wi(t) {
  const e = ii(t);
  if (!ti(e))
    return ln(1);
  const i = e.getBoundingClientRect(), {
    width: a,
    height: n,
    $: l
  } = Ir(e);
  let r = (l ? an(i.width) : i.width) / a, c = (l ? an(i.height) : i.height) / n;
  return (!r || !Number.isFinite(r)) && (r = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: r,
    y: c
  };
}
const Cr = /* @__PURE__ */ ln(0);
function Ar(t) {
  const e = tt(t);
  return !hr() || !e.visualViewport ? Cr : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Er(t, e, i) {
  return !1;
}
function Xi(t, e, i, a) {
  e === void 0 && (e = !1);
  const n = t.getBoundingClientRect(), l = ii(t);
  let r = ln(1);
  e && (r = Wi(t));
  const c = Er() ? Ar(l) : ln(0);
  let o = (n.left + c.x) / r.x, s = (n.top + c.y) / r.y, u = n.width / r.x, d = n.height / r.y;
  if (l) {
    const C = tt(l), p = a;
    let b = C, f = Vn(b);
    for (; f && a && p !== b; ) {
      const g = Wi(f), h = f.getBoundingClientRect(), S = ni(f), E = h.left + (f.clientLeft + parseFloat(S.paddingLeft)) * g.x, A = h.top + (f.clientTop + parseFloat(S.paddingTop)) * g.y;
      o *= g.x, s *= g.y, u *= g.x, d *= g.y, o += E, s += A, b = tt(f), f = Vn(b);
    }
  }
  return pr({
    width: u,
    height: d,
    x: o,
    y: s
  });
}
function Tr(t, e) {
  let i = null, a;
  const n = Xa(t);
  function l() {
    var c;
    clearTimeout(a), (c = i) == null || c.disconnect(), i = null;
  }
  function r(c, o) {
    c === void 0 && (c = !1), o === void 0 && (o = 1), l();
    const {
      left: s,
      top: u,
      width: d,
      height: C
    } = t.getBoundingClientRect();
    if (c || e(), !d || !C)
      return;
    const p = Wt(u), b = Wt(n.clientWidth - (s + d)), f = Wt(n.clientHeight - (u + C)), g = Wt(s), S = {
      rootMargin: -p + "px " + -b + "px " + -f + "px " + -g + "px",
      threshold: fr(0, mr(1, o)) || 1
    };
    let E = !0;
    function A(I) {
      const w = I[0].intersectionRatio;
      if (w !== o) {
        if (!E)
          return r();
        w ? r(!1, w) : a = setTimeout(() => {
          r(!1, 1e-7);
        }, 1e3);
      }
      E = !1;
    }
    try {
      i = new IntersectionObserver(A, {
        ...S,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      i = new IntersectionObserver(A, S);
    }
    i.observe(t);
  }
  return r(!0), l;
}
function Sr(t, e, i, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: l = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = a, s = ii(t), u = n || l ? [...s ? on(s) : [], ...on(e)] : [];
  u.forEach((h) => {
    n && h.addEventListener("scroll", i, {
      passive: !0
    }), l && h.addEventListener("resize", i);
  });
  const d = s && c ? Tr(s, i) : null;
  let C = -1, p = null;
  r && (p = new ResizeObserver((h) => {
    let [S] = h;
    S && S.target === s && p && (p.unobserve(e), cancelAnimationFrame(C), C = requestAnimationFrame(() => {
      var E;
      (E = p) == null || E.observe(e);
    })), i();
  }), s && !o && p.observe(s), p.observe(e));
  let b, f = o ? Xi(t) : null;
  o && g();
  function g() {
    const h = Xi(t);
    f && (h.x !== f.x || h.y !== f.y || h.width !== f.width || h.height !== f.height) && i(), f = h, b = requestAnimationFrame(g);
  }
  return i(), () => {
    var h;
    u.forEach((S) => {
      n && S.removeEventListener("scroll", i), l && S.removeEventListener("resize", i);
    }), d?.(), (h = p) == null || h.disconnect(), p = null, o && cancelAnimationFrame(b);
  };
}
var Wn = Pl, yr = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], rn = function() {
};
function wr(t, e) {
  return e ? e[0] === "-" ? t + e : t + "__" + e : t;
}
function xr(t, e) {
  for (var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), n = 2; n < i; n++)
    a[n - 2] = arguments[n];
  var l = [].concat(a);
  if (e && t)
    for (var r in e)
      e.hasOwnProperty(r) && e[r] && l.push("".concat(wr(t, r)));
  return l.filter(function(c) {
    return c;
  }).map(function(c) {
    return String(c).trim();
  }).join(" ");
}
var Zi = function(e) {
  return Pr(e) ? e.filter(Boolean) : ct(e) === "object" && e !== null ? [e] : [];
}, Ya = function(e) {
  e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme;
  var i = nt(e, yr);
  return F({}, i);
}, ue = function(e, i, a) {
  var n = e.cx, l = e.getStyles, r = e.getClassNames, c = e.className;
  return {
    css: l(i, e),
    className: n(a ?? {}, r(i, e), c)
  };
};
function hn(t) {
  return [document.documentElement, document.body, window].indexOf(t) > -1;
}
function Gr(t) {
  return hn(t) ? window.innerHeight : t.clientHeight;
}
function ja(t) {
  return hn(t) ? window.pageYOffset : t.scrollTop;
}
function sn(t, e) {
  if (hn(t)) {
    window.scrollTo(0, e);
    return;
  }
  t.scrollTop = e;
}
function Mr(t) {
  var e = getComputedStyle(t), i = e.position === "absolute", a = /(auto|scroll)/;
  if (e.position === "fixed") return document.documentElement;
  for (var n = t; n = n.parentElement; )
    if (e = getComputedStyle(n), !(i && e.position === "static") && a.test(e.overflow + e.overflowY + e.overflowX))
      return n;
  return document.documentElement;
}
function Br(t, e, i, a) {
  return i * ((t = t / a - 1) * t * t + 1) + e;
}
function Xt(t, e) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : rn, n = ja(t), l = e - n, r = 10, c = 0;
  function o() {
    c += r;
    var s = Br(c, n, l, i);
    sn(t, s), c < i ? window.requestAnimationFrame(o) : a(t);
  }
  o();
}
function zi(t, e) {
  var i = t.getBoundingClientRect(), a = e.getBoundingClientRect(), n = e.offsetHeight / 3;
  a.bottom + n > i.bottom ? sn(t, Math.min(e.offsetTop + e.clientHeight - t.offsetHeight + n, t.scrollHeight)) : a.top - n < i.top && sn(t, Math.max(e.offsetTop - n, 0));
}
function _r(t) {
  var e = t.getBoundingClientRect();
  return {
    bottom: e.bottom,
    height: e.height,
    left: e.left,
    right: e.right,
    top: e.top,
    width: e.width
  };
}
function Ji() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function Lr() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var $a = !1, Nr = {
  get passive() {
    return $a = !0;
  }
}, Zt = typeof window < "u" ? window : {};
Zt.addEventListener && Zt.removeEventListener && (Zt.addEventListener("p", rn, Nr), Zt.removeEventListener("p", rn, !1));
var Fr = $a;
function Or(t) {
  return t != null;
}
function Pr(t) {
  return Array.isArray(t);
}
function zt(t, e, i) {
  return t ? e : i;
}
var kr = function(e) {
  for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++)
    a[n - 1] = arguments[n];
  var l = Object.entries(e).filter(function(r) {
    var c = et(r, 1), o = c[0];
    return !a.includes(o);
  });
  return l.reduce(function(r, c) {
    var o = et(c, 2), s = o[0], u = o[1];
    return r[s] = u, r;
  }, {});
}, Rr = ["children", "innerProps"], Dr = ["children", "innerProps"];
function Hr(t) {
  var e = t.maxHeight, i = t.menuEl, a = t.minHeight, n = t.placement, l = t.shouldScroll, r = t.isFixedPosition, c = t.controlHeight, o = Mr(i), s = {
    placement: "bottom",
    maxHeight: e
  };
  if (!i || !i.offsetParent) return s;
  var u = o.getBoundingClientRect(), d = u.height, C = i.getBoundingClientRect(), p = C.bottom, b = C.height, f = C.top, g = i.offsetParent.getBoundingClientRect(), h = g.top, S = r ? window.innerHeight : Gr(o), E = ja(o), A = parseInt(getComputedStyle(i).marginBottom, 10), I = parseInt(getComputedStyle(i).marginTop, 10), w = h - I, T = S - f, x = w + E, O = d - E - f, W = p - S + E + A, M = E + f - I, L = 160;
  switch (n) {
    case "auto":
    case "bottom":
      if (T >= b)
        return {
          placement: "bottom",
          maxHeight: e
        };
      if (O >= b && !r)
        return l && Xt(o, W, L), {
          placement: "bottom",
          maxHeight: e
        };
      if (!r && O >= a || r && T >= a) {
        l && Xt(o, W, L);
        var H = r ? T - A : O - A;
        return {
          placement: "bottom",
          maxHeight: H
        };
      }
      if (n === "auto" || r) {
        var K = e, z = r ? w : x;
        return z >= a && (K = Math.min(z - A - c, e)), {
          placement: "top",
          maxHeight: K
        };
      }
      if (n === "bottom")
        return l && sn(o, W), {
          placement: "bottom",
          maxHeight: e
        };
      break;
    case "top":
      if (w >= b)
        return {
          placement: "top",
          maxHeight: e
        };
      if (x >= b && !r)
        return l && Xt(o, M, L), {
          placement: "top",
          maxHeight: e
        };
      if (!r && x >= a || r && w >= a) {
        var k = e;
        return (!r && x >= a || r && w >= a) && (k = r ? w - I : x - I), l && Xt(o, M, L), {
          placement: "top",
          maxHeight: k
        };
      }
      return {
        placement: "bottom",
        maxHeight: e
      };
    default:
      throw new Error('Invalid placement provided "'.concat(n, '".'));
  }
  return s;
}
function Ur(t) {
  var e = {
    bottom: "top",
    top: "bottom"
  };
  return t ? e[t] : "bottom";
}
var Qa = function(e) {
  return e === "auto" ? "bottom" : e;
}, Vr = function(e, i) {
  var a, n = e.placement, l = e.theme, r = l.borderRadius, c = l.spacing, o = l.colors;
  return F((a = {
    label: "menu"
  }, Mt(a, Ur(n), "100%"), Mt(a, "position", "absolute"), Mt(a, "width", "100%"), Mt(a, "zIndex", 1), a), i ? {} : {
    backgroundColor: o.neutral0,
    borderRadius: r,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: c.menuGutter,
    marginTop: c.menuGutter
  });
}, Ka = /* @__PURE__ */ Jn(null), Wr = function(e) {
  var i = e.children, a = e.minMenuHeight, n = e.maxMenuHeight, l = e.menuPlacement, r = e.menuPosition, c = e.menuShouldScrollIntoView, o = e.theme, s = dn(Ka) || {}, u = s.setPortalPlacement, d = Ue(null), C = te(n), p = et(C, 2), b = p[0], f = p[1], g = te(null), h = et(g, 2), S = h[0], E = h[1], A = o.spacing.controlHeight;
  return Wn(function() {
    var I = d.current;
    if (I) {
      var w = r === "fixed", T = c && !w, x = Hr({
        maxHeight: n,
        menuEl: I,
        minHeight: a,
        placement: l,
        shouldScroll: T,
        isFixedPosition: w,
        controlHeight: A
      });
      f(x.maxHeight), E(x.placement), u?.(x.placement);
    }
  }, [n, l, r, c, a, u, A]), i({
    ref: d,
    placerProps: F(F({}, e), {}, {
      placement: S || Qa(l),
      maxHeight: b
    })
  });
}, Xr = function(e) {
  var i = e.children, a = e.innerRef, n = e.innerProps;
  return N("div", P({}, ue(e, "menu", {
    menu: !0
  }), {
    ref: a
  }, n), i);
}, Zr = Xr, zr = function(e, i) {
  var a = e.maxHeight, n = e.theme.spacing.baseUnit;
  return F({
    maxHeight: a,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, i ? {} : {
    paddingBottom: n,
    paddingTop: n
  });
}, Jr = function(e) {
  var i = e.children, a = e.innerProps, n = e.innerRef, l = e.isMulti;
  return N("div", P({}, ue(e, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": l
  }), {
    ref: n
  }, a), i);
}, qa = function(e, i) {
  var a = e.theme, n = a.spacing.baseUnit, l = a.colors;
  return F({
    textAlign: "center"
  }, i ? {} : {
    color: l.neutral40,
    padding: "".concat(n * 2, "px ").concat(n * 3, "px")
  });
}, Yr = qa, jr = qa, $r = function(e) {
  var i = e.children, a = i === void 0 ? "No options" : i, n = e.innerProps, l = nt(e, Rr);
  return N("div", P({}, ue(F(F({}, l), {}, {
    children: a,
    innerProps: n
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), n), a);
}, Qr = function(e) {
  var i = e.children, a = i === void 0 ? "Loading..." : i, n = e.innerProps, l = nt(e, Dr);
  return N("div", P({}, ue(F(F({}, l), {}, {
    children: a,
    innerProps: n
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), n), a);
}, Kr = function(e) {
  var i = e.rect, a = e.offset, n = e.position;
  return {
    left: i.left,
    position: n,
    top: a,
    width: i.width,
    zIndex: 1
  };
}, qr = function(e) {
  var i = e.appendTo, a = e.children, n = e.controlElement, l = e.innerProps, r = e.menuPlacement, c = e.menuPosition, o = Ue(null), s = Ue(null), u = te(Qa(r)), d = et(u, 2), C = d[0], p = d[1], b = De(function() {
    return {
      setPortalPlacement: p
    };
  }, []), f = te(null), g = et(f, 2), h = g[0], S = g[1], E = Ce(function() {
    if (n) {
      var T = _r(n), x = c === "fixed" ? 0 : window.pageYOffset, O = T[C] + x;
      (O !== h?.offset || T.left !== h?.rect.left || T.width !== h?.rect.width) && S({
        offset: O,
        rect: T
      });
    }
  }, [n, c, C, h?.offset, h?.rect.left, h?.rect.width]);
  Wn(function() {
    E();
  }, [E]);
  var A = Ce(function() {
    typeof s.current == "function" && (s.current(), s.current = null), n && o.current && (s.current = Sr(n, o.current, E, {
      elementResize: "ResizeObserver" in window
    }));
  }, [n, E]);
  Wn(function() {
    A();
  }, [A]);
  var I = Ce(function(T) {
    o.current = T, A();
  }, [A]);
  if (!i && c !== "fixed" || !h) return null;
  var w = N("div", P({
    ref: I
  }, ue(F(F({}, e), {}, {
    offset: h.offset,
    position: c,
    rect: h.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), l), a);
  return N(Ka.Provider, {
    value: b
  }, i ? /* @__PURE__ */ Rl(w, i) : w);
}, es = function(e) {
  var i = e.isDisabled, a = e.isRtl;
  return {
    label: "container",
    direction: a ? "rtl" : void 0,
    pointerEvents: i ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, ts = function(e) {
  var i = e.children, a = e.innerProps, n = e.isDisabled, l = e.isRtl;
  return N("div", P({}, ue(e, "container", {
    "--is-disabled": n,
    "--is-rtl": l
  }), a), i);
}, ns = function(e, i) {
  var a = e.theme.spacing, n = e.isMulti, l = e.hasValue, r = e.selectProps.controlShouldRenderValue;
  return F({
    alignItems: "center",
    display: n && l && r ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, i ? {} : {
    padding: "".concat(a.baseUnit / 2, "px ").concat(a.baseUnit * 2, "px")
  });
}, is = function(e) {
  var i = e.children, a = e.innerProps, n = e.isMulti, l = e.hasValue;
  return N("div", P({}, ue(e, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": n,
    "value-container--has-value": l
  }), a), i);
}, as = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, ls = function(e) {
  var i = e.children, a = e.innerProps;
  return N("div", P({}, ue(e, "indicatorsContainer", {
    indicators: !0
  }), a), i);
}, Yi, os = ["size"], rs = ["innerProps", "isRtl", "size"];
function ss() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var cs = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ss
}, el = function(e) {
  var i = e.size, a = nt(e, os);
  return N("svg", P({
    height: i,
    width: i,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: cs
  }, a));
}, ai = function(e) {
  return N(el, P({
    size: 20
  }, e), N("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, tl = function(e) {
  return N(el, P({
    size: 20
  }, e), N("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, nl = function(e, i) {
  var a = e.isFocused, n = e.theme, l = n.spacing.baseUnit, r = n.colors;
  return F({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, i ? {} : {
    color: a ? r.neutral60 : r.neutral20,
    padding: l * 2,
    ":hover": {
      color: a ? r.neutral80 : r.neutral40
    }
  });
}, us = nl, ds = function(e) {
  var i = e.children, a = e.innerProps;
  return N("div", P({}, ue(e, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), a), i || N(tl, null));
}, ms = nl, fs = function(e) {
  var i = e.children, a = e.innerProps;
  return N("div", P({}, ue(e, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), a), i || N(ai, null));
}, ps = function(e, i) {
  var a = e.isDisabled, n = e.theme, l = n.spacing.baseUnit, r = n.colors;
  return F({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, i ? {} : {
    backgroundColor: a ? r.neutral10 : r.neutral20,
    marginBottom: l * 2,
    marginTop: l * 2
  });
}, gs = function(e) {
  var i = e.innerProps;
  return N("span", P({}, i, ue(e, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, hs = ur(Yi || (Yi = dr([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), bs = function(e, i) {
  var a = e.isFocused, n = e.size, l = e.theme, r = l.colors, c = l.spacing.baseUnit;
  return F({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: n,
    lineHeight: 1,
    marginRight: n,
    textAlign: "center",
    verticalAlign: "middle"
  }, i ? {} : {
    color: a ? r.neutral60 : r.neutral20,
    padding: c * 2
  });
}, Sn = function(e) {
  var i = e.delay, a = e.offset;
  return N("span", {
    css: /* @__PURE__ */ ei({
      animation: "".concat(hs, " 1s ease-in-out ").concat(i, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: a ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, vs = function(e) {
  var i = e.innerProps, a = e.isRtl, n = e.size, l = n === void 0 ? 4 : n, r = nt(e, rs);
  return N("div", P({}, ue(F(F({}, r), {}, {
    innerProps: i,
    isRtl: a,
    size: l
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), i), N(Sn, {
    delay: 0,
    offset: a
  }), N(Sn, {
    delay: 160,
    offset: !0
  }), N(Sn, {
    delay: 320,
    offset: !a
  }));
}, Is = function(e, i) {
  var a = e.isDisabled, n = e.isFocused, l = e.theme, r = l.colors, c = l.borderRadius, o = l.spacing;
  return F({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: o.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, i ? {} : {
    backgroundColor: a ? r.neutral5 : r.neutral0,
    borderColor: a ? r.neutral10 : n ? r.primary : r.neutral20,
    borderRadius: c,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: n ? "0 0 0 1px ".concat(r.primary) : void 0,
    "&:hover": {
      borderColor: n ? r.primary : r.neutral30
    }
  });
}, Cs = function(e) {
  var i = e.children, a = e.isDisabled, n = e.isFocused, l = e.innerRef, r = e.innerProps, c = e.menuIsOpen;
  return N("div", P({
    ref: l
  }, ue(e, "control", {
    control: !0,
    "control--is-disabled": a,
    "control--is-focused": n,
    "control--menu-is-open": c
  }), r, {
    "aria-disabled": a || void 0
  }), i);
}, As = Cs, Es = ["data"], Ts = function(e, i) {
  var a = e.theme.spacing;
  return i ? {} : {
    paddingBottom: a.baseUnit * 2,
    paddingTop: a.baseUnit * 2
  };
}, Ss = function(e) {
  var i = e.children, a = e.cx, n = e.getStyles, l = e.getClassNames, r = e.Heading, c = e.headingProps, o = e.innerProps, s = e.label, u = e.theme, d = e.selectProps;
  return N("div", P({}, ue(e, "group", {
    group: !0
  }), o), N(r, P({}, c, {
    selectProps: d,
    theme: u,
    getStyles: n,
    getClassNames: l,
    cx: a
  }), s), N("div", null, i));
}, ys = function(e, i) {
  var a = e.theme, n = a.colors, l = a.spacing;
  return F({
    label: "group",
    cursor: "default",
    display: "block"
  }, i ? {} : {
    color: n.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: l.baseUnit * 3,
    paddingRight: l.baseUnit * 3,
    textTransform: "uppercase"
  });
}, ws = function(e) {
  var i = Ya(e);
  i.data;
  var a = nt(i, Es);
  return N("div", P({}, ue(e, "groupHeading", {
    "group-heading": !0
  }), a));
}, xs = Ss, Gs = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Ms = function(e, i) {
  var a = e.isDisabled, n = e.value, l = e.theme, r = l.spacing, c = l.colors;
  return F(F({
    visibility: a ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: n ? "translateZ(0)" : ""
  }, Bs), i ? {} : {
    margin: r.baseUnit / 2,
    paddingBottom: r.baseUnit / 2,
    paddingTop: r.baseUnit / 2,
    color: c.neutral80
  });
}, il = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Bs = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": F({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, il)
}, _s = function(e) {
  return F({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, il);
}, Ls = function(e) {
  var i = e.cx, a = e.value, n = Ya(e), l = n.innerRef, r = n.isDisabled, c = n.isHidden, o = n.inputClassName, s = nt(n, Gs);
  return N("div", P({}, ue(e, "input", {
    "input-container": !0
  }), {
    "data-value": a || ""
  }), N("input", P({
    className: i({
      input: !0
    }, o),
    ref: l,
    style: _s(c),
    disabled: r
  }, s)));
}, Ns = Ls, Fs = function(e, i) {
  var a = e.theme, n = a.spacing, l = a.borderRadius, r = a.colors;
  return F({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, i ? {} : {
    backgroundColor: r.neutral10,
    borderRadius: l / 2,
    margin: n.baseUnit / 2
  });
}, Os = function(e, i) {
  var a = e.theme, n = a.borderRadius, l = a.colors, r = e.cropWithEllipsis;
  return F({
    overflow: "hidden",
    textOverflow: r || r === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, i ? {} : {
    borderRadius: n / 2,
    color: l.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, Ps = function(e, i) {
  var a = e.theme, n = a.spacing, l = a.borderRadius, r = a.colors, c = e.isFocused;
  return F({
    alignItems: "center",
    display: "flex"
  }, i ? {} : {
    borderRadius: l / 2,
    backgroundColor: c ? r.dangerLight : void 0,
    paddingLeft: n.baseUnit,
    paddingRight: n.baseUnit,
    ":hover": {
      backgroundColor: r.dangerLight,
      color: r.danger
    }
  });
}, al = function(e) {
  var i = e.children, a = e.innerProps;
  return N("div", a, i);
}, ks = al, Rs = al;
function Ds(t) {
  var e = t.children, i = t.innerProps;
  return N("div", P({
    role: "button"
  }, i), e || N(ai, {
    size: 14
  }));
}
var Hs = function(e) {
  var i = e.children, a = e.components, n = e.data, l = e.innerProps, r = e.isDisabled, c = e.removeProps, o = e.selectProps, s = a.Container, u = a.Label, d = a.Remove;
  return N(s, {
    data: n,
    innerProps: F(F({}, ue(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": r
    })), l),
    selectProps: o
  }, N(u, {
    data: n,
    innerProps: F({}, ue(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: o
  }, i), N(d, {
    data: n,
    innerProps: F(F({}, ue(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(i || "option")
    }, c),
    selectProps: o
  }));
}, Us = Hs, Vs = function(e, i) {
  var a = e.isDisabled, n = e.isFocused, l = e.isSelected, r = e.theme, c = r.spacing, o = r.colors;
  return F({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, i ? {} : {
    backgroundColor: l ? o.primary : n ? o.primary25 : "transparent",
    color: a ? o.neutral20 : l ? o.neutral0 : "inherit",
    padding: "".concat(c.baseUnit * 2, "px ").concat(c.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: a ? void 0 : l ? o.primary : o.primary50
    }
  });
}, Ws = function(e) {
  var i = e.children, a = e.isDisabled, n = e.isFocused, l = e.isSelected, r = e.innerRef, c = e.innerProps;
  return N("div", P({}, ue(e, "option", {
    option: !0,
    "option--is-disabled": a,
    "option--is-focused": n,
    "option--is-selected": l
  }), {
    ref: r,
    "aria-disabled": a
  }, c), i);
}, Xs = Ws, Zs = function(e, i) {
  var a = e.theme, n = a.spacing, l = a.colors;
  return F({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, i ? {} : {
    color: l.neutral50,
    marginLeft: n.baseUnit / 2,
    marginRight: n.baseUnit / 2
  });
}, zs = function(e) {
  var i = e.children, a = e.innerProps;
  return N("div", P({}, ue(e, "placeholder", {
    placeholder: !0
  }), a), i);
}, Js = zs, Ys = function(e, i) {
  var a = e.isDisabled, n = e.theme, l = n.spacing, r = n.colors;
  return F({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, i ? {} : {
    color: a ? r.neutral40 : r.neutral80,
    marginLeft: l.baseUnit / 2,
    marginRight: l.baseUnit / 2
  });
}, js = function(e) {
  var i = e.children, a = e.isDisabled, n = e.innerProps;
  return N("div", P({}, ue(e, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": a
  }), n), i);
}, $s = js, Qs = {
  ClearIndicator: fs,
  Control: As,
  DropdownIndicator: ds,
  DownChevron: tl,
  CrossIcon: ai,
  Group: xs,
  GroupHeading: ws,
  IndicatorsContainer: ls,
  IndicatorSeparator: gs,
  Input: Ns,
  LoadingIndicator: vs,
  Menu: Zr,
  MenuList: Jr,
  MenuPortal: qr,
  LoadingMessage: Qr,
  NoOptionsMessage: $r,
  MultiValue: Us,
  MultiValueContainer: ks,
  MultiValueLabel: Rs,
  MultiValueRemove: Ds,
  Option: Xs,
  Placeholder: Js,
  SelectContainer: ts,
  SingleValue: $s,
  ValueContainer: is
}, Ks = function(e) {
  return F(F({}, Qs), e.components);
}, ji = Number.isNaN || function(e) {
  return typeof e == "number" && e !== e;
};
function qs(t, e) {
  return !!(t === e || ji(t) && ji(e));
}
function ec(t, e) {
  if (t.length !== e.length)
    return !1;
  for (var i = 0; i < t.length; i++)
    if (!qs(t[i], e[i]))
      return !1;
  return !0;
}
function tc(t, e) {
  e === void 0 && (e = ec);
  var i = null;
  function a() {
    for (var n = [], l = 0; l < arguments.length; l++)
      n[l] = arguments[l];
    if (i && i.lastThis === this && e(n, i.lastArgs))
      return i.lastResult;
    var r = t.apply(this, n);
    return i = {
      lastResult: r,
      lastArgs: n,
      lastThis: this
    }, r;
  }
  return a.clear = function() {
    i = null;
  }, a;
}
function nc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var ic = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: nc
}, ac = function(e) {
  return N("span", P({
    css: ic
  }, e));
}, $i = ac, lc = {
  guidance: function(e) {
    var i = e.isSearchable, a = e.isMulti, n = e.tabSelectsValue, l = e.context, r = e.isInitialFocus;
    switch (l) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(n ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return r ? "".concat(e["aria-label"] || "Select", " is focused ").concat(i ? ",type to refine list" : "", ", press Down to open the menu, ").concat(a ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(e) {
    var i = e.action, a = e.label, n = a === void 0 ? "" : a, l = e.labels, r = e.isDisabled;
    switch (i) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(n, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(l.length > 1 ? "s" : "", " ").concat(l.join(","), ", selected.");
      case "select-option":
        return r ? "option ".concat(n, " is disabled. Select another option.") : "option ".concat(n, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(e) {
    var i = e.context, a = e.focused, n = e.options, l = e.label, r = l === void 0 ? "" : l, c = e.selectValue, o = e.isDisabled, s = e.isSelected, u = e.isAppleDevice, d = function(f, g) {
      return f && f.length ? "".concat(f.indexOf(g) + 1, " of ").concat(f.length) : "";
    };
    if (i === "value" && c)
      return "value ".concat(r, " focused, ").concat(d(c, a), ".");
    if (i === "menu" && u) {
      var C = o ? " disabled" : "", p = "".concat(s ? " selected" : "").concat(C);
      return "".concat(r).concat(p, ", ").concat(d(n, a), ".");
    }
    return "";
  },
  onFilter: function(e) {
    var i = e.inputValue, a = e.resultsMessage;
    return "".concat(a).concat(i ? " for search term " + i : "", ".");
  }
}, oc = function(e) {
  var i = e.ariaSelection, a = e.focusedOption, n = e.focusedValue, l = e.focusableOptions, r = e.isFocused, c = e.selectValue, o = e.selectProps, s = e.id, u = e.isAppleDevice, d = o.ariaLiveMessages, C = o.getOptionLabel, p = o.inputValue, b = o.isMulti, f = o.isOptionDisabled, g = o.isSearchable, h = o.menuIsOpen, S = o.options, E = o.screenReaderStatus, A = o.tabSelectsValue, I = o.isLoading, w = o["aria-label"], T = o["aria-live"], x = De(function() {
    return F(F({}, lc), d || {});
  }, [d]), O = De(function() {
    var z = "";
    if (i && x.onChange) {
      var k = i.option, oe = i.options, re = i.removedValue, fe = i.removedValues, ie = i.value, X = function(pe) {
        return Array.isArray(pe) ? null : pe;
      }, j = re || k || X(ie), U = j ? C(j) : "", Y = oe || fe || void 0, J = Y ? Y.map(C) : [], de = F({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: j && f(j, c),
        label: U,
        labels: J
      }, i);
      z = x.onChange(de);
    }
    return z;
  }, [i, x, f, c, C]), W = De(function() {
    var z = "", k = a || n, oe = !!(a && c && c.includes(a));
    if (k && x.onFocus) {
      var re = {
        focused: k,
        label: C(k),
        isDisabled: f(k, c),
        isSelected: oe,
        options: l,
        context: k === a ? "menu" : "value",
        selectValue: c,
        isAppleDevice: u
      };
      z = x.onFocus(re);
    }
    return z;
  }, [a, n, C, f, x, l, c, u]), M = De(function() {
    var z = "";
    if (h && S.length && !I && x.onFilter) {
      var k = E({
        count: l.length
      });
      z = x.onFilter({
        inputValue: p,
        resultsMessage: k
      });
    }
    return z;
  }, [l, p, h, x, S, E, I]), L = i?.action === "initial-input-focus", H = De(function() {
    var z = "";
    if (x.guidance) {
      var k = n ? "value" : h ? "menu" : "input";
      z = x.guidance({
        "aria-label": w,
        context: k,
        isDisabled: a && f(a, c),
        isMulti: b,
        isSearchable: g,
        tabSelectsValue: A,
        isInitialFocus: L
      });
    }
    return z;
  }, [w, a, n, b, f, g, h, x, c, A, L]), K = N(On, null, N("span", {
    id: "aria-selection"
  }, O), N("span", {
    id: "aria-focused"
  }, W), N("span", {
    id: "aria-results"
  }, M), N("span", {
    id: "aria-guidance"
  }, H));
  return N(On, null, N($i, {
    id: s
  }, L && K), N($i, {
    "aria-live": T,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, r && !L && K));
}, rc = oc, Xn = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], sc = new RegExp("[" + Xn.map(function(t) {
  return t.letters;
}).join("") + "]", "g"), ll = {};
for (var yn = 0; yn < Xn.length; yn++)
  for (var wn = Xn[yn], xn = 0; xn < wn.letters.length; xn++)
    ll[wn.letters[xn]] = wn.base;
var ol = function(e) {
  return e.replace(sc, function(i) {
    return ll[i];
  });
}, cc = tc(ol), Qi = function(e) {
  return e.replace(/^\s+|\s+$/g, "");
}, uc = function(e) {
  return "".concat(e.label, " ").concat(e.value);
}, dc = function(e) {
  return function(i, a) {
    if (i.data.__isNew__) return !0;
    var n = F({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: uc,
      trim: !0,
      matchFrom: "any"
    }, e), l = n.ignoreCase, r = n.ignoreAccents, c = n.stringify, o = n.trim, s = n.matchFrom, u = o ? Qi(a) : a, d = o ? Qi(c(i)) : c(i);
    return l && (u = u.toLowerCase(), d = d.toLowerCase()), r && (u = cc(u), d = ol(d)), s === "start" ? d.substr(0, u.length) === u : d.indexOf(u) > -1;
  };
}, mc = ["innerRef"];
function fc(t) {
  var e = t.innerRef, i = nt(t, mc), a = kr(i, "onExited", "in", "enter", "exit", "appear");
  return N("input", P({
    ref: e
  }, a, {
    css: /* @__PURE__ */ ei({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var pc = function(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};
function gc(t) {
  var e = t.isEnabled, i = t.onBottomArrive, a = t.onBottomLeave, n = t.onTopArrive, l = t.onTopLeave, r = Ue(!1), c = Ue(!1), o = Ue(0), s = Ue(null), u = Ce(function(g, h) {
    if (s.current !== null) {
      var S = s.current, E = S.scrollTop, A = S.scrollHeight, I = S.clientHeight, w = s.current, T = h > 0, x = A - I - E, O = !1;
      x > h && r.current && (a && a(g), r.current = !1), T && c.current && (l && l(g), c.current = !1), T && h > x ? (i && !r.current && i(g), w.scrollTop = A, O = !0, r.current = !0) : !T && -h > E && (n && !c.current && n(g), w.scrollTop = 0, O = !0, c.current = !0), O && pc(g);
    }
  }, [i, a, n, l]), d = Ce(function(g) {
    u(g, g.deltaY);
  }, [u]), C = Ce(function(g) {
    o.current = g.changedTouches[0].clientY;
  }, []), p = Ce(function(g) {
    var h = o.current - g.changedTouches[0].clientY;
    u(g, h);
  }, [u]), b = Ce(function(g) {
    if (g) {
      var h = Fr ? {
        passive: !1
      } : !1;
      g.addEventListener("wheel", d, h), g.addEventListener("touchstart", C, h), g.addEventListener("touchmove", p, h);
    }
  }, [p, C, d]), f = Ce(function(g) {
    g && (g.removeEventListener("wheel", d, !1), g.removeEventListener("touchstart", C, !1), g.removeEventListener("touchmove", p, !1));
  }, [p, C, d]);
  return ne(function() {
    if (e) {
      var g = s.current;
      return b(g), function() {
        f(g);
      };
    }
  }, [e, b, f]), function(g) {
    s.current = g;
  };
}
var Ki = ["boxSizing", "height", "overflow", "paddingRight", "position"], qi = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function ea(t) {
  t.cancelable && t.preventDefault();
}
function ta(t) {
  t.stopPropagation();
}
function na() {
  var t = this.scrollTop, e = this.scrollHeight, i = t + this.offsetHeight;
  t === 0 ? this.scrollTop = 1 : i === e && (this.scrollTop = t - 1);
}
function ia() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var aa = !!(typeof window < "u" && window.document && window.document.createElement), Tt = 0, pt = {
  capture: !1,
  passive: !1
};
function hc(t) {
  var e = t.isEnabled, i = t.accountForScrollbars, a = i === void 0 ? !0 : i, n = Ue({}), l = Ue(null), r = Ce(function(o) {
    if (aa) {
      var s = document.body, u = s && s.style;
      if (a && Ki.forEach(function(b) {
        var f = u && u[b];
        n.current[b] = f;
      }), a && Tt < 1) {
        var d = parseInt(n.current.paddingRight, 10) || 0, C = document.body ? document.body.clientWidth : 0, p = window.innerWidth - C + d || 0;
        Object.keys(qi).forEach(function(b) {
          var f = qi[b];
          u && (u[b] = f);
        }), u && (u.paddingRight = "".concat(p, "px"));
      }
      s && ia() && (s.addEventListener("touchmove", ea, pt), o && (o.addEventListener("touchstart", na, pt), o.addEventListener("touchmove", ta, pt))), Tt += 1;
    }
  }, [a]), c = Ce(function(o) {
    if (aa) {
      var s = document.body, u = s && s.style;
      Tt = Math.max(Tt - 1, 0), a && Tt < 1 && Ki.forEach(function(d) {
        var C = n.current[d];
        u && (u[d] = C);
      }), s && ia() && (s.removeEventListener("touchmove", ea, pt), o && (o.removeEventListener("touchstart", na, pt), o.removeEventListener("touchmove", ta, pt)));
    }
  }, [a]);
  return ne(function() {
    if (e) {
      var o = l.current;
      return r(o), function() {
        c(o);
      };
    }
  }, [e, r, c]), function(o) {
    l.current = o;
  };
}
function bc() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var vc = function(e) {
  var i = e.target;
  return i.ownerDocument.activeElement && i.ownerDocument.activeElement.blur();
}, Ic = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: bc
};
function Cc(t) {
  var e = t.children, i = t.lockEnabled, a = t.captureEnabled, n = a === void 0 ? !0 : a, l = t.onBottomArrive, r = t.onBottomLeave, c = t.onTopArrive, o = t.onTopLeave, s = gc({
    isEnabled: n,
    onBottomArrive: l,
    onBottomLeave: r,
    onTopArrive: c,
    onTopLeave: o
  }), u = hc({
    isEnabled: i
  }), d = function(p) {
    s(p), u(p);
  };
  return N(On, null, i && N("div", {
    onClick: vc,
    css: Ic
  }), e(d));
}
function Ac() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ec = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Ac
}, Tc = function(e) {
  var i = e.name, a = e.onFocus;
  return N("input", {
    required: !0,
    name: i,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: a,
    css: Ec,
    value: "",
    onChange: function() {
    }
  });
}, Sc = Tc;
function li(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(((e = window.navigator.userAgentData) === null || e === void 0 ? void 0 : e.platform) || window.navigator.platform) : !1;
}
function yc() {
  return li(/^iPhone/i);
}
function rl() {
  return li(/^Mac/i);
}
function wc() {
  return li(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  rl() && navigator.maxTouchPoints > 1;
}
function xc() {
  return yc() || wc();
}
function Gc() {
  return rl() || xc();
}
var Mc = function(e) {
  return e.label;
}, Bc = function(e) {
  return e.label;
}, _c = function(e) {
  return e.value;
}, Lc = function(e) {
  return !!e.isDisabled;
}, Nc = {
  clearIndicator: ms,
  container: es,
  control: Is,
  dropdownIndicator: us,
  group: Ts,
  groupHeading: ys,
  indicatorsContainer: as,
  indicatorSeparator: ps,
  input: Ms,
  loadingIndicator: bs,
  loadingMessage: jr,
  menu: Vr,
  menuList: zr,
  menuPortal: Kr,
  multiValue: Fs,
  multiValueLabel: Os,
  multiValueRemove: Ps,
  noOptionsMessage: Yr,
  option: Vs,
  placeholder: Zs,
  singleValue: Ys,
  valueContainer: ns
}, Fc = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, Oc = 4, sl = 4, Pc = 38, kc = sl * 2, Rc = {
  baseUnit: sl,
  controlHeight: Pc,
  menuGutter: kc
}, Gn = {
  borderRadius: Oc,
  colors: Fc,
  spacing: Rc
}, Dc = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Ji(),
  captureMenuScroll: !Ji(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: dc(),
  formatGroupLabel: Mc,
  getOptionLabel: Bc,
  getOptionValue: _c,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: Lc,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !Lr(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(e) {
    var i = e.count;
    return "".concat(i, " result").concat(i !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function la(t, e, i, a) {
  var n = dl(t, e, i), l = ml(t, e, i), r = ul(t, e), c = cn(t, e);
  return {
    type: "option",
    data: e,
    isDisabled: n,
    isSelected: l,
    label: r,
    value: c,
    index: a
  };
}
function qt(t, e) {
  return t.options.map(function(i, a) {
    if ("options" in i) {
      var n = i.options.map(function(r, c) {
        return la(t, r, e, c);
      }).filter(function(r) {
        return ra(t, r);
      });
      return n.length > 0 ? {
        type: "group",
        data: i,
        options: n,
        index: a
      } : void 0;
    }
    var l = la(t, i, e, a);
    return ra(t, l) ? l : void 0;
  }).filter(Or);
}
function cl(t) {
  return t.reduce(function(e, i) {
    return i.type === "group" ? e.push.apply(e, jn(i.options.map(function(a) {
      return a.data;
    }))) : e.push(i.data), e;
  }, []);
}
function oa(t, e) {
  return t.reduce(function(i, a) {
    return a.type === "group" ? i.push.apply(i, jn(a.options.map(function(n) {
      return {
        data: n.data,
        id: "".concat(e, "-").concat(a.index, "-").concat(n.index)
      };
    }))) : i.push({
      data: a.data,
      id: "".concat(e, "-").concat(a.index)
    }), i;
  }, []);
}
function Hc(t, e) {
  return cl(qt(t, e));
}
function ra(t, e) {
  var i = t.inputValue, a = i === void 0 ? "" : i, n = e.data, l = e.isSelected, r = e.label, c = e.value;
  return (!pl(t) || !l) && fl(t, {
    label: r,
    value: c,
    data: n
  }, a);
}
function Uc(t, e) {
  var i = t.focusedValue, a = t.selectValue, n = a.indexOf(i);
  if (n > -1) {
    var l = e.indexOf(i);
    if (l > -1)
      return i;
    if (n < e.length)
      return e[n];
  }
  return null;
}
function Vc(t, e) {
  var i = t.focusedOption;
  return i && e.indexOf(i) > -1 ? i : e[0];
}
var Mn = function(e, i) {
  var a, n = (a = e.find(function(l) {
    return l.data === i;
  })) === null || a === void 0 ? void 0 : a.id;
  return n || null;
}, ul = function(e, i) {
  return e.getOptionLabel(i);
}, cn = function(e, i) {
  return e.getOptionValue(i);
};
function dl(t, e, i) {
  return typeof t.isOptionDisabled == "function" ? t.isOptionDisabled(e, i) : !1;
}
function ml(t, e, i) {
  if (i.indexOf(e) > -1) return !0;
  if (typeof t.isOptionSelected == "function")
    return t.isOptionSelected(e, i);
  var a = cn(t, e);
  return i.some(function(n) {
    return cn(t, n) === a;
  });
}
function fl(t, e, i) {
  return t.filterOption ? t.filterOption(e, i) : !0;
}
var pl = function(e) {
  var i = e.hideSelectedOptions, a = e.isMulti;
  return i === void 0 ? a : i;
}, Wc = 1, gl = /* @__PURE__ */ function(t) {
  eo(i, t);
  var e = io(i);
  function i(a) {
    var n;
    if (Kl(this, i), n = e.call(this, a), n.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, n.blockOptionHover = !1, n.isComposing = !1, n.commonProps = void 0, n.initialTouchX = 0, n.initialTouchY = 0, n.openAfterFocus = !1, n.scrollToFocusedOptionOnUpdate = !1, n.userIsDragging = void 0, n.isAppleDevice = Gc(), n.controlRef = null, n.getControlRef = function(o) {
      n.controlRef = o;
    }, n.focusedOptionRef = null, n.getFocusedOptionRef = function(o) {
      n.focusedOptionRef = o;
    }, n.menuListRef = null, n.getMenuListRef = function(o) {
      n.menuListRef = o;
    }, n.inputRef = null, n.getInputRef = function(o) {
      n.inputRef = o;
    }, n.focus = n.focusInput, n.blur = n.blurInput, n.onChange = function(o, s) {
      var u = n.props, d = u.onChange, C = u.name;
      s.name = C, n.ariaOnChange(o, s), d(o, s);
    }, n.setValue = function(o, s, u) {
      var d = n.props, C = d.closeMenuOnSelect, p = d.isMulti, b = d.inputValue;
      n.onInputChange("", {
        action: "set-value",
        prevInputValue: b
      }), C && (n.setState({
        inputIsHiddenAfterUpdate: !p
      }), n.onMenuClose()), n.setState({
        clearFocusValueOnUpdate: !0
      }), n.onChange(o, {
        action: s,
        option: u
      });
    }, n.selectOption = function(o) {
      var s = n.props, u = s.blurInputOnSelect, d = s.isMulti, C = s.name, p = n.state.selectValue, b = d && n.isOptionSelected(o, p), f = n.isOptionDisabled(o, p);
      if (b) {
        var g = n.getOptionValue(o);
        n.setValue(p.filter(function(h) {
          return n.getOptionValue(h) !== g;
        }), "deselect-option", o);
      } else if (!f)
        d ? n.setValue([].concat(jn(p), [o]), "select-option", o) : n.setValue(o, "select-option");
      else {
        n.ariaOnChange(o, {
          action: "select-option",
          option: o,
          name: C
        });
        return;
      }
      u && n.blurInput();
    }, n.removeValue = function(o) {
      var s = n.props.isMulti, u = n.state.selectValue, d = n.getOptionValue(o), C = u.filter(function(b) {
        return n.getOptionValue(b) !== d;
      }), p = zt(s, C, C[0] || null);
      n.onChange(p, {
        action: "remove-value",
        removedValue: o
      }), n.focusInput();
    }, n.clearValue = function() {
      var o = n.state.selectValue;
      n.onChange(zt(n.props.isMulti, [], null), {
        action: "clear",
        removedValues: o
      });
    }, n.popValue = function() {
      var o = n.props.isMulti, s = n.state.selectValue, u = s[s.length - 1], d = s.slice(0, s.length - 1), C = zt(o, d, d[0] || null);
      u && n.onChange(C, {
        action: "pop-value",
        removedValue: u
      });
    }, n.getFocusedOptionId = function(o) {
      return Mn(n.state.focusableOptionsWithIds, o);
    }, n.getFocusableOptionsWithIds = function() {
      return oa(qt(n.props, n.state.selectValue), n.getElementId("option"));
    }, n.getValue = function() {
      return n.state.selectValue;
    }, n.cx = function() {
      for (var o = arguments.length, s = new Array(o), u = 0; u < o; u++)
        s[u] = arguments[u];
      return xr.apply(void 0, [n.props.classNamePrefix].concat(s));
    }, n.getOptionLabel = function(o) {
      return ul(n.props, o);
    }, n.getOptionValue = function(o) {
      return cn(n.props, o);
    }, n.getStyles = function(o, s) {
      var u = n.props.unstyled, d = Nc[o](s, u);
      d.boxSizing = "border-box";
      var C = n.props.styles[o];
      return C ? C(d, s) : d;
    }, n.getClassNames = function(o, s) {
      var u, d;
      return (u = (d = n.props.classNames)[o]) === null || u === void 0 ? void 0 : u.call(d, s);
    }, n.getElementId = function(o) {
      return "".concat(n.state.instancePrefix, "-").concat(o);
    }, n.getComponents = function() {
      return Ks(n.props);
    }, n.buildCategorizedOptions = function() {
      return qt(n.props, n.state.selectValue);
    }, n.getCategorizedOptions = function() {
      return n.props.menuIsOpen ? n.buildCategorizedOptions() : [];
    }, n.buildFocusableOptions = function() {
      return cl(n.buildCategorizedOptions());
    }, n.getFocusableOptions = function() {
      return n.props.menuIsOpen ? n.buildFocusableOptions() : [];
    }, n.ariaOnChange = function(o, s) {
      n.setState({
        ariaSelection: F({
          value: o
        }, s)
      });
    }, n.onMenuMouseDown = function(o) {
      o.button === 0 && (o.stopPropagation(), o.preventDefault(), n.focusInput());
    }, n.onMenuMouseMove = function(o) {
      n.blockOptionHover = !1;
    }, n.onControlMouseDown = function(o) {
      if (!o.defaultPrevented) {
        var s = n.props.openMenuOnClick;
        n.state.isFocused ? n.props.menuIsOpen ? o.target.tagName !== "INPUT" && o.target.tagName !== "TEXTAREA" && n.onMenuClose() : s && n.openMenu("first") : (s && (n.openAfterFocus = !0), n.focusInput()), o.target.tagName !== "INPUT" && o.target.tagName !== "TEXTAREA" && o.preventDefault();
      }
    }, n.onDropdownIndicatorMouseDown = function(o) {
      if (!(o && o.type === "mousedown" && o.button !== 0) && !n.props.isDisabled) {
        var s = n.props, u = s.isMulti, d = s.menuIsOpen;
        n.focusInput(), d ? (n.setState({
          inputIsHiddenAfterUpdate: !u
        }), n.onMenuClose()) : n.openMenu("first"), o.preventDefault();
      }
    }, n.onClearIndicatorMouseDown = function(o) {
      o && o.type === "mousedown" && o.button !== 0 || (n.clearValue(), o.preventDefault(), n.openAfterFocus = !1, o.type === "touchend" ? n.focusInput() : setTimeout(function() {
        return n.focusInput();
      }));
    }, n.onScroll = function(o) {
      typeof n.props.closeMenuOnScroll == "boolean" ? o.target instanceof HTMLElement && hn(o.target) && n.props.onMenuClose() : typeof n.props.closeMenuOnScroll == "function" && n.props.closeMenuOnScroll(o) && n.props.onMenuClose();
    }, n.onCompositionStart = function() {
      n.isComposing = !0;
    }, n.onCompositionEnd = function() {
      n.isComposing = !1;
    }, n.onTouchStart = function(o) {
      var s = o.touches, u = s && s.item(0);
      u && (n.initialTouchX = u.clientX, n.initialTouchY = u.clientY, n.userIsDragging = !1);
    }, n.onTouchMove = function(o) {
      var s = o.touches, u = s && s.item(0);
      if (u) {
        var d = Math.abs(u.clientX - n.initialTouchX), C = Math.abs(u.clientY - n.initialTouchY), p = 5;
        n.userIsDragging = d > p || C > p;
      }
    }, n.onTouchEnd = function(o) {
      n.userIsDragging || (n.controlRef && !n.controlRef.contains(o.target) && n.menuListRef && !n.menuListRef.contains(o.target) && n.blurInput(), n.initialTouchX = 0, n.initialTouchY = 0);
    }, n.onControlTouchEnd = function(o) {
      n.userIsDragging || n.onControlMouseDown(o);
    }, n.onClearIndicatorTouchEnd = function(o) {
      n.userIsDragging || n.onClearIndicatorMouseDown(o);
    }, n.onDropdownIndicatorTouchEnd = function(o) {
      n.userIsDragging || n.onDropdownIndicatorMouseDown(o);
    }, n.handleInputChange = function(o) {
      var s = n.props.inputValue, u = o.currentTarget.value;
      n.setState({
        inputIsHiddenAfterUpdate: !1
      }), n.onInputChange(u, {
        action: "input-change",
        prevInputValue: s
      }), n.props.menuIsOpen || n.onMenuOpen();
    }, n.onInputFocus = function(o) {
      n.props.onFocus && n.props.onFocus(o), n.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (n.openAfterFocus || n.props.openMenuOnFocus) && n.openMenu("first"), n.openAfterFocus = !1;
    }, n.onInputBlur = function(o) {
      var s = n.props.inputValue;
      if (n.menuListRef && n.menuListRef.contains(document.activeElement)) {
        n.inputRef.focus();
        return;
      }
      n.props.onBlur && n.props.onBlur(o), n.onInputChange("", {
        action: "input-blur",
        prevInputValue: s
      }), n.onMenuClose(), n.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, n.onOptionHover = function(o) {
      if (!(n.blockOptionHover || n.state.focusedOption === o)) {
        var s = n.getFocusableOptions(), u = s.indexOf(o);
        n.setState({
          focusedOption: o,
          focusedOptionId: u > -1 ? n.getFocusedOptionId(o) : null
        });
      }
    }, n.shouldHideSelectedOptions = function() {
      return pl(n.props);
    }, n.onValueInputFocus = function(o) {
      o.preventDefault(), o.stopPropagation(), n.focus();
    }, n.onKeyDown = function(o) {
      var s = n.props, u = s.isMulti, d = s.backspaceRemovesValue, C = s.escapeClearsValue, p = s.inputValue, b = s.isClearable, f = s.isDisabled, g = s.menuIsOpen, h = s.onKeyDown, S = s.tabSelectsValue, E = s.openMenuOnFocus, A = n.state, I = A.focusedOption, w = A.focusedValue, T = A.selectValue;
      if (!f && !(typeof h == "function" && (h(o), o.defaultPrevented))) {
        switch (n.blockOptionHover = !0, o.key) {
          case "ArrowLeft":
            if (!u || p) return;
            n.focusValue("previous");
            break;
          case "ArrowRight":
            if (!u || p) return;
            n.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (p) return;
            if (w)
              n.removeValue(w);
            else {
              if (!d) return;
              u ? n.popValue() : b && n.clearValue();
            }
            break;
          case "Tab":
            if (n.isComposing || o.shiftKey || !g || !S || !I || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            E && n.isOptionSelected(I, T))
              return;
            n.selectOption(I);
            break;
          case "Enter":
            if (o.keyCode === 229)
              break;
            if (g) {
              if (!I || n.isComposing) return;
              n.selectOption(I);
              break;
            }
            return;
          case "Escape":
            g ? (n.setState({
              inputIsHiddenAfterUpdate: !1
            }), n.onInputChange("", {
              action: "menu-close",
              prevInputValue: p
            }), n.onMenuClose()) : b && C && n.clearValue();
            break;
          case " ":
            if (p)
              return;
            if (!g) {
              n.openMenu("first");
              break;
            }
            if (!I) return;
            n.selectOption(I);
            break;
          case "ArrowUp":
            g ? n.focusOption("up") : n.openMenu("last");
            break;
          case "ArrowDown":
            g ? n.focusOption("down") : n.openMenu("first");
            break;
          case "PageUp":
            if (!g) return;
            n.focusOption("pageup");
            break;
          case "PageDown":
            if (!g) return;
            n.focusOption("pagedown");
            break;
          case "Home":
            if (!g) return;
            n.focusOption("first");
            break;
          case "End":
            if (!g) return;
            n.focusOption("last");
            break;
          default:
            return;
        }
        o.preventDefault();
      }
    }, n.state.instancePrefix = "react-select-" + (n.props.instanceId || ++Wc), n.state.selectValue = Zi(a.value), a.menuIsOpen && n.state.selectValue.length) {
      var l = n.getFocusableOptionsWithIds(), r = n.buildFocusableOptions(), c = r.indexOf(n.state.selectValue[0]);
      n.state.focusableOptionsWithIds = l, n.state.focusedOption = r[c], n.state.focusedOptionId = Mn(l, r[c]);
    }
    return n;
  }
  return ql(i, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && zi(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      var l = this.props, r = l.isDisabled, c = l.menuIsOpen, o = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (o && !r && n.isDisabled || // ensure focus is on the Input when the menu opens
      o && c && !n.menuIsOpen) && this.focusInput(), o && r && !n.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !o && !r && n.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (zi(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(n, l) {
      this.props.onInputChange(n, l);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(n) {
      var l = this, r = this.state, c = r.selectValue, o = r.isFocused, s = this.buildFocusableOptions(), u = n === "first" ? 0 : s.length - 1;
      if (!this.props.isMulti) {
        var d = s.indexOf(c[0]);
        d > -1 && (u = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(o && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: s[u],
        focusedOptionId: this.getFocusedOptionId(s[u])
      }, function() {
        return l.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(n) {
      var l = this.state, r = l.selectValue, c = l.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var o = r.indexOf(c);
        c || (o = -1);
        var s = r.length - 1, u = -1;
        if (r.length) {
          switch (n) {
            case "previous":
              o === 0 ? u = 0 : o === -1 ? u = s : u = o - 1;
              break;
            case "next":
              o > -1 && o < s && (u = o + 1);
              break;
          }
          this.setState({
            inputIsHidden: u !== -1,
            focusedValue: r[u]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", l = this.props.pageSize, r = this.state.focusedOption, c = this.getFocusableOptions();
      if (c.length) {
        var o = 0, s = c.indexOf(r);
        r || (s = -1), n === "up" ? o = s > 0 ? s - 1 : c.length - 1 : n === "down" ? o = (s + 1) % c.length : n === "pageup" ? (o = s - l, o < 0 && (o = 0)) : n === "pagedown" ? (o = s + l, o > c.length - 1 && (o = c.length - 1)) : n === "last" && (o = c.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: c[o],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(c[o])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(Gn) : F(F({}, Gn), this.props.theme) : Gn;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var n = this.clearValue, l = this.cx, r = this.getStyles, c = this.getClassNames, o = this.getValue, s = this.selectOption, u = this.setValue, d = this.props, C = d.isMulti, p = d.isRtl, b = d.options, f = this.hasValue();
      return {
        clearValue: n,
        cx: l,
        getStyles: r,
        getClassNames: c,
        getValue: o,
        hasValue: f,
        isMulti: C,
        isRtl: p,
        options: b,
        selectOption: s,
        selectProps: d,
        setValue: u,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var n = this.state.selectValue;
      return n.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var n = this.props, l = n.isClearable, r = n.isMulti;
      return l === void 0 ? r : l;
    }
  }, {
    key: "isOptionDisabled",
    value: function(n, l) {
      return dl(this.props, n, l);
    }
  }, {
    key: "isOptionSelected",
    value: function(n, l) {
      return ml(this.props, n, l);
    }
  }, {
    key: "filterOption",
    value: function(n, l) {
      return fl(this.props, n, l);
    }
  }, {
    key: "formatOptionLabel",
    value: function(n, l) {
      if (typeof this.props.formatOptionLabel == "function") {
        var r = this.props.inputValue, c = this.state.selectValue;
        return this.props.formatOptionLabel(n, {
          context: l,
          inputValue: r,
          selectValue: c
        });
      } else
        return this.getOptionLabel(n);
    }
  }, {
    key: "formatGroupLabel",
    value: function(n) {
      return this.props.formatGroupLabel(n);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var n = this.props, l = n.isDisabled, r = n.isSearchable, c = n.inputId, o = n.inputValue, s = n.tabIndex, u = n.form, d = n.menuIsOpen, C = n.required, p = this.getComponents(), b = p.Input, f = this.state, g = f.inputIsHidden, h = f.ariaSelection, S = this.commonProps, E = c || this.getElementId("input"), A = F(F(F({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": C,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, d && {
          "aria-controls": this.getElementId("listbox")
        }), !r && {
          "aria-readonly": !0
        }), this.hasValue() ? h?.action === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return r ? /* @__PURE__ */ V.createElement(b, P({}, S, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: E,
          innerRef: this.getInputRef,
          isDisabled: l,
          isHidden: g,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: s,
          form: u,
          type: "text",
          value: o
        }, A)) : /* @__PURE__ */ V.createElement(fc, P({
          id: E,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: rn,
          onFocus: this.onInputFocus,
          disabled: l,
          tabIndex: s,
          inputMode: "none",
          form: u,
          value: ""
        }, A));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var n = this, l = this.getComponents(), r = l.MultiValue, c = l.MultiValueContainer, o = l.MultiValueLabel, s = l.MultiValueRemove, u = l.SingleValue, d = l.Placeholder, C = this.commonProps, p = this.props, b = p.controlShouldRenderValue, f = p.isDisabled, g = p.isMulti, h = p.inputValue, S = p.placeholder, E = this.state, A = E.selectValue, I = E.focusedValue, w = E.isFocused;
      if (!this.hasValue() || !b)
        return h ? null : /* @__PURE__ */ V.createElement(d, P({}, C, {
          key: "placeholder",
          isDisabled: f,
          isFocused: w,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), S);
      if (g)
        return A.map(function(x, O) {
          var W = x === I, M = "".concat(n.getOptionLabel(x), "-").concat(n.getOptionValue(x));
          return /* @__PURE__ */ V.createElement(r, P({}, C, {
            components: {
              Container: c,
              Label: o,
              Remove: s
            },
            isFocused: W,
            isDisabled: f,
            key: M,
            index: O,
            removeProps: {
              onClick: function() {
                return n.removeValue(x);
              },
              onTouchEnd: function() {
                return n.removeValue(x);
              },
              onMouseDown: function(H) {
                H.preventDefault();
              }
            },
            data: x
          }), n.formatOptionLabel(x, "value"));
        });
      if (h)
        return null;
      var T = A[0];
      return /* @__PURE__ */ V.createElement(u, P({}, C, {
        data: T,
        isDisabled: f
      }), this.formatOptionLabel(T, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var n = this.getComponents(), l = n.ClearIndicator, r = this.commonProps, c = this.props, o = c.isDisabled, s = c.isLoading, u = this.state.isFocused;
      if (!this.isClearable() || !l || o || !this.hasValue() || s)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ V.createElement(l, P({}, r, {
        innerProps: d,
        isFocused: u
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var n = this.getComponents(), l = n.LoadingIndicator, r = this.commonProps, c = this.props, o = c.isDisabled, s = c.isLoading, u = this.state.isFocused;
      if (!l || !s) return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ V.createElement(l, P({}, r, {
        innerProps: d,
        isDisabled: o,
        isFocused: u
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var n = this.getComponents(), l = n.DropdownIndicator, r = n.IndicatorSeparator;
      if (!l || !r) return null;
      var c = this.commonProps, o = this.props.isDisabled, s = this.state.isFocused;
      return /* @__PURE__ */ V.createElement(r, P({}, c, {
        isDisabled: o,
        isFocused: s
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var n = this.getComponents(), l = n.DropdownIndicator;
      if (!l) return null;
      var r = this.commonProps, c = this.props.isDisabled, o = this.state.isFocused, s = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ V.createElement(l, P({}, r, {
        innerProps: s,
        isDisabled: c,
        isFocused: o
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var n = this, l = this.getComponents(), r = l.Group, c = l.GroupHeading, o = l.Menu, s = l.MenuList, u = l.MenuPortal, d = l.LoadingMessage, C = l.NoOptionsMessage, p = l.Option, b = this.commonProps, f = this.state.focusedOption, g = this.props, h = g.captureMenuScroll, S = g.inputValue, E = g.isLoading, A = g.loadingMessage, I = g.minMenuHeight, w = g.maxMenuHeight, T = g.menuIsOpen, x = g.menuPlacement, O = g.menuPosition, W = g.menuPortalTarget, M = g.menuShouldBlockScroll, L = g.menuShouldScrollIntoView, H = g.noOptionsMessage, K = g.onMenuScrollToTop, z = g.onMenuScrollToBottom;
      if (!T) return null;
      var k = function(U, Y) {
        var J = U.type, de = U.data, Ae = U.isDisabled, pe = U.isSelected, Le = U.label, Ye = U.value, je = f === de, G = Ae ? void 0 : function() {
          return n.onOptionHover(de);
        }, Pe = Ae ? void 0 : function() {
          return n.selectOption(de);
        }, be = "".concat(n.getElementId("option"), "-").concat(Y), Ne = {
          id: be,
          onClick: Pe,
          onMouseMove: G,
          onMouseOver: G,
          tabIndex: -1,
          role: "option",
          "aria-selected": n.isAppleDevice ? void 0 : pe
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ V.createElement(p, P({}, b, {
          innerProps: Ne,
          data: de,
          isDisabled: Ae,
          isSelected: pe,
          key: be,
          label: Le,
          type: J,
          value: Ye,
          isFocused: je,
          innerRef: je ? n.getFocusedOptionRef : void 0
        }), n.formatOptionLabel(U.data, "menu"));
      }, oe;
      if (this.hasOptions())
        oe = this.getCategorizedOptions().map(function(j) {
          if (j.type === "group") {
            var U = j.data, Y = j.options, J = j.index, de = "".concat(n.getElementId("group"), "-").concat(J), Ae = "".concat(de, "-heading");
            return /* @__PURE__ */ V.createElement(r, P({}, b, {
              key: de,
              data: U,
              options: Y,
              Heading: c,
              headingProps: {
                id: Ae,
                data: j.data
              },
              label: n.formatGroupLabel(j.data)
            }), j.options.map(function(pe) {
              return k(pe, "".concat(J, "-").concat(pe.index));
            }));
          } else if (j.type === "option")
            return k(j, "".concat(j.index));
        });
      else if (E) {
        var re = A({
          inputValue: S
        });
        if (re === null) return null;
        oe = /* @__PURE__ */ V.createElement(d, b, re);
      } else {
        var fe = H({
          inputValue: S
        });
        if (fe === null) return null;
        oe = /* @__PURE__ */ V.createElement(C, b, fe);
      }
      var ie = {
        minMenuHeight: I,
        maxMenuHeight: w,
        menuPlacement: x,
        menuPosition: O,
        menuShouldScrollIntoView: L
      }, X = /* @__PURE__ */ V.createElement(Wr, P({}, b, ie), function(j) {
        var U = j.ref, Y = j.placerProps, J = Y.placement, de = Y.maxHeight;
        return /* @__PURE__ */ V.createElement(o, P({}, b, ie, {
          innerRef: U,
          innerProps: {
            onMouseDown: n.onMenuMouseDown,
            onMouseMove: n.onMenuMouseMove
          },
          isLoading: E,
          placement: J
        }), /* @__PURE__ */ V.createElement(Cc, {
          captureEnabled: h,
          onTopArrive: K,
          onBottomArrive: z,
          lockEnabled: M
        }, function(Ae) {
          return /* @__PURE__ */ V.createElement(s, P({}, b, {
            innerRef: function(Le) {
              n.getMenuListRef(Le), Ae(Le);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": b.isMulti,
              id: n.getElementId("listbox")
            },
            isLoading: E,
            maxHeight: de,
            focusedOption: f
          }), oe);
        }));
      });
      return W || O === "fixed" ? /* @__PURE__ */ V.createElement(u, P({}, b, {
        appendTo: W,
        controlElement: this.controlRef,
        menuPlacement: x,
        menuPosition: O
      }), X) : X;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var n = this, l = this.props, r = l.delimiter, c = l.isDisabled, o = l.isMulti, s = l.name, u = l.required, d = this.state.selectValue;
      if (u && !this.hasValue() && !c)
        return /* @__PURE__ */ V.createElement(Sc, {
          name: s,
          onFocus: this.onValueInputFocus
        });
      if (!(!s || c))
        if (o)
          if (r) {
            var C = d.map(function(f) {
              return n.getOptionValue(f);
            }).join(r);
            return /* @__PURE__ */ V.createElement("input", {
              name: s,
              type: "hidden",
              value: C
            });
          } else {
            var p = d.length > 0 ? d.map(function(f, g) {
              return /* @__PURE__ */ V.createElement("input", {
                key: "i-".concat(g),
                name: s,
                type: "hidden",
                value: n.getOptionValue(f)
              });
            }) : /* @__PURE__ */ V.createElement("input", {
              name: s,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ V.createElement("div", null, p);
          }
        else {
          var b = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ V.createElement("input", {
            name: s,
            type: "hidden",
            value: b
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var n = this.commonProps, l = this.state, r = l.ariaSelection, c = l.focusedOption, o = l.focusedValue, s = l.isFocused, u = l.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ V.createElement(rc, P({}, n, {
        id: this.getElementId("live-region"),
        ariaSelection: r,
        focusedOption: c,
        focusedValue: o,
        isFocused: s,
        selectValue: u,
        focusableOptions: d,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.getComponents(), l = n.Control, r = n.IndicatorsContainer, c = n.SelectContainer, o = n.ValueContainer, s = this.props, u = s.className, d = s.id, C = s.isDisabled, p = s.menuIsOpen, b = this.state.isFocused, f = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ V.createElement(c, P({}, f, {
        className: u,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: C,
        isFocused: b
      }), this.renderLiveRegion(), /* @__PURE__ */ V.createElement(l, P({}, f, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: C,
        isFocused: b,
        menuIsOpen: p
      }), /* @__PURE__ */ V.createElement(o, P({}, f, {
        isDisabled: C
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ V.createElement(r, P({}, f, {
        isDisabled: C
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, l) {
      var r = l.prevProps, c = l.clearFocusValueOnUpdate, o = l.inputIsHiddenAfterUpdate, s = l.ariaSelection, u = l.isFocused, d = l.prevWasFocused, C = l.instancePrefix, p = n.options, b = n.value, f = n.menuIsOpen, g = n.inputValue, h = n.isMulti, S = Zi(b), E = {};
      if (r && (b !== r.value || p !== r.options || f !== r.menuIsOpen || g !== r.inputValue)) {
        var A = f ? Hc(n, S) : [], I = f ? oa(qt(n, S), "".concat(C, "-option")) : [], w = c ? Uc(l, S) : null, T = Vc(l, A), x = Mn(I, T);
        E = {
          selectValue: S,
          focusedOption: T,
          focusedOptionId: x,
          focusableOptionsWithIds: I,
          focusedValue: w,
          clearFocusValueOnUpdate: !1
        };
      }
      var O = o != null && n !== r ? {
        inputIsHidden: o,
        inputIsHiddenAfterUpdate: void 0
      } : {}, W = s, M = u && d;
      return u && !M && (W = {
        value: zt(h, S, S[0] || null),
        options: S,
        action: "initial-input-focus"
      }, M = !d), s?.action === "initial-input-focus" && (W = null), F(F(F({}, E), O), {}, {
        prevProps: n,
        ariaSelection: W,
        prevWasFocused: M
      });
    }
  }]), i;
}(kl);
gl.defaultProps = Dc;
var Xc = /* @__PURE__ */ Ia(function(t, e) {
  var i = Ql(t);
  return /* @__PURE__ */ V.createElement(gl, P({
    ref: e
  }, i));
}), Zc = Xc;
const zc = ({
  label: t,
  className: e,
  onBlur: i,
  value: a,
  onChange: n,
  onFocus: l,
  isSelected: r,
  isMulti: c,
  isSearchable: o,
  ariaLabel: s,
  isClearable: u,
  isDisabled: d,
  isLoading: C,
  placeholder: p,
  header: b,
  firstHint: f,
  secondHint: g,
  systemMsg: h,
  hasErrored: S,
  defaultValue: E,
  options: A
}) => {
  const [I, w] = te(null), M = [
    "ajbl-select",
    c ? "basic-multi-select" : "basic-single",
    r ? "ajbl-select--selected" : null,
    S ? "ajbl-select--error" : null,
    d ? "ajbl-select--disabled" : null,
    e
  ], L = (z, k) => {
    typeof n == "function" && n(z, k), Array.isArray(z) && w(z ?? I);
  }, H = () => {
    typeof i == "function" && i();
  }, K = () => {
    typeof l == "function" && l();
  };
  return /* @__PURE__ */ D("div", { "data-testid": "select-container", className: he(M), children: [
    /* @__PURE__ */ v(
      "label",
      {
        className: he("ajbl-select__label", { hidden: !b }),
        htmlFor: t,
        children: b
      }
    ),
    f && /* @__PURE__ */ v("p", { className: "ajbl-select__hint", children: f }),
    h && /* @__PURE__ */ v("p", { className: "ajbl-select__sysmsg", children: h }),
    /* @__PURE__ */ v(
      Zc,
      {
        defaultValue: E,
        isMulti: c,
        name: t,
        options: A,
        classNamePrefix: "select",
        value: a,
        onChange: L,
        isClearable: u,
        onBlur: H,
        onFocus: K,
        isSearchable: o,
        isDisabled: d,
        isLoading: C,
        placeholder: p,
        "aria-label": s
      }
    ),
    g && /* @__PURE__ */ v("p", { className: "ajbl-select__hint", children: g })
  ] });
}, Jc = ({
  options: t,
  onChange: e,
  onClick: i,
  showSelectedOptions: a,
  placeholder: n = "Select options",
  isSelected: l,
  ariaLabel: r,
  isDisabled: c,
  label: o,
  header: s,
  firstHint: u,
  secondHint: d,
  systemMsg: C,
  hasErrored: p,
  className: b,
  isMulti: f = !0,
  isSectionBased: g,
  forceChecked: h,
  indicateWhenOptionSelected: S,
  presetOption: E,
  presetOptions: A,
  keyboardNavRestrictionContainer: I
}) => {
  const [w, T] = te(!1), [x, O] = te(!1), [W, M] = te([]), [L, H] = te([]), [K, z] = te(0), [k, oe] = te(0), [re, fe] = te(!1), ie = Ue(null), X = Ue(null), j = l || x ? "ajbl-checkselect--selected" : null, U = p ? "ajbl-checkselect--error" : null, Y = c ? "ajbl-checkselect--disabled" : null, J = 50, de = [
    "ajbl-checkselect",
    j,
    U,
    Y,
    b
  ], Ae = (R) => {
    pe(R.clientX), typeof i == "function" && i();
  }, pe = (R) => {
    fe(R > window.innerWidth / 2), K === k && (c || (z(K + 1), H(W), T(!w), setTimeout(() => {
      const ae = ie.current?.querySelector(
        'input[type="checkbox"]'
      );
      ae && ae.focus();
    }, 100)));
  }, Le = (R) => {
    const se = ((ke) => ke?.getBoundingClientRect().left ?? 0)(R?.currentTarget ?? 0), Se = () => {
      R.preventDefault(), pe(se), typeof i == "function" && i();
    };
    switch (R.key) {
      case "ArrowLeft":
        R.preventDefault(), T(!1), setTimeout(() => {
          Fe.Prev({ keyboardNavRestrictionContainer: I });
        }, 0);
        break;
      case "ArrowRight":
        R.preventDefault(), T(!1), setTimeout(() => {
          Fe.Next({ keyboardNavRestrictionContainer: I });
        }, 0);
        break;
      case "ArrowUp":
        R.preventDefault(), pe(se);
        break;
      case "ArrowDown":
        Se();
        break;
      case "Enter":
        Se();
        break;
      case "Space":
        Se();
        break;
    }
  }, Ye = (R) => {
    const ae = R.currentTarget.classList.contains(
      "ajbl-checkselect__save"
    ), se = () => {
      R.preventDefault();
      const Se = ae ? "button:not(.ajbl-checkselect__save)" : "button.ajbl-checkselect__save", ke = ie.current?.querySelector(Se);
      ke && setTimeout(() => {
        ke.focus();
      }, 100);
    };
    switch (R.code) {
      case "ArrowLeft":
        se();
        break;
      case "ArrowRight":
        se();
        break;
      case "ArrowUp":
        se();
        break;
      case "ArrowDown":
        se();
        break;
      case "Tab":
        ae && T(!1);
        break;
    }
  }, je = (R, ae) => {
    const se = (Se) => {
      if (X.current) {
        X.current.focus();
        const ot = (Se === "next" ? X.current.parentElement?.parentElement?.nextElementSibling : X.current.parentElement?.parentElement?.previousElementSibling)?.querySelector(
          ".ajbl-checkselect__select-box"
        );
        ot && (ot.focus(), ot.click());
      }
      T(!1);
    };
    switch (R.code) {
      case "ArrowLeft":
        R.preventDefault(), X.current?.focus(), se("prev");
        break;
      case "ArrowRight":
        R.preventDefault(), X.current?.focus(), se("next");
        break;
      case "ArrowUp":
        R.preventDefault(), Fe.Prev({ keyboardNavRestrictionContainer: I });
        break;
      case "ArrowDown":
        R.preventDefault(), Fe.Next({ keyboardNavRestrictionContainer: I });
        break;
      case "Enter":
        G(ae);
        break;
      case "Space":
        G(ae);
        break;
      case "Tab": {
        R.preventDefault();
        const Se = ie.current?.querySelector(
          ".ajbl-checkselect__save"
        );
        Se && Se.focus();
        break;
      }
      case "Escape":
        X.current?.focus(), T(!1);
        break;
    }
  }, G = (R) => {
    if (!f) {
      M([]), H([R]);
      return;
    }
    if (g && L.find((ae) => ae.section === R.section)) {
      const ae = L.filter(
        (se) => se.section !== R.section
      );
      H([...ae, R]);
      return;
    }
    L.find((ae) => ae?.value === R?.value) ? H(
      L.filter((ae) => ae?.value !== R?.value)
    ) : H([...L, R]);
  }, Pe = () => {
    H([]);
  }, be = () => {
    M(L), T(!1), e && e(L);
  }, Ne = (R) => {
    ie.current && !ie.current.contains(R.target) && T(!1);
  };
  ne(() => (oe(k + 1), w ? document.addEventListener("mousedown", Ne) : (document.removeEventListener("mousedown", Ne), oe(0), setTimeout(() => {
    z(0);
  }, 500)), () => {
    document.removeEventListener("mousedown", Ne);
  }), [w]), ne(() => {
    h === !1 && (M([]), H([]));
  }, [h]), ne(() => {
    S && (W.length > 0 ? O(!0) : O(!1));
  }, [
    x,
    L,
    W,
    S
  ]), ne(() => {
    E ? (M([E]), H([E])) : (M([]), H([]));
  }, [E]), ne(() => {
    A ? (M(A), H(A)) : (M([]), H([]));
  }, [A]);
  const vt = (R) => typeof R.label == "string" ? R.label : R?.value, at = W.length && a ? W.map(vt).join(", ") : n;
  return /* @__PURE__ */ D(
    "div",
    {
      "data-testid": "checkselect-container",
      className: he(de, {
        "ajbl-checkselect--right-side": re
      }),
      children: [
        s && /* @__PURE__ */ v("label", { className: "ajbl-checkselect__label", htmlFor: o, children: s }),
        u && /* @__PURE__ */ v("p", { className: "ajbl-checkselect__hint", children: u }),
        C && /* @__PURE__ */ v("p", { className: "ajbl-checkselect__sysmsg", children: C }),
        /* @__PURE__ */ D("div", { className: "ajbl-checkselect__option-display", children: [
          /* @__PURE__ */ D(
            "div",
            {
              ref: X,
              onClick: Ae,
              onKeyDown: Le,
              className: "ajbl-checkselect__select-box",
              tabIndex: 0,
              role: "combobox",
              "aria-haspopup": "listbox",
              "aria-expanded": w ? "true" : "false",
              "aria-label": r,
              id: o,
              children: [
                at,
                /* @__PURE__ */ v(
                  "span",
                  {
                    className: `ajbl-checkselect__arrow ${w ? "open" : ""}`
                  }
                )
              ]
            }
          ),
          w && /* @__PURE__ */ D(
            "div",
            {
              className: `ajbl-checkselect__dropdown ${t !== void 0 && t?.length > J ? "ajbl-checkselect__dropdown--big-list" : ""}`,
              role: "list",
              ref: ie,
              children: [
                /* @__PURE__ */ v(
                  "div",
                  {
                    className: "ajbl-checkselect__options-list oxum-flex oxum-flex-wrap",
                    "aria-labelledby": o,
                    role: "listbox",
                    children: t?.map((R, ae) => {
                      if ("content" in R)
                        return /* @__PURE__ */ v(
                          "div",
                          {
                            className: "ajbl-checkselect__custom-content oxum-w-full",
                            role: "option",
                            children: R.content
                          },
                          `content-${ae}`
                        );
                      {
                        const se = R, Se = h ?? L?.some(
                          (ke) => wa(ke?.value, se?.value)
                        );
                        return /* @__PURE__ */ D(
                          "label",
                          {
                            className: "ajbl-checkselect__option",
                            role: "option",
                            children: [
                              /* @__PURE__ */ v(
                                "input",
                                {
                                  type: "checkbox",
                                  "aria-label": `${se.label} check box`,
                                  checked: Se,
                                  onChange: () => G(se),
                                  onKeyDown: (ke) => je(ke, se)
                                }
                              ),
                              /* @__PURE__ */ v("span", { className: "custom-checkbox" }),
                              /* @__PURE__ */ v("span", { className: "ajbl-checkselect__option-item", children: se.label })
                            ]
                          },
                          se?.value
                        );
                      }
                    })
                  }
                ),
                /* @__PURE__ */ D("div", { className: "ajbl-checkselect__dropdown-actions", children: [
                  /* @__PURE__ */ v(
                    "button",
                    {
                      className: "ajbl-checkselect__clear-all oxum-mx-2",
                      onClick: Pe,
                      onKeyDown: (R) => {
                        Ye(
                          R
                        );
                      },
                      type: "button",
                      children: "Clear All"
                    }
                  ),
                  /* @__PURE__ */ v(
                    Ve,
                    {
                      chevron: "right",
                      chevronSide: "right",
                      className: "ajbl-checkselect__save oxum-mx-2",
                      onKeyDown: (R) => {
                        Ye(
                          R
                        );
                      },
                      onClick: be,
                      children: "Save"
                    }
                  )
                ] })
              ]
            }
          )
        ] }),
        d && /* @__PURE__ */ v("p", { className: "ajbl-checkselect__hint", children: d })
      ]
    }
  );
}, Yc = [
  {
    link: {
      link_path: "",
      link_title: "Default Title",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !1,
    below: []
  }
], hl = {
  navState: Yc,
  subNavVisibility: !1,
  headerSearchVisibility: !1,
  mobileSubNavVisibility: !1,
  activeUser: void 0,
  accountData: void 0,
  blockedURLs: []
}, jc = (t, e) => {
  switch (e.type) {
    case "setHeaderPayload":
      return { ...t, navState: e.payload };
    case "setSubNavVisibility":
      return { ...t, subNavVisibility: e.payload };
    case "setHeaderSearchVisibility":
      return { ...t, headerSearchVisibility: e.payload };
    case "setMobileSubNavVisibility":
      return { ...t, mobileSubNavVisibility: e.payload };
    case "setActiveUser":
      return { ...t, activeUser: e.payload };
    case "setAccountData":
      return { ...t, accountData: e.payload };
    case "setBlockedURLs":
      return { ...t, blockedURLs: e.payload };
    default:
      return t;
  }
}, bl = Jn({
  state: hl,
  dispatch: () => {
  }
}), $c = ({
  children: t
}) => {
  const [e, i] = Ca(jc, hl);
  return /* @__PURE__ */ v(bl.Provider, { value: { state: e, dispatch: i }, children: t });
}, it = () => {
  const t = dn(bl);
  if (!t)
    throw new Error("useMegaNav must be used within an MegaNavProvider");
  return t;
}, st = {
  XSM: 375,
  SM: 640,
  MD: 768,
  LG: 1024,
  ML: 1180,
  XL: 1280,
  XXL: 1500
}, He = "My account", vl = {
  DEALING: 1,
  ISA: 3,
  SIPP: 2,
  JISA: 4,
  JSIPP: 5,
  LISA: 8,
  MEMO_ASSETS: 9,
  RAISIN: 10
};
/*! @license DOMPurify 3.2.0 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.0/LICENSE */
const {
  entries: Il,
  setPrototypeOf: sa,
  isFrozen: Qc,
  getPrototypeOf: Kc,
  getOwnPropertyDescriptor: qc
} = Object;
let {
  freeze: xe,
  seal: Oe,
  create: Cl
} = Object, {
  apply: Zn,
  construct: zn
} = typeof Reflect < "u" && Reflect;
xe || (xe = function(e) {
  return e;
});
Oe || (Oe = function(e) {
  return e;
});
Zn || (Zn = function(e, i, a) {
  return e.apply(i, a);
});
zn || (zn = function(e, i) {
  return new e(...i);
});
const Jt = _e(Array.prototype.forEach), ca = _e(Array.prototype.pop), St = _e(Array.prototype.push), en = _e(String.prototype.toLowerCase), Bn = _e(String.prototype.toString), ua = _e(String.prototype.match), yt = _e(String.prototype.replace), eu = _e(String.prototype.indexOf), tu = _e(String.prototype.trim), Re = _e(Object.prototype.hasOwnProperty), we = _e(RegExp.prototype.test), wt = nu(TypeError);
function _e(t) {
  return function(e) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), n = 1; n < i; n++)
      a[n - 1] = arguments[n];
    return Zn(t, e, a);
  };
}
function nu(t) {
  return function() {
    for (var e = arguments.length, i = new Array(e), a = 0; a < e; a++)
      i[a] = arguments[a];
    return zn(t, i);
  };
}
function Z(t, e) {
  let i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : en;
  sa && sa(t, null);
  let a = e.length;
  for (; a--; ) {
    let n = e[a];
    if (typeof n == "string") {
      const l = i(n);
      l !== n && (Qc(e) || (e[a] = l), n = l);
    }
    t[n] = !0;
  }
  return t;
}
function iu(t) {
  for (let e = 0; e < t.length; e++)
    Re(t, e) || (t[e] = null);
  return t;
}
function rt(t) {
  const e = Cl(null);
  for (const [i, a] of Il(t))
    Re(t, i) && (Array.isArray(a) ? e[i] = iu(a) : a && typeof a == "object" && a.constructor === Object ? e[i] = rt(a) : e[i] = a);
  return e;
}
function xt(t, e) {
  for (; t !== null; ) {
    const a = qc(t, e);
    if (a) {
      if (a.get)
        return _e(a.get);
      if (typeof a.value == "function")
        return _e(a.value);
    }
    t = Kc(t);
  }
  function i() {
    return null;
  }
  return i;
}
const da = xe(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), _n = xe(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Ln = xe(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), au = xe(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Nn = xe(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), lu = xe(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), ma = xe(["#text"]), fa = xe(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Fn = xe(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), pa = xe(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Yt = xe(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), ou = Oe(/\{\{[\w\W]*|[\w\W]*\}\}/gm), ru = Oe(/<%[\w\W]*|[\w\W]*%>/gm), su = Oe(/\${[\w\W]*}/gm), cu = Oe(/^data-[\-\w.\u00B7-\uFFFF]/), uu = Oe(/^aria-[\-\w]+$/), Al = Oe(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), du = Oe(/^(?:\w+script|data):/i), mu = Oe(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), El = Oe(/^html$/i), fu = Oe(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ga = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: uu,
  ATTR_WHITESPACE: mu,
  CUSTOM_ELEMENT: fu,
  DATA_ATTR: cu,
  DOCTYPE_NAME: El,
  ERB_EXPR: ru,
  IS_ALLOWED_URI: Al,
  IS_SCRIPT_OR_DATA: du,
  MUSTACHE_EXPR: ou,
  TMPLIT_EXPR: su
});
const Gt = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, pu = function() {
  return typeof window > "u" ? null : window;
}, gu = function(e, i) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let a = null;
  const n = "data-tt-policy-suffix";
  i && i.hasAttribute(n) && (a = i.getAttribute(n));
  const l = "dompurify" + (a ? "#" + a : "");
  try {
    return e.createPolicy(l, {
      createHTML(r) {
        return r;
      },
      createScriptURL(r) {
        return r;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + l + " could not be created."), null;
  }
};
function Tl() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : pu();
  const e = (_) => Tl(_);
  if (e.version = "3.2.0", e.removed = [], !t || !t.document || t.document.nodeType !== Gt.document)
    return e.isSupported = !1, e;
  let {
    document: i
  } = t;
  const a = i, n = a.currentScript, {
    DocumentFragment: l,
    HTMLTemplateElement: r,
    Node: c,
    Element: o,
    NodeFilter: s,
    NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: C,
    trustedTypes: p
  } = t, b = o.prototype, f = xt(b, "cloneNode"), g = xt(b, "remove"), h = xt(b, "nextSibling"), S = xt(b, "childNodes"), E = xt(b, "parentNode");
  if (typeof r == "function") {
    const _ = i.createElement("template");
    _.content && _.content.ownerDocument && (i = _.content.ownerDocument);
  }
  let A, I = "";
  const {
    implementation: w,
    createNodeIterator: T,
    createDocumentFragment: x,
    getElementsByTagName: O
  } = i, {
    importNode: W
  } = a;
  let M = {};
  e.isSupported = typeof Il == "function" && typeof E == "function" && w && w.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: L,
    ERB_EXPR: H,
    TMPLIT_EXPR: K,
    DATA_ATTR: z,
    ARIA_ATTR: k,
    IS_SCRIPT_OR_DATA: oe,
    ATTR_WHITESPACE: re,
    CUSTOM_ELEMENT: fe
  } = ga;
  let {
    IS_ALLOWED_URI: ie
  } = ga, X = null;
  const j = Z({}, [...da, ..._n, ...Ln, ...Nn, ...ma]);
  let U = null;
  const Y = Z({}, [...fa, ...Fn, ...pa, ...Yt]);
  let J = Object.seal(Cl(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), de = null, Ae = null, pe = !0, Le = !0, Ye = !1, je = !0, G = !1, Pe = !0, be = !1, Ne = !1, vt = !1, at = !1, R = !1, ae = !1, se = !0, Se = !1;
  const ke = "user-content-";
  let ot = !0, It = !1, ut = {}, dt = null;
  const di = Z({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let mi = null;
  const fi = Z({}, ["audio", "video", "img", "source", "image", "track"]);
  let vn = null;
  const pi = Z({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), kt = "http://www.w3.org/1998/Math/MathML", Rt = "http://www.w3.org/2000/svg", $e = "http://www.w3.org/1999/xhtml";
  let mt = $e, In = !1, Cn = null;
  const Ml = Z({}, [kt, Rt, $e], Bn);
  let Dt = Z({}, ["mi", "mo", "mn", "ms", "mtext"]), Ht = Z({}, ["annotation-xml"]);
  const Bl = Z({}, ["title", "style", "font", "a", "script"]);
  let Ct = null;
  const _l = ["application/xhtml+xml", "text/html"], Ll = "text/html";
  let ge = null, ft = null;
  const Nl = i.createElement("form"), gi = function(m) {
    return m instanceof RegExp || m instanceof Function;
  }, An = function() {
    let m = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(ft && ft === m)) {
      if ((!m || typeof m != "object") && (m = {}), m = rt(m), Ct = // eslint-disable-next-line unicorn/prefer-includes
      _l.indexOf(m.PARSER_MEDIA_TYPE) === -1 ? Ll : m.PARSER_MEDIA_TYPE, ge = Ct === "application/xhtml+xml" ? Bn : en, X = Re(m, "ALLOWED_TAGS") ? Z({}, m.ALLOWED_TAGS, ge) : j, U = Re(m, "ALLOWED_ATTR") ? Z({}, m.ALLOWED_ATTR, ge) : Y, Cn = Re(m, "ALLOWED_NAMESPACES") ? Z({}, m.ALLOWED_NAMESPACES, Bn) : Ml, vn = Re(m, "ADD_URI_SAFE_ATTR") ? Z(rt(pi), m.ADD_URI_SAFE_ATTR, ge) : pi, mi = Re(m, "ADD_DATA_URI_TAGS") ? Z(rt(fi), m.ADD_DATA_URI_TAGS, ge) : fi, dt = Re(m, "FORBID_CONTENTS") ? Z({}, m.FORBID_CONTENTS, ge) : di, de = Re(m, "FORBID_TAGS") ? Z({}, m.FORBID_TAGS, ge) : {}, Ae = Re(m, "FORBID_ATTR") ? Z({}, m.FORBID_ATTR, ge) : {}, ut = Re(m, "USE_PROFILES") ? m.USE_PROFILES : !1, pe = m.ALLOW_ARIA_ATTR !== !1, Le = m.ALLOW_DATA_ATTR !== !1, Ye = m.ALLOW_UNKNOWN_PROTOCOLS || !1, je = m.ALLOW_SELF_CLOSE_IN_ATTR !== !1, G = m.SAFE_FOR_TEMPLATES || !1, Pe = m.SAFE_FOR_XML !== !1, be = m.WHOLE_DOCUMENT || !1, at = m.RETURN_DOM || !1, R = m.RETURN_DOM_FRAGMENT || !1, ae = m.RETURN_TRUSTED_TYPE || !1, vt = m.FORCE_BODY || !1, se = m.SANITIZE_DOM !== !1, Se = m.SANITIZE_NAMED_PROPS || !1, ot = m.KEEP_CONTENT !== !1, It = m.IN_PLACE || !1, ie = m.ALLOWED_URI_REGEXP || Al, mt = m.NAMESPACE || $e, Dt = m.MATHML_TEXT_INTEGRATION_POINTS || Dt, Ht = m.HTML_INTEGRATION_POINTS || Ht, J = m.CUSTOM_ELEMENT_HANDLING || {}, m.CUSTOM_ELEMENT_HANDLING && gi(m.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (J.tagNameCheck = m.CUSTOM_ELEMENT_HANDLING.tagNameCheck), m.CUSTOM_ELEMENT_HANDLING && gi(m.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (J.attributeNameCheck = m.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), m.CUSTOM_ELEMENT_HANDLING && typeof m.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (J.allowCustomizedBuiltInElements = m.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), G && (Le = !1), R && (at = !0), ut && (X = Z({}, ma), U = [], ut.html === !0 && (Z(X, da), Z(U, fa)), ut.svg === !0 && (Z(X, _n), Z(U, Fn), Z(U, Yt)), ut.svgFilters === !0 && (Z(X, Ln), Z(U, Fn), Z(U, Yt)), ut.mathMl === !0 && (Z(X, Nn), Z(U, pa), Z(U, Yt))), m.ADD_TAGS && (X === j && (X = rt(X)), Z(X, m.ADD_TAGS, ge)), m.ADD_ATTR && (U === Y && (U = rt(U)), Z(U, m.ADD_ATTR, ge)), m.ADD_URI_SAFE_ATTR && Z(vn, m.ADD_URI_SAFE_ATTR, ge), m.FORBID_CONTENTS && (dt === di && (dt = rt(dt)), Z(dt, m.FORBID_CONTENTS, ge)), ot && (X["#text"] = !0), be && Z(X, ["html", "head", "body"]), X.table && (Z(X, ["tbody"]), delete de.tbody), m.TRUSTED_TYPES_POLICY) {
        if (typeof m.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw wt('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof m.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw wt('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        A = m.TRUSTED_TYPES_POLICY, I = A.createHTML("");
      } else
        A === void 0 && (A = gu(p, n)), A !== null && typeof I == "string" && (I = A.createHTML(""));
      xe && xe(m), ft = m;
    }
  }, hi = Z({}, [..._n, ...Ln, ...au]), bi = Z({}, [...Nn, ...lu]), Fl = function(m) {
    let y = E(m);
    (!y || !y.tagName) && (y = {
      namespaceURI: mt,
      tagName: "template"
    });
    const B = en(m.tagName), le = en(y.tagName);
    return Cn[m.namespaceURI] ? m.namespaceURI === Rt ? y.namespaceURI === $e ? B === "svg" : y.namespaceURI === kt ? B === "svg" && (le === "annotation-xml" || Dt[le]) : !!hi[B] : m.namespaceURI === kt ? y.namespaceURI === $e ? B === "math" : y.namespaceURI === Rt ? B === "math" && Ht[le] : !!bi[B] : m.namespaceURI === $e ? y.namespaceURI === Rt && !Ht[le] || y.namespaceURI === kt && !Dt[le] ? !1 : !bi[B] && (Bl[B] || !hi[B]) : !!(Ct === "application/xhtml+xml" && Cn[m.namespaceURI]) : !1;
  }, We = function(m) {
    St(e.removed, {
      element: m
    });
    try {
      E(m).removeChild(m);
    } catch {
      g(m);
    }
  }, Ut = function(m, y) {
    try {
      St(e.removed, {
        attribute: y.getAttributeNode(m),
        from: y
      });
    } catch {
      St(e.removed, {
        attribute: null,
        from: y
      });
    }
    if (y.removeAttribute(m), m === "is" && !U[m])
      if (at || R)
        try {
          We(y);
        } catch {
        }
      else
        try {
          y.setAttribute(m, "");
        } catch {
        }
  }, vi = function(m) {
    let y = null, B = null;
    if (vt)
      m = "<remove></remove>" + m;
    else {
      const ve = ua(m, /^[\r\n\t ]+/);
      B = ve && ve[0];
    }
    Ct === "application/xhtml+xml" && mt === $e && (m = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + m + "</body></html>");
    const le = A ? A.createHTML(m) : m;
    if (mt === $e)
      try {
        y = new C().parseFromString(le, Ct);
      } catch {
      }
    if (!y || !y.documentElement) {
      y = w.createDocument(mt, "template", null);
      try {
        y.documentElement.innerHTML = In ? I : le;
      } catch {
      }
    }
    const Ee = y.body || y.documentElement;
    return m && B && Ee.insertBefore(i.createTextNode(B), Ee.childNodes[0] || null), mt === $e ? O.call(y, be ? "html" : "body")[0] : be ? y.documentElement : Ee;
  }, Ii = function(m) {
    return T.call(
      m.ownerDocument || m,
      m,
      // eslint-disable-next-line no-bitwise
      s.SHOW_ELEMENT | s.SHOW_COMMENT | s.SHOW_TEXT | s.SHOW_PROCESSING_INSTRUCTION | s.SHOW_CDATA_SECTION,
      null
    );
  }, Ci = function(m) {
    return m instanceof d && (typeof m.nodeName != "string" || typeof m.textContent != "string" || typeof m.removeChild != "function" || !(m.attributes instanceof u) || typeof m.removeAttribute != "function" || typeof m.setAttribute != "function" || typeof m.namespaceURI != "string" || typeof m.insertBefore != "function" || typeof m.hasChildNodes != "function");
  }, Ai = function(m) {
    return typeof c == "function" && m instanceof c;
  };
  function Qe(_, m, y) {
    M[_] && Jt(M[_], (B) => {
      B.call(e, m, y, ft);
    });
  }
  const Ei = function(m) {
    let y = null;
    if (Qe("beforeSanitizeElements", m, null), Ci(m))
      return We(m), !0;
    const B = ge(m.nodeName);
    if (Qe("uponSanitizeElement", m, {
      tagName: B,
      allowedTags: X
    }), m.hasChildNodes() && !Ai(m.firstElementChild) && we(/<[/\w]/g, m.innerHTML) && we(/<[/\w]/g, m.textContent) || m.nodeType === Gt.progressingInstruction || Pe && m.nodeType === Gt.comment && we(/<[/\w]/g, m.data))
      return We(m), !0;
    if (!X[B] || de[B]) {
      if (!de[B] && Si(B) && (J.tagNameCheck instanceof RegExp && we(J.tagNameCheck, B) || J.tagNameCheck instanceof Function && J.tagNameCheck(B)))
        return !1;
      if (ot && !dt[B]) {
        const le = E(m) || m.parentNode, Ee = S(m) || m.childNodes;
        if (Ee && le) {
          const ve = Ee.length;
          for (let Ge = ve - 1; Ge >= 0; --Ge) {
            const Xe = f(Ee[Ge], !0);
            Xe.__removalCount = (m.__removalCount || 0) + 1, le.insertBefore(Xe, h(m));
          }
        }
      }
      return We(m), !0;
    }
    return m instanceof o && !Fl(m) || (B === "noscript" || B === "noembed" || B === "noframes") && we(/<\/no(script|embed|frames)/i, m.innerHTML) ? (We(m), !0) : (G && m.nodeType === Gt.text && (y = m.textContent, Jt([L, H, K], (le) => {
      y = yt(y, le, " ");
    }), m.textContent !== y && (St(e.removed, {
      element: m.cloneNode()
    }), m.textContent = y)), Qe("afterSanitizeElements", m, null), !1);
  }, Ti = function(m, y, B) {
    if (se && (y === "id" || y === "name") && (B in i || B in Nl))
      return !1;
    if (!(Le && !Ae[y] && we(z, y))) {
      if (!(pe && we(k, y))) {
        if (!U[y] || Ae[y]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Si(m) && (J.tagNameCheck instanceof RegExp && we(J.tagNameCheck, m) || J.tagNameCheck instanceof Function && J.tagNameCheck(m)) && (J.attributeNameCheck instanceof RegExp && we(J.attributeNameCheck, y) || J.attributeNameCheck instanceof Function && J.attributeNameCheck(y)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            y === "is" && J.allowCustomizedBuiltInElements && (J.tagNameCheck instanceof RegExp && we(J.tagNameCheck, B) || J.tagNameCheck instanceof Function && J.tagNameCheck(B)))
          ) return !1;
        } else if (!vn[y]) {
          if (!we(ie, yt(B, re, ""))) {
            if (!((y === "src" || y === "xlink:href" || y === "href") && m !== "script" && eu(B, "data:") === 0 && mi[m])) {
              if (!(Ye && !we(oe, yt(B, re, "")))) {
                if (B)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Si = function(m) {
    return m !== "annotation-xml" && ua(m, fe);
  }, yi = function(m) {
    Qe("beforeSanitizeAttributes", m, null);
    const {
      attributes: y
    } = m;
    if (!y)
      return;
    const B = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: U,
      forceKeepAttr: void 0
    };
    let le = y.length;
    for (; le--; ) {
      const Ee = y[le], {
        name: ve,
        namespaceURI: Ge,
        value: Xe
      } = Ee, At = ge(ve);
      let ye = ve === "value" ? Xe : tu(Xe);
      if (B.attrName = At, B.attrValue = ye, B.keepAttr = !0, B.forceKeepAttr = void 0, Qe("uponSanitizeAttribute", m, B), ye = B.attrValue, Se && (At === "id" || At === "name") && (Ut(ve, m), ye = ke + ye), Pe && we(/((--!?|])>)|<\/(style|title)/i, ye)) {
        Ut(ve, m);
        continue;
      }
      if (B.forceKeepAttr || (Ut(ve, m), !B.keepAttr))
        continue;
      if (!je && we(/\/>/i, ye)) {
        Ut(ve, m);
        continue;
      }
      G && Jt([L, H, K], (xi) => {
        ye = yt(ye, xi, " ");
      });
      const wi = ge(m.nodeName);
      if (Ti(wi, At, ye)) {
        if (A && typeof p == "object" && typeof p.getAttributeType == "function" && !Ge)
          switch (p.getAttributeType(wi, At)) {
            case "TrustedHTML": {
              ye = A.createHTML(ye);
              break;
            }
            case "TrustedScriptURL": {
              ye = A.createScriptURL(ye);
              break;
            }
          }
        try {
          Ge ? m.setAttributeNS(Ge, ve, ye) : m.setAttribute(ve, ye), Ci(m) ? We(m) : ca(e.removed);
        } catch {
        }
      }
    }
    Qe("afterSanitizeAttributes", m, null);
  }, Ol = function _(m) {
    let y = null;
    const B = Ii(m);
    for (Qe("beforeSanitizeShadowDOM", m, null); y = B.nextNode(); )
      Qe("uponSanitizeShadowNode", y, null), !Ei(y) && (y.content instanceof l && _(y.content), yi(y));
    Qe("afterSanitizeShadowDOM", m, null);
  };
  return e.sanitize = function(_) {
    let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, y = null, B = null, le = null, Ee = null;
    if (In = !_, In && (_ = "<!-->"), typeof _ != "string" && !Ai(_))
      if (typeof _.toString == "function") {
        if (_ = _.toString(), typeof _ != "string")
          throw wt("dirty is not a string, aborting");
      } else
        throw wt("toString is not a function");
    if (!e.isSupported)
      return _;
    if (Ne || An(m), e.removed = [], typeof _ == "string" && (It = !1), It) {
      if (_.nodeName) {
        const Xe = ge(_.nodeName);
        if (!X[Xe] || de[Xe])
          throw wt("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (_ instanceof c)
      y = vi("<!---->"), B = y.ownerDocument.importNode(_, !0), B.nodeType === Gt.element && B.nodeName === "BODY" || B.nodeName === "HTML" ? y = B : y.appendChild(B);
    else {
      if (!at && !G && !be && // eslint-disable-next-line unicorn/prefer-includes
      _.indexOf("<") === -1)
        return A && ae ? A.createHTML(_) : _;
      if (y = vi(_), !y)
        return at ? null : ae ? I : "";
    }
    y && vt && We(y.firstChild);
    const ve = Ii(It ? _ : y);
    for (; le = ve.nextNode(); )
      Ei(le) || (le.content instanceof l && Ol(le.content), yi(le));
    if (It)
      return _;
    if (at) {
      if (R)
        for (Ee = x.call(y.ownerDocument); y.firstChild; )
          Ee.appendChild(y.firstChild);
      else
        Ee = y;
      return (U.shadowroot || U.shadowrootmode) && (Ee = W.call(a, Ee, !0)), Ee;
    }
    let Ge = be ? y.outerHTML : y.innerHTML;
    return be && X["!doctype"] && y.ownerDocument && y.ownerDocument.doctype && y.ownerDocument.doctype.name && we(El, y.ownerDocument.doctype.name) && (Ge = "<!DOCTYPE " + y.ownerDocument.doctype.name + `>
` + Ge), G && Jt([L, H, K], (Xe) => {
      Ge = yt(Ge, Xe, " ");
    }), A && ae ? A.createHTML(Ge) : Ge;
  }, e.setConfig = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    An(_), Ne = !0;
  }, e.clearConfig = function() {
    ft = null, Ne = !1;
  }, e.isValidAttribute = function(_, m, y) {
    ft || An({});
    const B = ge(_), le = ge(m);
    return Ti(B, le, y);
  }, e.addHook = function(_, m) {
    typeof m == "function" && (M[_] = M[_] || [], St(M[_], m));
  }, e.removeHook = function(_) {
    if (M[_])
      return ca(M[_]);
  }, e.removeHooks = function(_) {
    M[_] && (M[_] = []);
  }, e.removeAllHooks = function() {
    M = {};
  }, e;
}
var hu = Tl();
const bn = (t, e = 0) => (t.forEach((i) => {
  i.tier = e, i.below && i.below.length > 0 && bn(i.below, e + 1);
}), t), Ot = (t, e) => {
  const i = (l, r) => JSON.stringify(l) === JSON.stringify(r);
  if (t.some((l) => i(l, e)))
    return t;
  const n = t.findIndex(
    (l) => l.tier === e.tier
  );
  n !== -1 ? t[n] = e : t.push(e);
  for (let l = t.length - 1; l >= 0; l--) {
    const r = t[l].tier, c = e.tier;
    r !== void 0 && c !== void 0 && r > c && t.splice(l, 1);
  }
  return t;
}, bu = (t) => {
  if (t.length === 0)
    return t;
  const e = t.pop();
  if (!e || e.tier === void 0)
    return t;
  for (let i = t.length - 1; i >= 0; i--)
    t[i].tier !== void 0 && e.tier !== void 0 && (t[i].tier ?? 0) > e.tier && t.splice(i, 1);
  return t;
}, oi = (t) => {
  const e = [];
  return t.map((i) => {
    e.push(i.link.link_title);
  }), e;
}, ha = ({
  htmlString: t,
  element: e = "div"
}) => {
  const i = hu.sanitize(t);
  return /* @__PURE__ */ v(e, { dangerouslySetInnerHTML: { __html: i } });
}, ri = (t, e) => t.map((i) => {
  if (e.includes(i.link.link_path))
    return null;
  let a;
  return i.below && i.below.length > 0 && (a = ri(i.below, e)), {
    ...i,
    below: a
  };
}).filter((i) => i !== null), ba = (t) => {
  const e = {};
  return Array.isArray(t.userData) ? (t.userData.forEach((i) => {
    const a = i.productType === vl.MEMO_ASSETS ? 2 : 1, n = i.number.slice(0, -a);
    e[n] || (e[n] = []), e[n].push(i);
  }), { ...t, userData: e }) : t;
}, un = () => {
  const t = document.querySelectorAll(".ajbl-mega-nav__sub-col");
  if (t.length === 0)
    return console.warn('No elements found with class "ajbl-mega-nav__sub-col".'), null;
  const i = t[t.length - 1].querySelector(
    ".nav-item"
  );
  if (!i)
    return console.warn(
      'No element with class "nav-item" found within the last "ajbl-mega-nav__sub-col".'
    ), null;
  i.focus();
}, si = {
  prefix: "fasr",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z"]
}, Sl = ({
  LinkComponent: t
}) => {
  const { state: e, dispatch: i } = it(), [a, n] = te(null), l = (s) => {
    let u = "", d = "";
    return s.productType === vl.MEMO_ASSETS ? (d = `/platform/mywealth?accountNo=${s.accountNumber}`, u = "My Wealth") : (d = `/platform/portfolio?accountNo=${s.accountNumber}`, u = `${s.serviceName}: ${s.currencySymbol ?? "£"}${Xl(s.totalValuation)}`), {
      ctaCopy: u,
      link: d
    };
  }, r = De(() => e.accountData ? Yn({
    data: e.accountData.userData,
    basketCount: e.accountData.basketCount ?? 0,
    secureMessageCount: e.accountData.secureMessageCount ?? 0
  }) : [], [e.accountData]), c = De(
    () => r.map((s) => ({
      label: s.fullName,
      value: s.accountID
    })),
    [r]
  );
  ne(() => {
    if (r.length !== 0)
      if (a) {
        const s = r.find(
          (u) => u.accountID === a.value
        );
        i({ type: "setActiveUser", payload: s ?? r[0] });
      } else {
        const s = r[0];
        n({
          label: s.fullName,
          value: s.accountID
        }), i({ type: "setActiveUser", payload: s });
      }
  }, [a, r]);
  const o = (s) => {
    n(s);
  };
  return /* @__PURE__ */ v(Ke, { children: e.accountData && /* @__PURE__ */ D("div", { className: "ajbl-mega-nav__sub-level__accounts-overview", children: [
    /* @__PURE__ */ D(
      qe,
      {
        noAnimation: !0,
        className: "mobile-account-close-btn",
        ariaLabel: "Close Menu",
        onClick: () => i({ type: "setMobileSubNavVisibility", payload: !1 }),
        children: [
          "Close menu",
          /* @__PURE__ */ v(ce, { icon: si })
        ]
      }
    ),
    /* @__PURE__ */ v("h4", { className: "oxum-pb-5", children: He }),
    c.length > 1 ? /* @__PURE__ */ v(
      zc,
      {
        options: c,
        value: a,
        placeholder: "Select User",
        label: "Account Users",
        isSearchable: !1,
        isMulti: !1,
        className: "ajbl-select--abs-dropdown oxum-inline-block oxum-w-full lg:oxum-w-3/12",
        onChange: o
      }
    ) : /* @__PURE__ */ D("span", { className: "oxum-text-sm oxum-text-black", children: [
      c[0].label,
      ":"
    ] }),
    e.activeUser?.services?.map(
      (s, u) => {
        const d = l(s);
        return /* @__PURE__ */ v(
          Ve,
          {
            noAnimation: !0,
            href: d.link,
            LinkComponent: t,
            theme: "light",
            className: "oxum-mt-4 oxum-block oxum-w-full oxum-font-bold lg:oxum-ml-3 lg:oxum-mt-0 lg:oxum-inline-block lg:oxum-w-auto",
            chevron: "right",
            chevronSide: "right",
            children: d.ctaCopy
          },
          u
        );
      }
    )
  ] }) });
}, vu = ({
  LinkComponent: t
}) => {
  const { state: e, dispatch: i } = it(), [a, n] = te(null), l = De(() => e.accountData ? Yn({
    data: e.accountData.userData,
    basketCount: e.accountData.basketCount ?? 0,
    secureMessageCount: e.accountData.secureMessageCount ?? 0
  }) : [], [e.accountData]);
  if (ne(() => {
    if (l.length !== 0)
      if (a) {
        const o = l?.find(
          (s) => s.accountID === a.value
        );
        i({ type: "setActiveUser", payload: o ?? l[0] });
      } else {
        const o = l[0];
        n({
          label: o.fullName,
          value: o.accountID
        }), i({ type: "setActiveUser", payload: o });
      }
  }, [a, l, i]), !e.subNavVisibility) return null;
  const r = e.navState.length > 3 ? "oxum-grid-cols-" + e.navState.length : "oxum-grid-cols-3", c = oi(e.navState);
  return /* @__PURE__ */ D(
    "div",
    {
      id: "mega-header-desktop-sub-nav",
      className: "ajbl-mega-nav__sub-level desktop-sub-nav oxum-w-full",
      children: [
        e.navState[0]?.link?.link_title === "My account" ? /* @__PURE__ */ D(Ke, { children: [
          /* @__PURE__ */ v(Sl, { LinkComponent: t }),
          /* @__PURE__ */ D(
            Ve,
            {
              theme: "light",
              noAnimation: !0,
              className: "ajbl-mega-nav__sub-level-close-btn",
              ariaLabel: "Close Menu",
              onClick: () => i({ type: "setSubNavVisibility", payload: !1 }),
              children: [
                "Close menu",
                /* @__PURE__ */ v(ce, { icon: si })
              ]
            }
          )
        ] }) : null,
        /* @__PURE__ */ v(
          "div",
          {
            role: "grid",
            className: `${r} oxum-grid oxum-gap-0 oxum-overflow-hidden`,
            children: e.navState.map((o, s) => {
              const { below: u, link: d, dropdownsubmenu: C } = o;
              if (d?.field_component?.length > 0 && !C) {
                const p = e.navState.length < 3 ? "oxum-col-span-2" : "oxum-col-span-1", b = d.field_component[0];
                return /* @__PURE__ */ v(
                  "div",
                  {
                    className: `ajbl-mega-nav__sub-field-content-col ${p}`,
                    children: /* @__PURE__ */ D("div", { className: "ajbl-mega-nav__field-text-content", children: [
                      /* @__PURE__ */ v(
                        ha,
                        {
                          htmlString: b.field_plain_title,
                          element: "h4"
                        }
                      ),
                      /* @__PURE__ */ v(
                        ha,
                        {
                          htmlString: b.field_text_content
                        }
                      )
                    ] })
                  },
                  s
                );
              }
              return !u || u.length === 0 ? null : /* @__PURE__ */ v("div", { role: "list", className: "ajbl-mega-nav__sub-col", children: u.map((p, b) => {
                const { link: f, dropdownsubmenu: g, below: h, tier: S } = p, E = c?.includes(f.link_title), A = (!f?.link_path || f?.link_path === "#") && g, I = f.link_path && !g || g && f.link_path !== "" && f.link_path !== "#", w = () => {
                  i({
                    type: "setHeaderPayload",
                    payload: Ot(e.navState, {
                      link: f,
                      dropdownsubmenu: g,
                      below: h,
                      tier: S
                    })
                  });
                }, T = () => {
                  const O = () => {
                    const W = e?.navState[e?.navState?.length - 1]?.link?.link_title, M = e?.navState?.length < 2 ? document.querySelectorAll(".desktop-nav .nav-item") : document.querySelectorAll(
                      ".desktop-sub-nav .nav-item"
                    );
                    Array.from(M).find((K) => K?.textContent?.trim() === W)?.focus(), i({
                      type: "setHeaderPayload",
                      payload: bu(e.navState)
                    }), i({
                      type: "setSubNavVisibility",
                      payload: !1
                    });
                  };
                  O(), f.link_path !== "" && f.link_path !== "#" && O();
                }, x = (O) => {
                  O.preventDefault();
                  const W = e?.navState[0]?.link?.link_title, M = document.querySelectorAll(
                    ".desktop-nav .nav-item"
                  ), H = Array.from(M).find((K) => K?.textContent?.trim() === W?.trim());
                  H?.focus(), H?.click();
                };
                return /* @__PURE__ */ D(
                  qe,
                  {
                    chevron: "right",
                    role: "listitem",
                    noAnimation: !0,
                    chevronSide: f.link_path && !g ? void 0 : "right",
                    variant: "tab",
                    ariaLabel: f.link_title,
                    href: f.link_path !== "" && f.link_path !== "#" ? f.link_path : void 0,
                    LinkComponent: t,
                    isSelected: E,
                    className: "ajbl-mega-nav__sub-item",
                    onFocus: f.link_path !== "" && f.link_path !== "#" ? w : void 0,
                    onHover: I ? w : void 0,
                    onClick: A ? w : void 0,
                    onKeyEnter: () => {
                      A && (w(), setTimeout(() => {
                        un();
                      }, 100));
                    },
                    onKeyCodeRight: () => {
                      w(), setTimeout(() => {
                        un();
                      }, 100);
                    },
                    onKeyEscape: T,
                    onKeyCodeLeft: T,
                    onKeyTab: (O) => {
                      O && x(O);
                    },
                    keyboardNavRestrictionContainer: ".ajbl-mega-nav__sub-col",
                    children: [
                      /* @__PURE__ */ v("span", { className: "sub-nav-title", children: f.link_title }),
                      f.showBasketCount && e.activeUser && e.activeUser.basketCount > 0 && /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__account-notifyier-count in-menu", children: e.activeUser.basketCount }),
                      f.showSecureMessagesCount && e.activeUser && e.activeUser.secureMessageCount > 0 && /* @__PURE__ */ v(
                        "div",
                        {
                          "aria-label": `You have ${e.activeUser.secureMessageCount} message${e.activeUser.secureMessageCount > 1 ? "s" : ""}`,
                          className: "ajbl-mega-nav__account-notifyier-count in-menu",
                          children: e.activeUser.secureMessageCount
                        }
                      )
                    ]
                  },
                  b
                );
              }) }, s);
            })
          }
        )
      ]
    }
  );
}, Iu = () => {
  const { state: t } = it();
  return t.headerSearchVisibility && /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__sub-level desktop-search-sub-nav oxum-w-full", children: /* @__PURE__ */ D("div", { className: "oxum-m-auto oxum-flex oxum-w-11/12 oxum-flex-wrap oxum-py-20 xl:oxum-w-2/3", children: [
    /* @__PURE__ */ D("div", { className: "ajbl-mega-nav__sub-level-search-input-container oxum-w-5/6 oxum-pr-7", children: [
      /* @__PURE__ */ v(
        ce,
        {
          className: "desktop-search-sub-nav-search-input-icon",
          icon: Bt
        }
      ),
      " ",
      /* @__PURE__ */ v(
        "input",
        {
          "aria-label": "Search site",
          placeholder: "Search investments, news, FAQs...",
          type: "text",
          className: "desktop-search-sub-nav_search-input"
        }
      )
    ] }),
    /* @__PURE__ */ v("div", { className: "oxum-w-1/6", children: /* @__PURE__ */ D(
      Ve,
      {
        noAnimation: !0,
        className: "desktop-search-sub-nav_search-btn",
        children: [
          /* @__PURE__ */ v(ce, { icon: Bt }),
          " Search"
        ]
      }
    ) })
  ] }) });
}, Cu = ({
  LinkComponent: t
}) => {
  const { state: e } = it();
  return ne(() => {
  }, [e]), /* @__PURE__ */ D(Ke, { children: [
    /* @__PURE__ */ v(vu, { LinkComponent: t }),
    /* @__PURE__ */ v(Iu, {})
  ] });
}, yl = "data:image/svg+xml,%3csvg%20width='106'%20height='34'%20viewBox='0%200%20106%2034'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_834_7299)'%3e%3cpath%20d='M13.6646%2015.2884C13.675%2015.3534%2013.6828%2015.4158%2013.6932%2015.4808C13.9533%2014.4091%2014.0106%2013.2697%2013.8155%2012.1148C13.0559%207.5365%208.72993%204.44357%204.15166%205.20575C2.55187%205.47108%201.13676%206.17343%200%207.16972C0.546271%206.98243%201.11335%206.83416%201.70124%206.73791C7.36686%205.79364%2012.7229%209.62274%2013.6646%2015.2884Z'%20fill='%23D50032'/%3e%3cpath%20d='M12.3769%2020.6574C12.3275%2020.7199%2012.2755%2020.7745%2012.2261%2020.8343C13.394%2020.2256%2014.4606%2019.375%2015.3476%2018.2903C18.8541%2014.0007%2018.222%207.67699%2013.9299%204.17045C12.429%202.94524%2010.6809%202.22729%208.8938%201.99057C9.4921%202.33134%2010.0722%202.72413%2010.6237%203.17676C15.9355%207.52091%2016.7211%2015.3482%2012.3769%2020.6574Z'%20fill='%23D50032'/%3e%3cpath%20d='M11.7761%2024.0937H11.7787C19.0805%2022.8425%2024.0047%2015.9283%2022.7873%208.61344C22.2202%205.19275%2020.4071%202.28711%2017.8891%200.286713C18.6071%201.83708%2019.1325%203.50971%2019.4265%205.27599C20.6699%2012.7339%2017.4755%2019.903%2011.7761%2024.0937V24.0937Z'%20fill='%23D50032'/%3e%3cpath%20d='M27.121%2010.2132C26.9285%209.02705%2026.6034%207.89549%2026.1716%206.82635V6.82896C26.2964%2016.4511%2019.3718%2024.973%209.58573%2026.5702C7.7154%2026.8745%205.87109%2026.9057%204.0788%2026.695C7.03126%2028.274%2010.504%2028.9347%2014.0626%2028.3546C22.6754%2026.9499%2028.5231%2018.8287%2027.121%2010.2132Z'%20fill='%23D50032'/%3e%3cpath%20d='M66.9832%2016.9714L64.975%2016.9688L64.9802%2024.5776C65.0141%2025.3762%2064.9152%2026.5103%2065.2768%2026.7861C65.4745%2026.9708%2066.2575%2027.2777%2067.3786%2027.2777C71.4939%2027.2777%2072.2847%2025.1603%2072.2847%2022.2156C72.2847%2019.6091%2071.1973%2017.0312%2066.9832%2016.9714V16.9714ZM66.424%207.82786L64.9802%207.82526L64.975%2016.1104L67.0561%2016.113C69.3894%2016.113%2070.8357%2015.2051%2070.8357%2011.7896C70.8357%208.44177%2068.9914%207.89029%2066.424%207.82786V7.82786ZM68.3931%2028.1934C68.0368%2028.2012%2061.7806%2028.1986%2061.7806%2028.1986V10.0676C61.7806%208.68889%2061.6818%208.16603%2061.1876%207.85908C60.891%207.64577%2059.5071%207.64577%2058.9504%207.64577L59.2132%206.84197H66.3901C70.6667%206.72491%2073.6972%207.55473%2074.2252%2011.1419C74.5556%2013.3816%2073.1405%2015.5901%2070.175%2016.3263C75.016%2016.9714%2075.8068%2020.3167%2075.8068%2021.8176C75.8068%2025.2721%2073.8636%2028.1127%2068.3931%2028.1934'%20fill='%23373741'/%3e%3cpath%20d='M84.3677%2014.1802C83.0852%2014.1802%2081.306%2015.2858%2080.9444%2019.2735H86.1808C87.0366%2019.2735%2087.0028%2019.2449%2087.0028%2018.2928C87.0002%2016.2352%2086.3108%2014.1802%2084.3677%2014.1802ZM89.8668%2020.3765H80.8455C80.549%2024.3044%2082.5572%2027.4026%2085.4888%2027.4026C88.0225%2027.4026%2089.4714%2025.9589%2089.4714%2025.9589L89.6691%2026.8485C89.6691%2026.8485%2088.0875%2028.7214%2084.2688%2028.5653C80.8768%2028.4405%2077.4535%2025.7429%2077.7162%2020.712C77.8801%2017.5827%2079.9559%2013.1631%2084.4327%2013.1631C88.7457%2013.1631%2089.9657%2016.4459%2089.9657%2019.1487C89.9657%2019.8874%2089.8668%2020.3765%2089.8668%2020.3765'%20fill='%23373741'/%3e%3cpath%20d='M98.0426%2028.1049L93.0716%2028.1075L93.069%209.5291C93.069%208.45476%2092.788%207.98653%2092.247%207.74721C91.8594%207.57553%2090.9307%207.47148%2090.4365%207.47148L90.7018%206.82635H95.8367V24.9756C95.8367%2026.2944%2096.1645%2026.8485%2096.6926%2027.1841C97.0203%2027.3375%2097.7461%2027.4624%2098.2742%2027.4624L98.0426%2028.1049Z'%20fill='%23373741'/%3e%3cpath%20d='M105.771%2028.1049L100.8%2028.1075V9.5291C100.8%208.45476%20100.519%207.98653%2099.9754%207.74721C99.5878%207.57553%2098.6592%207.47148%2098.1649%207.47148L98.4276%206.82635H103.563V24.9756C103.563%2026.2944%20103.89%2026.8485%20104.418%2027.1841C104.751%2027.3375%20105.472%2027.4624%20106%2027.4624L105.771%2028.1049Z'%20fill='%23373741'/%3e%3cpath%20d='M33.424%2018.8964C33.424%2018.8964%2036.5169%2011.1003%2037.2114%209.3184C37.9346%2011.2512%2040.372%2018.8964%2040.372%2018.8964H33.424ZM45.7723%2025.3007C45.7723%2025.3007%2044.4222%2021.7422%2043.106%2017.9079C41.592%2013.5195%2039.4043%206.83417%2039.4043%206.83417L36.751%206.82896L29.5688%2026.1774C29.1786%2027.0644%2028.5413%2027.2933%2027.5164%2027.2933L27.2979%2028.0009H32.4407L32.6722%2027.2933C32.6722%2027.2933%2031.3507%2027.2543%2031.0984%2027.0462C30.7914%2026.7731%2030.8565%2026.2138%2031.2857%2025.0224L33.0155%2020.197L40.8324%2020.1996L43.3245%2027.9983H48.2747L48.5062%2027.2907C47.2862%2027.2959%2046.3966%2026.9916%2045.7723%2025.3007'%20fill='%23373741'/%3e%3cpath%20d='M55.4283%2026.3803C55.4283%2031.0756%2053.4201%2033.6535%2049.3023%2033.7133C49.0396%2033.7133%2048.795%2033.7029%2048.6312%2033.7029L48.3424%2032.8393C49.154%2032.9693%2049.9292%2032.8549%2050.6524%2032.4543C51.2767%2032.1187%2051.9868%2031.3487%2052.0831%2029.5408C52.1819%2027.824%2052.1195%2025.8912%2052.1195%2023.8362V10.0572C52.1195%208.67588%2052.0232%208.15562%2051.529%207.84867C51.2324%207.63276%2049.8512%207.63276%2049.2893%207.63276L49.552%206.82896H55.4387L55.4283%2026.3803Z'%20fill='%23373741'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_834_7299'%3e%3crect%20width='106'%20height='33.4266'%20fill='white'%20transform='translate(0%200.286713)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Au = ({
  link: t,
  dropdownsubmenu: e,
  tier: i,
  below: a,
  LinkComponent: n
}) => {
  const { state: l, dispatch: r } = it(), [c, o] = te(!1);
  ne(() => {
    const u = oi(l.navState).includes(t.link_title) === !0 && l.subNavVisibility;
    o(u);
  }, [l, t.link_title]);
  const s = () => {
    o(!c), r({
      type: "setHeaderPayload",
      payload: Ot([], {
        link: t,
        dropdownsubmenu: e,
        below: a,
        tier: i
      })
    }), r({
      type: "setSubNavVisibility",
      payload: t.link_title === l?.navState[0]?.link?.link_title ? !l.subNavVisibility : !0
    }), r({
      type: "setHeaderSearchVisibility",
      payload: !1
    });
  };
  return /* @__PURE__ */ v(
    qe,
    {
      isSelected: c,
      className: "oxum-ml-2",
      ariaLabel: t?.link_title,
      href: t?.link_path && !e ? t.link_path : void 0,
      onClick: s,
      LinkComponent: n,
      onKeyEnter: () => {
        t?.link_path && !e || setTimeout(() => {
          un();
        }, 200);
      },
      onKeyCodeDown: () => {
        s(), !(t?.link_path && !e) && setTimeout(() => {
          un();
        }, 50);
      },
      onKeyEscape: () => {
        r({
          type: "setSubNavVisibility",
          payload: !1
        });
      },
      chevron: "down",
      chevronSide: t?.link_path && !e ? void 0 : "right",
      noAnimation: !0,
      keyboardNavRestrictionContainer: ".desktop-nav",
      ariaExpanded: c,
      ariaControls: "mega-header-desktop-sub-nav",
      ariaOwns: "mega-header-desktop-sub-nav",
      children: t?.link_title
    }
  );
}, ci = () => {
  const [t, e] = te({
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight
  });
  return ne(() => {
    const i = () => {
      e({
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight
      });
    };
    return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, []), t;
}, Eu = ({
  accountData: t,
  onLogOutClick: e,
  LinkComponent: i
}) => {
  const { state: a, dispatch: n } = it(), { screenWidth: l } = ci(), r = a.activeUser && a.activeUser?.secureMessageCount ? a.activeUser?.secureMessageCount : 0;
  ne(() => {
    if (t?.userData) {
      const f = Yn({
        data: t?.userData,
        basketCount: t?.basketCount ?? 0,
        secureMessageCount: t?.secureMessageCount ?? 0
      })?.find(
        (g) => g.userType === "primaryUser"
      );
      f && n({
        type: "setActiveUser",
        payload: f
      }), n({
        type: "setAccountData",
        payload: t
      });
    }
  }, []);
  const c = (b) => {
    if (b?.preventDefault(), !t) return;
    const f = {
      link: {
        link_path: "",
        link_title: He,
        localized_options: {},
        field_component: []
      },
      dropdownsubmenu: !0,
      tier: 0,
      below: t.navigation
    };
    let g = bn(Ot([], f));
    if (g = ri(
      g,
      a.blockedURLs ?? []
    ), n({
      type: "setHeaderPayload",
      payload: g
    }), n({
      type: "setSubNavVisibility",
      payload: f.link.link_title === a?.navState[0]?.link?.link_title ? !a.subNavVisibility : !0
    }), n({
      type: "setHeaderSearchVisibility",
      payload: !1
    }), l < st.ML) {
      const h = a.mobileSubNavVisibility === !0 && a?.navState[0]?.link?.link_title !== He;
      n({
        type: "setMobileSubNavVisibility",
        payload: h ? !0 : !a.mobileSubNavVisibility
      });
    }
    setTimeout(() => {
      const h = document.querySelectorAll(
        ".ajbl-mega-nav__sub-level__accounts-overview .ajbl-select input"
      ), S = document.querySelectorAll(
        ".ajbl-mega-nav__sub-level__accounts-overview .ajbl-button"
      );
      h.length > 0 ? h[0].focus() : S.length > 0 && S[0].focus();
    }, 100);
  }, o = () => {
    n({
      type: "setMobileSubNavVisibility",
      payload: !a.mobileSubNavVisibility
    }), n({
      type: "setHeaderPayload",
      payload: []
    });
  }, s = a.mobileSubNavVisibility && a.navState[0]?.link?.link_title !== He, u = () => {
    if (l < st.ML)
      return /* @__PURE__ */ v(
        Ve,
        {
          onClick: o,
          noAnimation: !0,
          theme: s ? "light" : "dark",
          ariaLabel: "mobile menu",
          className: "ajbl-mega-nav__mobile-burger-btn",
          children: s ? /* @__PURE__ */ D(Ke, { children: [
            /* @__PURE__ */ v(ce, { icon: si }),
            "Close"
          ] }) : /* @__PURE__ */ D(Ke, { children: [
            /* @__PURE__ */ v(ce, { icon: Dl }),
            " Menu"
          ] })
        }
      );
  }, d = () => {
    if (l > st.ML)
      return /* @__PURE__ */ D(
        Ve,
        {
          noAnimation: !0,
          onClick: e,
          href: e ? void 0 : "/login/terminate",
          className: "main-nav-logout",
          theme: "light",
          LinkComponent: i,
          children: [
            /* @__PURE__ */ v(ce, { icon: Ea }),
            /* @__PURE__ */ v("span", { className: "ajbl-login-btn oxum-ml-2 oxum-inline-block", children: "Log out" })
          ]
        }
      );
  }, C = () => {
    if (l > st.ML)
      return /* @__PURE__ */ v(
        Ve,
        {
          href: "/investment/search/all",
          noAnimation: !0,
          ariaLabel: "search",
          isSelected: a.headerSearchVisibility,
          theme: "light",
          className: "ajbl-mega-nav__search-btn",
          LinkComponent: i,
          children: /* @__PURE__ */ v(ce, { icon: Bt })
        }
      );
  }, p = r === 0 ? "" : `you have ${r} message${r > 1 ? "s" : ""} available`;
  return /* @__PURE__ */ D(Ke, { children: [
    /* @__PURE__ */ D(
      Ve,
      {
        noAnimation: !0,
        href: t ? void 0 : "/login",
        theme: `${l <= st.SM ? "light" : "dark"}`,
        ariaLabel: t ? `${He} ${p}` : "Log in",
        className: "ajbl-mega-nav__login-btn oxum-inline-block",
        onClick: (b) => c(b),
        onKeyEnter: (b) => c(b),
        LinkComponent: i,
        children: [
          /* @__PURE__ */ v(ce, { icon: Vl }),
          /* @__PURE__ */ v("span", { className: "oxum-ml-2 sm:oxum-inline", children: t ? He : "Log in" }),
          a.activeUser && a.activeUser?.secureMessageCount > 0 && /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__account-notifyier-count", children: r })
        ]
      }
    ),
    t && d(),
    C(),
    u()
  ] });
}, Tu = ({
  navPayload: t,
  accountData: e,
  onLogOutClick: i
}) => {
  const { state: a } = it(), { screenWidth: n } = ci(), l = De(() => bn(t), [t]);
  return ne(() => {
  }, [a]), !l || l.length === 0 ? null : /* @__PURE__ */ D("div", { className: "items-center oxum-flex oxum-w-auto oxum-grow oxum-flex-nowrap", children: [
    /* @__PURE__ */ D("div", { className: "ajbl-meganav-header-left-panel oxum-grow", children: [
      /* @__PURE__ */ v(
        "a",
        {
          className: "oxum-relative oxum-mr-2 oxum-mt-0 oxum-inline-block",
          href: "/",
          children: /* @__PURE__ */ v("img", { className: "nav-logo", src: yl, alt: "AJ Bell" })
        }
      ),
      n > st.ML && /* @__PURE__ */ v("ul", { className: "desktop-nav", children: l.map((r, c) => /* @__PURE__ */ v("li", { className: "oxum-inline", children: /* @__PURE__ */ v(
        Au,
        {
          link: r.link,
          dropdownsubmenu: r.dropdownsubmenu,
          below: r.below,
          tier: r.tier
        },
        c
      ) }, c)) })
    ] }),
    /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__top-level--right-menu", children: /* @__PURE__ */ v(
      Eu,
      {
        onLogOutClick: i,
        accountData: e
      }
    ) })
  ] });
}, Su = ({
  navPayload: t,
  onLogOutClick: e,
  LinkComponent: i
}) => {
  const { state: a, dispatch: n } = it(), { navState: l, mobileSubNavVisibility: r } = a, [c, o] = te(0), s = l[l.length - 1], u = Ce(() => l.length === 1 && s?.tier === void 0 ? 0 : s?.link?.field_component?.length > 0 && s?.dropdownsubmenu === !1 && r ? s.tier ?? 0 : s?.tier !== void 0 ? (s.tier ?? 0) + 1 : 0, [l, s, r]), d = Ce(() => {
    r && o(u());
  }, [r, u]);
  if (ne(() => (window.addEventListener("resize", d), () => {
    window.removeEventListener("resize", d);
  }), [d]), ne(() => {
    o(r ? u() : 0);
  }, [r, u]), !t || t.length === 0) return null;
  const C = oi(l);
  return /* @__PURE__ */ v(Ke, { children: r && /* @__PURE__ */ D(
    "div",
    {
      role: "presentation",
      style: {
        width: `${100 * (c + 1)}%`,
        left: `-${100 * c}%`
      },
      className: "ajbl-mega-nav__sub-level mobile-sub-nav oxum-w-full",
      children: [
        /* @__PURE__ */ D(
          "div",
          {
            style: {
              width: `${100 / (c + 1)}%`
            },
            className: "ajbl-mega-nav__mobile-main-menu items-center oxum-overflow-hidden",
            children: [
              t.map((p, b) => {
                const { link: f, dropdownsubmenu: g } = p, h = C?.includes(f.link_title);
                return /* @__PURE__ */ v(
                  qe,
                  {
                    noAnimation: !0,
                    isSelected: h,
                    ariaLabel: f?.link_title,
                    href: f?.link_path && !g ? f.link_path : void 0,
                    onClick: () => {
                      n({
                        type: "setHeaderPayload",
                        payload: Ot([], p)
                      }), n({
                        type: "setSubNavVisibility",
                        payload: !1
                      });
                    },
                    chevron: "right",
                    variant: "tab",
                    chevronSide: "right",
                    children: f?.link_title
                  },
                  b
                );
              }),
              /* @__PURE__ */ D("div", { className: "ajbl-mega-nav__sub-level-search-input-container oxum-hidden", children: [
                /* @__PURE__ */ v(
                  ce,
                  {
                    className: "desktop-search-sub-nav-search-input-icon",
                    icon: Bt
                  }
                ),
                /* @__PURE__ */ v(
                  "input",
                  {
                    "aria-label": "Search site",
                    placeholder: "Search investments, news, FAQs...",
                    type: "text",
                    className: "mobile-search-sub-nav_search-input"
                  }
                )
              ] })
            ]
          }
        ),
        l.map(
          (p, b) => p.below && p.dropdownsubmenu && /* @__PURE__ */ D(
            "div",
            {
              style: {
                width: `${100 / (c + 1)}%`
              },
              className: "ajbl-mega-nav__mobile-main-menu items-center overflow-hidden",
              children: [
                c > 1 && p.link.link_title === He || c >= 1 && p.link.link_title !== He && /* @__PURE__ */ v(
                  qe,
                  {
                    className: "mobile-subnav-back",
                    chevron: "left",
                    chevronSide: "left",
                    noAnimation: !0,
                    onClick: () => {
                      const f = l.filter((g) => g.dropdownsubmenu).slice(0, -1);
                      n({
                        type: "setHeaderPayload",
                        payload: f
                      }), n({
                        type: "setSubNavVisibility",
                        payload: !1
                      });
                    },
                    children: `Back to ${c > 1 ? l.filter((f) => f.dropdownsubmenu)[l.length - 2]?.link?.link_title : "menu"}`
                  }
                ),
                p.link.link_title !== He && /* @__PURE__ */ v("h4", { children: p.link.link_title }),
                p.link.link_title === He && /* @__PURE__ */ v(Sl, { LinkComponent: i }),
                /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__sub-level__below-nav", children: p.below.map(
                  (f, g) => {
                    const { link: h, dropdownsubmenu: S } = f, E = C?.includes(
                      h.link_title
                    );
                    return /* @__PURE__ */ D(
                      qe,
                      {
                        noAnimation: !0,
                        isSelected: E,
                        ariaLabel: h?.link_title,
                        href: h?.link_path && !S ? h.link_path : void 0,
                        onClick: () => {
                          n({
                            type: "setHeaderPayload",
                            payload: Ot(l, f)
                          }), n({
                            type: "setSubNavVisibility",
                            payload: !1
                          });
                        },
                        chevron: h?.link_path && !S ? void 0 : "right",
                        variant: "tab",
                        chevronSide: "right",
                        children: [
                          h?.link_title,
                          h.showBasketCount && a.activeUser && /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__account-notifyier-count in-menu", children: a.activeUser.basketCount }),
                          h.showSecureMessagesCount && a.activeUser && /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__account-notifyier-count in-menu", children: a.activeUser.secureMessageCount })
                        ]
                      },
                      `${b}-${g}`
                    );
                  }
                ) }),
                /* @__PURE__ */ v("div", { className: "oxum-px-4", children: c === 1 && l.some(
                  (f) => f.link.link_title === He
                ) && /* @__PURE__ */ D(
                  Ve,
                  {
                    onClick: e,
                    href: e ? void 0 : "/login/terminate",
                    className: "mobile-logout-btn oxum-my-4 oxum-w-full",
                    theme: "light",
                    children: [
                      /* @__PURE__ */ v(ce, { icon: Ea }),
                      "Log out"
                    ]
                  }
                ) })
              ]
            },
            b
          )
        )
      ]
    }
  ) });
}, yu = ({
  onStateChange: t,
  accountData: e,
  menuPayload: i,
  theme: a,
  blockedURLs: n,
  onLogOutClick: l,
  LinkComponent: r
}) => {
  const { state: c, dispatch: o } = it(), { screenWidth: s } = ci(), [u, d] = te(void 0), C = De(() => {
    let b = bn(i ?? []);
    return b = ri(
      b,
      n ?? []
    ), b;
  }, [i]);
  if (ne(() => {
    o({
      type: "setBlockedURLs",
      payload: n ?? []
    }), e && (d(ba(e)), o({
      type: "setAccountData",
      payload: ba(e)
    }));
  }, [e]), ne(() => {
    if (e && !_t(e)) {
      console.error("MegaNav Failed to parse accountData");
      return;
    }
    if (!_t(i)) {
      console.error("MegaNav Failed to parse menuPayload");
      return;
    }
    o({
      type: "setHeaderPayload",
      payload: C
    });
  }, [o, C]), ne(() => {
    t?.({ ComponentState: c });
  }, [t]), !C || C.length === 0) return null;
  const p = he([
    "ajbl-fe-comp ajbl-mega-nav abjl-anti-legacy-style oxum-w-full",
    { "ajbl-drupal-meganav-alignment": a === "basic" },
    {
      "desktop-nav-active": (c.subNavVisibility || c.headerSearchVisibility) && s > st.ML
    }
  ]);
  return /* @__PURE__ */ D(
    "nav",
    {
      "aria-label": "Main site navigation",
      role: "navigation",
      className: p,
      children: [
        /* @__PURE__ */ v("div", { className: "ajbl-mega-nav__top-level oxum-m-auto", children: /* @__PURE__ */ v(
          Tu,
          {
            accountData: u,
            navPayload: C,
            onLogOutClick: l,
            LinkComponent: r
          }
        ) }),
        /* @__PURE__ */ v(Cu, {}),
        /* @__PURE__ */ v(
          Su,
          {
            accountData: u,
            navPayload: C,
            onLogOutClick: l,
            LinkComponent: r
          }
        )
      ]
    }
  );
}, Ad = ({
  onStateChange: t,
  accountData: e,
  menuPayload: i = [],
  theme: a = "basic",
  blockedURLs: n,
  onLogOutClick: l,
  LinkComponent: r
}) => /* @__PURE__ */ v($c, { children: /* @__PURE__ */ v(
  yu,
  {
    onStateChange: t,
    theme: a,
    accountData: e,
    menuPayload: i,
    blockedURLs: n,
    onLogOutClick: l,
    LinkComponent: r
  }
) }), wu = {
  prefix: "fab",
  iconName: "x-twitter",
  icon: [512, 512, [], "e61b", "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"]
}, xu = {
  prefix: "fab",
  iconName: "linkedin",
  icon: [448, 512, [], "f08c", "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"]
}, Gu = {
  prefix: "fab",
  iconName: "instagram",
  icon: [448, 512, [], "f16d", "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"]
}, Mu = {
  prefix: "fab",
  iconName: "facebook",
  icon: [512, 512, [62e3], "f09a", "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"]
}, Bu = {
  prefix: "fab",
  iconName: "youtube",
  icon: [576, 512, [61802], "f167", "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"]
}, _u = [
  {
    link: {
      link_path: "",
      link_title: "Investing",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "",
          link_title: "Our accounts",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/isa/stocks-shares-isa",
              link_title: "Stocks and shares ISA",
              localized_options: {},
              field_component: [
                {
                  id: "2431",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Our Which? Recommended Stocks and shares ISA lets you invest up to £20,000 each tax year, with any growth free from tax. Explore our full range of investment opportunities with the flexibility and control to grow your wealth while maximising your returns.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Stocks and shares ISA"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/lifetime-isa",
              link_title: "Lifetime ISA",
              localized_options: {},
              field_component: [
                {
                  id: "2432",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Build towards your first home or retirement with our Lifetime ISA. Invest up to £4,000 per tax year and get a 25% government bonus, worth up to £1,000, added on top.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Lifetime ISA"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/junior-isa",
              link_title: "Junior ISA",
              localized_options: {},
              field_component: [
                {
                  id: "2433",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Prepare for your little one’s financial future with our Junior ISA. Invest up to £9,000 per tax year and build a tax-efficient pot for their future education, home purchase, or other life milestone, ensuring they have a solid foundation for success.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Junior ISA"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/sipp",
              link_title: "Self-invested personal pension (SIPP)",
              localized_options: {},
              field_component: [
                {
                  id: "3166",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Take control of your retirement planning with our Which? Recommended Self-invested personal pension (SIPP). With a £60,000 tax-free annual allowance and no lifetime limit, enjoy flexibility and choice in managing your pension investments.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Self-invested personal pension (SIPP)"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/ready-made-pension",
              link_title: "Ready-made pension",
              localized_options: {},
              field_component: [
                {
                  id: "3200",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Simplify your retirement planning with our Ready-made pension. A hands-off, low hassle was of building for later life, choose the fund which matches your risk tolerance and we’ll manage it for you.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Ready made pension"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/dealing-account",
              link_title: "Dealing account",
              localized_options: {},
              field_component: [
                {
                  id: "3201",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Unlock the power of investing with our Dealing account. Enjoy the freedom to buy and sell a wide range of investments, from stocks and shares to funds and more, giving you control over your financial future with ease and flexibility.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Dealing account"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/charges",
              link_title: "Charges and rates",
              localized_options: {},
              field_component: [
                {
                  id: "3203",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>See all our account charges and rates in one handy place. Select by account type or use our charges calculator to understand what our charges mean for you.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Charges and rates"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/accounts",
              link_title: "All accounts",
              localized_options: {},
              field_component: [
                {
                  id: "3204",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>All our accounts, under one roof. From ISAs to pensions, Dealing accounts to savings options, find an account that suits you easily.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "All accounts"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      },
      {
        link: {
          link_path: "",
          link_title: "Choose your investments",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/investment/shares",
              link_title: "Shares",
              localized_options: {},
              field_component: [
                {
                  id: "5334",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Invest in the world’s biggest companies. Our dedicated shares page helps you find, research, buy and sell shares from across the globe and build a portfolio with confidence.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Shares"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/funds",
              link_title: "Funds",
              localized_options: {},
              field_component: [
                {
                  id: "5335",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Explore the universe of funds we have available, including our AJ Bell managed funds, and shortlisted Favourite funds that we’ve carefully selected from across the market.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Funds"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/exchange-traded-funds",
              link_title: "Exchange traded funds (ETFs) ",
              localized_options: {},
              field_component: [
                {
                  id: "5336",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Choose from hundreds of Exchanged traded funds, across a broad range of indices and benchmarks.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Exchange traded funds (ETFs) "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/investment-trusts",
              link_title: "Investment trusts",
              localized_options: {},
              field_component: [
                {
                  id: "5337",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>From income-focused to growth-oriented, explore our range of investment trusts.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Investment trusts"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/bonds",
              link_title: "Bonds & gilts",
              localized_options: {},
              field_component: [
                {
                  id: "5338",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Choose from hundreds of corporate bonds and government backed securities that offer fixed-terms and represent less volatile investment options.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Bonds and gilts "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment",
              link_title: "See all investments",
              localized_options: {},
              field_component: [
                {
                  id: "5339",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Explore our full range of investment options, giving you a complete, comprehensive menu of choices so you can build a portfolio that works for you.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "See all investments"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/top-buys-sells",
              link_title: "Top buys & sells",
              localized_options: {},
              field_component: [
                {
                  id: "5340",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>See what’s popular with AJ Bell customers and what they’ve been buying and selling most recently.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Top buys and sells "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/investment/international",
              link_title: "International dealing",
              localized_options: {},
              field_component: [
                {
                  id: "5341",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Explore investment opportunities in 24 global markets with our international dealing service.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "International dealing"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      },
      {
        link: {
          link_path: "/investment/ideas",
          link_title: "Help choosing your investments",
          localized_options: {},
          field_component: [
            {
              id: "5342",
              field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>If you’re ready to invest your money but aren’t sure which investment type is right for you, then consider looking at our investment ideas.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
              field_plain_title: "Help choosing your investments "
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    link: {
      link_path: "",
      link_title: "Pensions ",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "",
          link_title: "Pension accounts",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/pensions/sipp",
              link_title: "Self-invested personal pension (SIPP)",
              localized_options: {},
              field_component: [
                {
                  id: "5353",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Take control of your retirement planning with our Which? Recommended Self-invested personal pension (SIPP). With a £60,000 tax-free annual allowance and no lifetime limit, enjoy flexibility and choice in managing your pension investments to suit your needs.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Self-invested personal pension (SIPP)"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/ready-made-pension",
              link_title: "Ready-made pension",
              localized_options: {},
              field_component: [
                {
                  id: "5354",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Simplify your retirement planning with our Ready-made pension. A hands-off, low hassle was of building for later life, choose the fund which matches your risk tolerance and we’ll manage it for you.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Ready-made pension "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions",
              link_title: "All pension accounts",
              localized_options: {},
              field_component: [
                {
                  id: "5355",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Make sure you have everything you need to plan for a comfortable future with our pension hub. Here, you’ll find our range of pension accounts, tips to help you stay on top of your saving, and expert guidance.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "All pension accounts"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/junior-sipp",
              link_title: "Junior SIPP",
              localized_options: {},
              field_component: []
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      },
      {
        link: {
          link_path: "",
          link_title: "Saving for retirement",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/pensions/find-my-pensions",
              link_title: "Find lost pensions",
              localized_options: {},
              field_component: [
                {
                  id: "5356",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Make sure you have everything you need to plan for a comfortable future with our pension hub. Here, you’ll find our range of pension accounts, tips to help you stay on top of your saving, and expert guidance.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Find lost pensions"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/consolidating-pensions",
              link_title: "Pension consolidation",
              localized_options: {},
              field_component: [
                {
                  id: "5357",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Streamline your retirement savings with our pension consolidation service. Simplify your financial life by bringing your pension pots into one, easy-to-manage account.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Pension consolidation"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/transferring-to-us",
              link_title: "Transfer a pension",
              localized_options: {},
              field_component: [
                {
                  id: "5358",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Take control of your financial future by moving your pensions over to one, easy-to-manage account.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Transfer a pension "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/builder",
              link_title: "Pension builder fund",
              localized_options: {},
              field_component: [
                {
                  id: "5359",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Our classic fund for anyone wanting to build a personal pension but doesn’t know what to invest in. This fund is designed for long-term growth, helping you build a robust financial foundation for your future.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Pension builder fund"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/learn",
              link_title: "Pension essentials",
              localized_options: {},
              field_component: [
                {
                  id: "5360",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Learn about how to build a personal pension pot that works for you. Our bitesize guides make one of investing’s chewiest topics much easier to understand.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Pension essentials "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/sipp/what-is",
              link_title: "What is a SIPP?",
              localized_options: {},
              field_component: [
                {
                  id: "5361",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Find out how they differ from other pension types, what investment options are available, and how you can access your money in retirement.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "What is a SIPP?"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      },
      {
        link: {
          link_path: "",
          link_title: "Approaching retirement",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/pensions/drawdown",
              link_title: "Drawdown",
              localized_options: {},
              field_component: [
                {
                  id: "5362",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Understand how to unlock flexible retirement income with our drawdown options that aim to minimise tax and maximise control over your finances.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Drawdown"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/investing-in-later-life",
              link_title: "Investing in retirement",
              localized_options: {},
              field_component: [
                {
                  id: "5363",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Continue growing your wealth in retirement with our Investing in Retirement options. Here, we cover strategies to help generate income, manage risk, and preserve capital, so your money remains working hard for you in your golden years. &nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Investing in retirement"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/pensions/retirement-checklist",
              link_title: "Retirement checklist",
              localized_options: {},
              field_component: [
                {
                  id: "5364",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Navigate your journey to retirement, with our checklist. Covering everything from pension finding to estate management, we want to help enjoy your post-work life.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Retirement checklist"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      }
    ]
  },
  {
    link: {
      link_path: "/news",
      link_title: "News & insight",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !1,
    below: []
  },
  {
    link: {
      link_path: "",
      link_title: "Help & education",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "",
          link_title: "Learn to invest",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/learn",
              link_title: "Learn hub",
              localized_options: {},
              field_component: [
                {
                  id: "5365",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Discover a wealth of knowledge from our experts and learn team through a range of educational resources, guides, and articles that help you make informed decisions about your financial future.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Learn hub"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/learn/investing-essentials",
              link_title: "Investing essentials",
              localized_options: {},
              field_component: [
                {
                  id: "5366",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Master the fundamentals of investing with our Investing Essentials. From understanding risk to diversification strategies, gain the knowledge and tools you need to navigate the markets with confidence.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Investing essentials "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/learn/building-your-portfolio",
              link_title: "Building your portfolio",
              localized_options: {},
              field_component: [
                {
                  id: "5367",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Craft your investment strategy with our guide to building a portfolio that’s right for you. Our experts give you tips and insights on asset allocation, diversification, and risk management.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Building your portfolio "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/learn/jargon",
              link_title: "Jargon buster",
              localized_options: {},
              field_component: [
                {
                  id: "5368",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Demystify the world of financial terminology with our comprehensive jargon buster.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Jargon buster "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/learn/podcast",
              link_title: "Money & Markets podcast",
              localized_options: {},
              field_component: [
                {
                  id: "5369",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Join Laura Suter, Dan Coatsworth, Danni Hewson, and special guests, as they debate and dissect the latest stories that move the markets.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Money & markets podcast "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "https://www.ajbellmoneymatters.co.uk/",
              link_title: "Money matters",
              localized_options: {},
              field_component: [
                {
                  id: "5370",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>We think women need to talk more openly about money, because money really matters. Join our mission to help women feel good, investing.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Money matters "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      },
      {
        link: {
          link_path: "",
          link_title: "Support",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/security-centre",
              link_title: "Security centre",
              localized_options: {},
              field_component: [
                {
                  id: "5373",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Learn how we work together to keep you, your account, and your investments safe.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Security centre"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/can-we-help",
              link_title: "Contact us",
              localized_options: {},
              field_component: [
                {
                  id: "5371",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Our dedicated support team are on hand to help you with anything you may need.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Contact us"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/faq",
              link_title: "FAQs",
              localized_options: {},
              field_component: [
                {
                  id: "5372",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Have a question? It's likely we've already got an answer for you in our simple list of most popular questions</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "FAQs"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      }
    ]
  },
  {
    link: {
      link_path: "",
      link_title: "New to AJ Bell",
      localized_options: {},
      field_component: [
        {
          id: "5374",
          field_text_content: "",
          field_plain_title: ""
        }
      ]
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "/about-us",
          link_title: "About us",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>For over 25 years, we’ve been providing our customers with award-winning products and services that make investing simple and affordable.</p><p>With accounts to suit every investor, alongside our hugely popular AJ Bell Dodl app for those just starting out, we give you the tools to get your money working for you.</p><p>That’s why over 500,000 people have taken control of their financial futures by opening an account with AJ Bell.</p><p>Join them. Open an AJ Bell account and feel good, investing.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
              field_plain_title: "Join the only investment platform to be Which? Recommended six years running (2019-2024)"
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/awards",
          link_title: "Our awards",
          localized_options: {},
          field_component: [
            {
              id: "5376",
              field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>For over 25 years, we’ve been providing our customers with award-winning products and services that make investing simple and affordable.</p><p>With accounts to suit every investor, alongside our hugely popular AJ Bell Dodl app for those just starting out, we give you the tools to get your money working for you.</p><p>That’s why over 500,000 people have taken control of their financial futures by opening an account with AJ Bell.</p><p>Join them. Open an AJ Bell account and feel good, investing.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
              field_plain_title: "Join the only investment platform to be Which? Recommended six years running (2019-2024)"
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/transfer",
          link_title: "Transfer to AJ Bell",
          localized_options: {},
          field_component: [
            {
              id: "5377",
              field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>For over 25 years, we’ve been providing our customers with award-winning products and services that make investing simple and affordable.</p><p>With accounts to suit every investor, alongside our hugely popular AJ Bell Dodl app for those just starting out, we give you the tools to get your money working for you.</p><p>That’s why over 500,000 people have taken control of their financial futures by opening an account with AJ Bell.</p><p>Join them. Open an AJ Bell account and feel good, investing.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
              field_plain_title: "Join the only investment platform to be Which? Recommended six years running (2019-2024)"
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/investment/accounts/offers",
          link_title: "Special offers",
          localized_options: {},
          field_component: [
            {
              id: "5378",
              field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>For over 25 years, we’ve been providing our customers with award-winning products and services that make investing simple and affordable.</p><p>With accounts to suit every investor, alongside our hugely popular AJ Bell Dodl app for those just starting out, we give you the tools to get your money working for you.</p><p>That’s why over 500,000 people have taken control of their financial futures by opening an account with AJ Bell.</p><p>Join them. Open an AJ Bell account and feel good, investing.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
              field_plain_title: "Join the only investment platform to be Which? Recommended six years running (2019-2024)"
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/investing/app",
          link_title: "AJ Bell app",
          localized_options: {},
          field_component: [
            {
              id: "5379",
              field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>For over 25 years, we’ve been providing our customers with award-winning products and services that make investing simple and affordable.</p><p>With accounts to suit every investor, alongside our hugely popular AJ Bell Dodl app for those just starting out, we give you the tools to get your money working for you.</p><p>That’s why over 500,000 people have taken control of their financial futures by opening an account with AJ Bell.</p><p>Join them. Open an AJ Bell account and feel good, investing.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
              field_plain_title: "Join the only investment platform to be Which? Recommended six years running (2019-2024)"
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    link: {
      link_path: "",
      link_title: "ISAs",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "",
          link_title: "ISA accounts",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/isa/stocks-shares-isa",
              link_title: "Stocks and shares ISA",
              localized_options: {},
              field_component: [
                {
                  id: "5168",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Our Which? Recommended Stocks and shares ISA lets you invest up to £20,000 each tax year, with any growth free from tax. Explore our full range of investment opportunities with the flexibility and control to grow your wealth while maximising your returns.&nbsp;</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Stocks and shares ISA"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/lifetime-isa",
              link_title: "Lifetime ISA",
              localized_options: {},
              field_component: [
                {
                  id: "5343",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Build towards your first home or retirement with our Lifetime ISA. Invest up to £4,000 per tax year and get a 25% government bonus, worth up to £1,000, added on top.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Lifetime ISA"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/junior-isa",
              link_title: "Junior ISA",
              localized_options: {},
              field_component: [
                {
                  id: "5344",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Prepare for your little one’s financial future with our Junior ISA. Invest up to £9,000 per tax year and build a tax-efficient pot for their future education, home purchase, or other life milestone, ensuring they have a solid foundation for success.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Junior ISA "
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa",
              link_title: "All ISA accounts",
              localized_options: {},
              field_component: [
                {
                  id: "5345",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>ISAs offer a simple, tax-free way to grow your savings, whether it's for a rainy day, your first home, or a child’s future. Opening an account is quick and easy, so whatever your goal, we’ll get you started in no time.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "All ISA accounts"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      },
      {
        link: {
          link_path: "",
          link_title: "Managing an ISA",
          localized_options: {},
          field_component: []
        },
        dropdownsubmenu: !0,
        below: [
          {
            link: {
              link_path: "/isa/allowances",
              link_title: "ISA allowances",
              localized_options: {},
              field_component: [
                {
                  id: "5346",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Take a look at the latest ISA allowance to know how much you can invest this year tax-free.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "ISA allowances"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/transfer",
              link_title: "Transfer an ISA",
              localized_options: {},
              field_component: [
                {
                  id: "5347",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Take control of your financial future by moving your ISA over to one, easy-to-manage account.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Transfer an ISA"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/multiple-accounts",
              link_title: "Multiple ISAs",
              localized_options: {},
              field_component: [
                {
                  id: "5348",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>You can split your ISA allowance over different ISAs each year, but make sure you know the indidviual limits for each type of ISA.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "Multiple ISAs"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/learn/investing-essentials",
              link_title: "ISA essentials",
              localized_options: {},
              field_component: [
                {
                  id: "5349",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Learn about the ins and outs of saving and investing in ISAs, including tax perks, allowances and how to transfer between ISA providers.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "ISA essentials"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          },
          {
            link: {
              link_path: "/isa/stocks-shares-isa/what-is",
              link_title: "What is an ISA?",
              localized_options: {},
              field_component: [
                {
                  id: "5350",
                  field_text_content: `

<!-- THEME DEBUG -->
<!-- THEME HOOK: 'field' -->
<!-- FILE NAME SUGGESTIONS:
   ▪️ field--paragraph--field-text-content--menu-content.html.twig
   ▪️ field--paragraph--field-text-content.html.twig
   ▪️ field--paragraph--menu-content.html.twig
   ▪️ field--field-text-content.html.twig
   ▪️ field--text-long.html.twig
   ✅ field.html.twig
-->
<!-- 💡 BEGIN CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

  <div>
    <div>Text content</div>
              <div><p>Get into the nitty gritty of ISAs - the different types, tax benefits and how to get started with AJ Bell.</p></div>
          </div>

<!-- END CUSTOM TEMPLATE OUTPUT from 'themes/ajbell/templates/field/field.html.twig' -->

`,
                  field_plain_title: "What is an ISA?"
                }
              ]
            },
            dropdownsubmenu: !1,
            below: []
          }
        ]
      }
    ]
  }
], Lu = [
  {
    menu_name: "Important Information",
    items: [
      {
        link: {
          link_path: "/",
          link_title: "Terms & Conditions ",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/cookies",
          link_title: "Cookie policy",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/privacy-policy",
          link_title: "Privacy notice",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/",
          link_title: "Accessibility",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/disclosures",
          link_title: "Disclosures",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/",
          link_title: "Anti-slavery statement",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    menu_name: "Useful Information",
    items: [
      {
        link: {
          link_path: "/can-we-help",
          link_title: "Contact us & Help",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/",
          link_title: "Web chat",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/",
          link_title: "Site map",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/",
          link_title: "Security centre",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "https://www.ajbell.co.uk/group/careers",
          link_title: "Careers",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/",
          link_title: "Press",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    menu_name: "Popular Services",
    items: [
      {
        link: {
          link_path: "/pensions/sipp",
          link_title: "Self-invested personal pension",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/isa/stocks-shares-isa",
          link_title: "Stocks and shares ISA",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/isa/lifetime-isa",
          link_title: "Lifetime ISA",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/dealing-account",
          link_title: "Dealing account",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/pensions/junior-sipp",
          link_title: "Investing for children",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/cash-savings",
          link_title: "Cash savings hub",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    menu_name: "Other websites",
    items: [
      {
        link: {
          link_path: "https://dodl.co.uk",
          link_title: "AJ Bell Dodl",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "https://www.investcentre.co.uk/",
          link_title: "AJ Bell Investcentre",
          localized_options: {}
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  }
], Nu = {
  header: _u,
  footer: Lu
}, Ed = ({
  className: t,
  footerData: e = Nu.footer,
  LinkComponent: i
}) => {
  const [a, n] = te(-1);
  if (!_t(e)) {
    console.error("Footer Failed to parse data");
    return;
  }
  if (e?.length)
    return /* @__PURE__ */ D(
      "footer",
      {
        className: he(
          "ajbl-fe-comp ajbl-main-footer abjl-anti-legacy-style",
          t
        ),
        children: [
          /* @__PURE__ */ v("div", { className: "ajbl-main-footer-nav", children: e.map((l, r) => /* @__PURE__ */ D(
            "div",
            {
              className: `ajbl-main-footer__footer-col ${a === r ? "active" : ""}`,
              children: [
                /* @__PURE__ */ v("h4", { children: /* @__PURE__ */ D(
                  "button",
                  {
                    "aria-label": "expand section Name",
                    className: "footer-accordian-btn",
                    onClick: () => {
                      n(
                        a === r ? -1 : r
                      );
                    },
                    children: [
                      l.menu_name,
                      /* @__PURE__ */ v(
                        ce,
                        {
                          className: "oxum-float-right oxum-mt-2 oxum-inline-block oxum-pr-3",
                          icon: a === r ? Ul : Wl
                        }
                      )
                    ]
                  }
                ) }),
                l.items.map((c, o) => /* @__PURE__ */ v(
                  qe,
                  {
                    variant: "tab",
                    noAnimation: !0,
                    href: c.link.link_path,
                    LinkComponent: i,
                    chevron: c.link.link_path.includes("https:") ? "external" : "right",
                    chevronSide: "right",
                    children: c.link.link_title
                  },
                  o
                ))
              ]
            },
            r
          )) }),
          /* @__PURE__ */ v("div", { children: /* @__PURE__ */ D("div", { className: "oxum-py-10", children: [
            /* @__PURE__ */ v("a", { href: "/", children: /* @__PURE__ */ v("img", { alt: "AJ Bell", src: yl }) }),
            /* @__PURE__ */ v("br", {}),
            /* @__PURE__ */ D("div", { className: "oxum-relative", children: [
              /* @__PURE__ */ D("p", { className: "footer-legal-copy oxum-w-full lg:oxum-w-1/2", children: [
                "Authorised and regulated by the Financial Conduct Authority.",
                /* @__PURE__ */ v("br", {}),
                "AJ Bell registered office: AJ Bell, 4 Exchange Quay, Salford Quays, Manchester, M5 3EE."
              ] }),
              /* @__PURE__ */ D("div", { className: "footer-app-socials w-full oxum-relative oxum-bottom-0 oxum-mt-2 oxum-pt-5 lg:oxum-absolute lg:oxum-right-0 lg:oxum-w-1/2 lg:oxum-text-right", children: [
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://www.youtube.com/channel/UCHcaVkNvsO6sLm-TxIwMnQw",
                    className: "footer-social-links",
                    "aria-label": "Youtube",
                    children: /* @__PURE__ */ v(ce, { icon: Bu })
                  }
                ),
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://twitter.com/ajbell",
                    className: "footer-social-links oxum-ml-4",
                    "aria-label": "Twitter",
                    children: /* @__PURE__ */ v(ce, { icon: wu })
                  }
                ),
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://www.linkedin.com/company/a-j-bell",
                    className: "footer-social-links oxum-ml-4",
                    "aria-label": "Linkedin",
                    children: /* @__PURE__ */ v(ce, { icon: xu })
                  }
                ),
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://www.facebook.com/AJBell",
                    className: "footer-social-links oxum-ml-4",
                    "aria-label": "Facebook",
                    children: /* @__PURE__ */ v(ce, { icon: Mu })
                  }
                ),
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://www.instagram.com/ajbell_invest/",
                    className: "footer-social-links oxum-mx-4",
                    "aria-label": "Instagram",
                    children: /* @__PURE__ */ v(ce, { icon: Gu })
                  }
                ),
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://apps.apple.com/gb/app/aj-bell/id557882383",
                    className: "footer-social-links oxum-mr-4",
                    children: /* @__PURE__ */ v(
                      "img",
                      {
                        width: "100px",
                        height: "34px",
                        alt: "Apple app store",
                        src: "https://www.ajbell.co.uk/sites/all/themes/ajbyi_patternlab/patternlab/source/images/appstore-button.png.pagespeed.ce.GBnUyhPLni.png"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ v(
                  "a",
                  {
                    href: "https://play.google.com/store/apps/details?id=com.apadmi.AJBell&hl=en_GB&pli=1",
                    className: "footer-social-links",
                    children: /* @__PURE__ */ v(
                      "img",
                      {
                        width: "100px",
                        height: "34px",
                        alt: "Google play store",
                        src: "https://www.ajbell.co.uk/sites/all/themes/ajbyi_patternlab/patternlab/source/images/googleplay-button.png.pagespeed.ce.aWgLa9Bh3J.png"
                      }
                    )
                  }
                )
              ] })
            ] })
          ] }) })
        ]
      }
    );
}, wl = {
  ScreenType: "Funds",
  SearchTerm: "",
  AdvancedOptionAvailability: !1,
  Filters: {}
}, Fu = (t, e) => {
  switch (e.type) {
    case "setScreenType":
      return { ...t, ScreenType: e.payload };
    case "setAdvancedOptionAvailability":
      return { ...t, AdvancedOptionAvailability: e.payload };
    case "setSearchTerm":
      return { ...t, SearchTerm: e.payload };
    case "setFilter":
      return { ...t, Filters: e.payload };
    default:
      return t;
  }
}, xl = Jn({
  state: wl,
  dispatch: () => {
  }
}), Gl = ({
  children: t
}) => {
  const [e, i] = Ca(Fu, wl);
  return /* @__PURE__ */ v(xl.Provider, { value: { state: e, dispatch: i }, children: t });
}, ui = () => {
  const t = dn(xl);
  if (!t)
    throw new Error("useScreenerCard must be used within an ScreenerProvider");
  return t;
}, Ou = ({
  searchCTA: t,
  showAdvancedOptions: e,
  setIsBottomClearAllActivated: i,
  setShowAdvancedOptions: a,
  hasAdvancedFilterOnScreen: n,
  onClick: l,
  dispatch: r
}) => /* @__PURE__ */ D("div", { className: "ajbl-screener_bottom-options items-center oxum-flex oxum-flex-col oxum-justify-between md:oxum-flex-row", children: [
  /* @__PURE__ */ D("div", { className: "oxum-order-1 oxum-flex-col md:oxum-order-2 md:oxum-flex md:oxum-flex-row md:oxum-space-x-2", children: [
    /* @__PURE__ */ v(
      Ve,
      {
        onClick: () => {
          a(!e), setTimeout(() => {
            const o = document.querySelector(
              ".ajbl-checkselect--abs-dropdown.is-advanced .ajbl-checkselect__option-display .ajbl-checkselect__select-box"
            );
            o && o.focus();
          }, 0);
        },
        className: he("ajbl-screener__advanced-filter", {
          hidden: !n
        }),
        children: e ? "Hide Advanced Filters" : "Advanced Filters"
      }
    ),
    (t || l) && /* @__PURE__ */ v(
      Ve,
      {
        chevronSide: "right",
        chevron: "right",
        className: "ajbl-screener__search-button oxum-font-bold",
        onClick: l,
        children: t
      }
    )
  ] }),
  /* @__PURE__ */ v(
    "button",
    {
      onClick: () => {
        r({ type: "setFilter", payload: {} }), r({ type: "setSearchTerm", payload: "" }), i(!0);
      },
      className: "ajbl-screener__clear-button oxum-order-2 oxum-mt-2 md:oxum-order-1 md:oxum-mt-0",
      children: "Clear Filters"
    }
  )
] }), Pu = ({
  optionalHeader: t,
  currentScreenType: e,
  hasScreenTypeHeaders: i,
  dispatch: a
}) => {
  const n = [
    "Funds",
    "ETF",
    "Shares",
    "Investment Trust"
  ];
  ne(() => {
    a({ type: "setScreenType", payload: e });
  }, [e, a]);
  const l = (o, s, u, d) => /* @__PURE__ */ v(
    qe,
    {
      label: o,
      className: "oxum-mx-2",
      isSelected: s,
      href: u,
      onClick: d,
      onKeyEnter: d
    },
    o
  ), r = () => t?.map(
    (o) => l(
      o.title,
      e === o.title || e === o?.screenTypeMatch,
      o.link
    )
  ), c = () => n.map(
    (o) => l(o, e === o, void 0, () => {
      a({ type: "setScreenType", payload: o }), a({ type: "setFilter", payload: {} }), a({ type: "setAdvancedOptionAvailability", payload: !1 });
    })
  );
  return /* @__PURE__ */ v(
    "div",
    {
      className: he("screen-type-switcher oxum-mb-10 oxum-mt-2", {
        "oxum-hidden": !i
      }),
      children: t && _t(t) ? r() : c()
    }
  );
}, ku = ({
  label: t,
  header: e,
  className: i,
  isMulti: a,
  data: n,
  isAdvancedFilter: l,
  showAdvancedOptions: r,
  onScreenType: c = ["Funds"],
  currentScreenType: o = "Funds",
  isSectionBased: s,
  presetFilters: u,
  filterId: d,
  ariaLabel: C,
  getPreselectedItemsObjects: p
}) => {
  const [b, f] = te([]), [g, h] = te([]), [S, E] = te(
    void 0
  ), { dispatch: A, state: I } = ui(), w = t.replace(/\s/g, ""), T = (M) => M.map((L) => L.type === "content" ? L : {
    label: L?.name || L?.content || "",
    type: L?.type || "option",
    value: L?.value || L.id || "",
    section: L?.section ?? null
  }), x = () => typeof l == "boolean" ? l : Array.isArray(l) ? l?.includes(I.ScreenType) : !1;
  if (ne(() => {
    if (n) {
      const M = T(n);
      h(M);
    }
  }, [n]), ne(() => {
    Object.keys(I.Filters).length === 0 && I.Filters.constructor === Object && S !== !1 && E(!1);
  }, [I]), ne(() => {
    c.includes(o) && l && A({
      type: "setAdvancedOptionAvailability",
      payload: x()
    });
  }, [o]), ne(() => {
    if (u && b.length === 0) {
      let M = [];
      u?.map((L) => {
        d === L.filterId && (g.map((H) => {
          wa(H.value, L.value) && (M = [...M, H]);
        }), f(M), M.length > 0 && p?.({ [w]: M }));
      });
    }
  }, [b]), !c.includes(o)) return;
  const O = I?.Filters[w]?.length ? (
    // @ts-expect-error for flexibility of obj
    I?.Filters[w].length
  ) : 0, W = r && x() || !x();
  return /* @__PURE__ */ v(Gl, { children: W && /* @__PURE__ */ v(
    Jc,
    {
      presetOptions: b,
      className: he(
        i,
        "ajbl-checkselect--variant-2 ajbl-checkselect--abs-dropdown screener-filter",
        {
          "is-advanced": x(),
          "ajbl-checkselect--selected": O > 0
        }
      ),
      header: e,
      label: t,
      isMulti: a,
      options: g,
      ariaLabel: C,
      onClick: () => {
        E(void 0);
      },
      forceChecked: S,
      isSectionBased: s,
      placeholder: `${O === 0 ? "Any" : `${O} Selection${O !== 1 ? "s" : ""}`}`,
      onChange: (M) => {
        A({
          type: "setFilter",
          payload: {
            ...I.Filters,
            [w]: M
          }
        });
      }
    }
  ) });
}, Ru = ({
  filterData: t,
  currentScreenType: e,
  presetFilters: i,
  showAdvancedOptions: a
}) => {
  const { state: n, dispatch: l } = ui(), [r, c] = te([]), o = i?.filter(
    (d) => d.filterId !== "APISearchTerm"
  ), s = (d) => {
    const C = r, p = C.findIndex((b) => {
      const f = Object.keys(b), g = Object.keys(d);
      return f[0] === g[0];
    });
    p !== -1 ? C[p] = d : C.push(d), c(C);
  }, u = (d) => {
    const C = {};
    d.forEach((p) => {
      Object.keys(p).forEach((b) => {
        C[b] || (C[b] = []), C[b] = [
          ...C[b],
          ...p[b].map((f) => ({
            label: f.label,
            value: f.value,
            type: f.type
          }))
        ];
      });
    }), l({
      type: "setFilter",
      payload: {
        ...n.Filters,
        ...C
      }
    });
  };
  return ne(() => {
    o && Object.keys(n.Filters).length === 0 && o?.length > 0 && u(r);
  }, [r, n.Filters]), /* @__PURE__ */ v("div", { className: "ajbl-screener_filters-wrapper oxum-grid oxum-grid-cols-1 oxum-gap-4 md:oxum-grid-cols-2 lg:oxum-grid-cols-4", children: Object.keys(t).map((d, C) => {
    const p = t[d];
    return /* @__PURE__ */ v(
      ku,
      {
        filterId: d,
        currentScreenType: e,
        onScreenType: p.ScreenType,
        data: p.data,
        label: p.UILabel,
        ariaLabel: p.UILabel,
        header: p.UILabel,
        isMulti: p.isMultipleChoice,
        isAdvancedFilter: p.isAdvancedFilter,
        showAdvancedOptions: a,
        isSectionBased: p?.isSectionBased ?? !1,
        presetFilters: i,
        getPreselectedItemsObjects: s
      },
      `${d}_${C}`
    );
  }) });
}, Du = {
  ScreenType: [
    "Funds",
    "ETF"
  ],
  UILabel: "Sector",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "LC00000061",
      name: "£ Corporate Bond"
    },
    {
      id: "LC00000743",
      name: "£ High Yield"
    },
    {
      id: "LC00000744",
      name: "£ Strategic Bond"
    },
    {
      id: "LC00000011",
      name: "Asia Pacific Excluding Japan"
    },
    {
      id: "LC00000010",
      name: "Asia Pacific Including Japan"
    },
    {
      id: "LC00002020",
      name: "China/Greater China"
    },
    {
      id: "LC00003054",
      name: "Commodities and Natural Resources"
    },
    {
      id: "LC00002864",
      name: "EUR Corporate Bond"
    },
    {
      id: "LC00002860",
      name: "EUR Government Bond"
    },
    {
      id: "LC00002870",
      name: "EUR High Yield Bond"
    },
    {
      id: "LC00002867",
      name: "EUR Mixed Bond"
    },
    {
      id: "LC00000055",
      name: "Europe Excluding UK"
    },
    {
      id: "LC00000056",
      name: "Europe Including UK"
    },
    {
      id: "LC00000057",
      name: "European Smaller Companies"
    },
    {
      id: "LC00003057",
      name: "Financials and Financial Innovation"
    },
    {
      id: "LC00000013",
      name: "Flexible Investment"
    },
    {
      id: "LC00000014",
      name: "Global"
    },
    {
      id: "LC00002865",
      name: "Global Corporate Bond"
    },
    {
      id: "LC00000015",
      name: "Global Emerging Markets"
    },
    {
      id: "LC00002386",
      name: "Global Emerging Markets Bond - Blended"
    },
    {
      id: "LC00002856",
      name: "Global Emerging Markets Bond - Hard Currency"
    },
    {
      id: "LC00002857",
      name: "Global Emerging Markets Bond - Local Currency"
    },
    {
      id: "LC00002225",
      name: "Global Equity Income"
    },
    {
      id: "LC00002861",
      name: "Global Government Bond"
    },
    {
      id: "LC00002871",
      name: "Global High Yield Bond"
    },
    {
      id: "LC00002862",
      name: "Global Inflation Linked Bond"
    },
    {
      id: "LC00002868",
      name: "Global Mixed Bond"
    },
    {
      id: "LC00003056",
      name: "Healthcare"
    },
    {
      id: "LC00003058",
      name: "India/Indian Subcontinent"
    },
    {
      id: "LC00003055",
      name: "Infrastructure"
    },
    {
      id: "LC00000009",
      name: "Japan"
    },
    {
      id: "LC00003060",
      name: "Latin America"
    },
    {
      id: "LC00002226",
      name: "Mixed Investment 0-35% Shares"
    },
    {
      id: "LC00000064",
      name: "Mixed Investment 20-60% Shares"
    },
    {
      id: "LC00000012",
      name: "Mixed Investment 40-85% Shares"
    },
    {
      id: "LC00000059",
      name: "North America"
    },
    {
      id: "LC00000060",
      name: "North American Smaller Companies"
    },
    {
      id: "LC00000753",
      name: "Property Other"
    },
    {
      id: "LC00002297",
      name: "Short Term Money Market"
    },
    {
      id: "LC00000063",
      name: "Specialist"
    },
    {
      id: "LC00002872",
      name: "Specialist Bond"
    },
    {
      id: "LC00000005",
      name: "Standard Money Market"
    },
    {
      id: "LC00000739",
      name: "Targeted Absolute Return"
    },
    {
      id: "LC00000065",
      name: "Technology and Technology Innovation"
    },
    {
      id: "LC00000007",
      name: "UK All Companies"
    },
    {
      id: "LC00002699",
      name: "UK Direct Property"
    },
    {
      id: "LC00000004",
      name: "UK Equity Income"
    },
    {
      id: "LC00000001",
      name: "UK Gilts"
    },
    {
      id: "LC00000084",
      name: "UK Index Linked Gilts"
    },
    {
      id: "LC00000008",
      name: "UK Smaller Companies"
    },
    {
      id: "LC00000145",
      name: "Unclassified Sector"
    },
    {
      id: "LC00002863",
      name: "USD Corporate Bond"
    },
    {
      id: "LC00002859",
      name: "USD Government Bond"
    },
    {
      id: "LC00002869",
      name: "USD High Yield Bond"
    },
    {
      id: "LC00002866",
      name: "USD Mixed Bond"
    },
    {
      id: "LC00002661",
      name: "Volatility Managed"
    }
  ]
}, Hu = {
  ScreenType: [
    "Shares"
  ],
  UILabel: "Sector",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "IG000BA001",
      name: "Basic Materials"
    },
    {
      id: "IG000BA002",
      name: "Communication Services"
    },
    {
      id: "IG000BA003",
      name: "Consumer Cyclical"
    },
    {
      id: "IG000BA004",
      name: "Consumer Defensive"
    },
    {
      id: "IG000BA009",
      name: "Energy"
    },
    {
      id: "IG000BA010",
      name: "Financial Services"
    },
    {
      id: "IG000BA005",
      name: "Healthcare"
    },
    {
      id: "IG000BA006",
      name: "Industrials"
    },
    {
      id: "IG000BA007",
      name: "Real Estate"
    },
    {
      id: "IG000BA008",
      name: "Technology"
    },
    {
      id: "IG000BA011",
      name: "Utilities"
    }
  ]
}, Uu = {
  ScreenType: [
    "Investment Trust"
  ],
  UILabel: "Sector",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "SB_BasicMaterials",
      name: "Basic Materials"
    },
    {
      id: "SB_CommunicationServices",
      name: "Communication Services"
    },
    {
      id: "SB_ConsumerCyclical",
      name: "Consumer Cyclical"
    },
    {
      id: "SB_ConsumerDefensive",
      name: "Consumer Defensive"
    },
    {
      id: "SB_Energy",
      name: "Energy"
    },
    {
      id: "SB_FinancialServices",
      name: "Financial Services"
    },
    {
      id: "SB_Healthcare",
      name: "Healthcare"
    },
    {
      id: "SB_Industrials",
      name: "Industrials"
    },
    {
      id: "SB_RealEstate",
      name: "RealEstate"
    },
    {
      id: "SB_Technology",
      name: "Technology"
    },
    {
      id: "SB_Utilities",
      name: "Utilities"
    }
  ]
}, Vu = {
  ScreenType: [
    "Shares"
  ],
  UILabel: "Region",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: [
        "EX$$$$XLON"
      ],
      name: "UK"
    },
    {
      id: [
        "EX$$$$XNAS",
        "EX$$$$XNYS",
        "EX$$$$XASE"
      ],
      name: "US"
    },
    {
      id: [
        "EX$$$$XPAR",
        "EX$$$$XSTO",
        "EX$$$$XAMS",
        "EX$$$$XSWX",
        "EX$$$$XMAD",
        "EX$$$$XMIL",
        "EX$$$$XETR"
      ],
      name: "Europe"
    },
    {
      id: [
        "EX$$$$XTSE"
      ],
      name: "Canada"
    }
  ]
}, Wu = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Provider",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "7IM",
      name: "7IM",
      value: [
        "0C000048YX"
      ]
    },
    {
      id: "Aberforth Unit Trust Managers",
      name: "Aberforth Unit Trust Managers",
      value: [
        "0C000020JJ",
        "0C00001KB2"
      ]
    },
    {
      id: "Abrdn",
      name: "Abrdn",
      value: [
        "0C0000AVFW",
        "0C00001D04",
        "0C0000CCU7",
        "0C0000AOEH",
        "0C00001KAX",
        "0C00001UOL",
        "0C00000MSX",
        "0C0000APTK"
      ]
    },
    {
      id: "Aegon Asset Management",
      name: "Aegon Asset Management",
      value: [
        "0C000092S5",
        "0C00001KF9"
      ]
    },
    {
      id: "Aikya Investment Management Limited",
      name: "Aikya Investment Management Limited",
      value: [
        "0C0000BZN1"
      ]
    },
    {
      id: "Algebris Investments",
      name: "Algebris Investments",
      value: [
        "0C00002EKZ"
      ]
    },
    {
      id: "Allianz Global Investors",
      name: "Allianz Global Investors",
      value: [
        "0C00001KKO",
        "0C0000AS5X",
        "0C0000ARZK"
      ]
    },
    {
      id: "Alpha Real Capital LLP",
      name: "Alpha Real Capital LLP",
      value: [
        "0C000021XS"
      ]
    },
    {
      id: "Alquity Investment Management Limited",
      name: "Alquity Investment Management Limited",
      value: [
        "0C00008VT7"
      ]
    },
    {
      id: "Amati Global Investors Ltd",
      name: "Amati Global Investors Ltd",
      value: [
        "0C0000688M"
      ]
    },
    {
      id: "Amundi Asset Management",
      name: "Amundi Asset Management",
      value: [
        "0C000068ZH",
        "0C0000563H",
        "0C0000BMWH"
      ]
    },
    {
      id: "AQR Capital Management",
      name: "AQR Capital Management",
      value: [
        "0C00001SWY"
      ]
    },
    {
      id: "Ardevora Asset Management LLP",
      name: "Ardevora Asset Management LLP",
      value: [
        "0C00008THD"
      ]
    },
    {
      id: "Artemis",
      name: "Artemis",
      value: [
        "0C00001KTV",
        "0C000034EW"
      ]
    },
    {
      id: "Artisan Partners Global Funds PLC",
      name: "Artisan Partners Global Funds PLC",
      value: [
        "0C0000921C"
      ]
    },
    {
      id: "Ashmore Investment Management",
      name: "Ashmore Investment Management",
      value: [
        "0C0000BQCK"
      ]
    },
    {
      id: "Atlantic House Fund Management",
      name: "Atlantic House Fund Management",
      value: [
        "0C0000CEFH"
      ]
    },
    {
      id: "Aviva Investors",
      name: "Aviva Investors",
      value: [
        "0C000033FK",
        "0C00001UPC"
      ]
    },
    {
      id: "AXA",
      name: "AXA",
      value: [
        "0C00001KZL",
        "0C00001T6S"
      ]
    },
    {
      id: "Baillie Gifford",
      name: "Baillie Gifford",
      value: [
        "0C0000341K",
        "0C0000BKEZ"
      ]
    },
    {
      id: "Barclays Wealth",
      name: "Barclays Wealth",
      value: [
        "0C0000AO5T",
        "0C00000PK3"
      ]
    },
    {
      id: "Barings",
      name: "Barings",
      value: [
        "0C00002EWK",
        "0C00001LCB",
        "0C000034Z8"
      ]
    },
    {
      id: "BlackRock",
      name: "BlackRock",
      value: [
        "0C000034YC",
        "0C00001LJV",
        "0C0000AUB6",
        "0C00001LBD",
        "0C0000AUB8",
        "0C00004AQA",
        "0C00001LK3",
        "0C000034EF"
      ]
    },
    {
      id: "Blue Whale",
      name: "Blue Whale",
      value: [
        "0C0000BFJJ"
      ]
    },
    {
      id: "BNY Mellon",
      name: "BNY Mellon",
      value: [
        "0C00009VY6",
        "0C000035YS"
      ]
    },
    {
      id: "Brandes Investment Partners (Europe) Limited",
      name: "Brandes Investment Partners (Europe) Limited",
      value: [
        "0C0000AF74"
      ]
    },
    {
      id: "Bridge Fund Management Limited",
      name: "Bridge Fund Management Limited",
      value: [
        "0C0000BLEN"
      ]
    },
    {
      id: "Brooks Macdonald",
      name: "Brooks Macdonald",
      value: [
        "0C00009OMR",
        "0C0000C1F2"
      ]
    },
    {
      id: "Brown Advisory",
      name: "Brown Advisory",
      value: [
        "0C0000BRS0",
        "0C00001KJC"
      ]
    },
    {
      id: "Canaccord Genuity Wealth Management",
      name: "Canaccord Genuity Wealth Management",
      value: [
        "0C0000CT02"
      ]
    },
    {
      id: "Capita Financial Managers (Ireland) Ltd",
      name: "Capita Financial Managers (Ireland) Ltd",
      value: [
        "0C00001UQM"
      ]
    },
    {
      id: "Carmignac Group",
      name: "Carmignac Group",
      value: [
        "0C00001M0G"
      ]
    },
    {
      id: "Carne Global Fund Managers (Ireland) Ltd",
      name: "Carne Global Fund Managers (Ireland) Ltd",
      value: [
        "0C00009T6U",
        "0C00004DF8"
      ]
    },
    {
      id: "Castellain Capital LLP",
      name: "Castellain Capital LLP",
      value: [
        "0C00009LUD"
      ]
    },
    {
      id: "CCLA Investment Management Ltd",
      name: "CCLA Investment Management Ltd",
      value: [
        "0C00001M2D"
      ]
    },
    {
      id: "Cerno Capital",
      name: "Cerno Capital",
      value: [
        "0C000097O2"
      ]
    },
    {
      id: "CG Asset Management",
      name: "CG Asset Management",
      value: [
        "0C00001M3U"
      ]
    },
    {
      id: "Chelverton Asset Management",
      name: "Chelverton Asset Management",
      value: [
        "0C00001M52"
      ]
    },
    {
      id: "Church House Investment Management",
      name: "Church House Investment Management",
      value: [
        "0C0000B21I"
      ]
    },
    {
      id: "Close Asset Management (UK) Limited",
      name: "Close Asset Management (UK) Limited",
      value: [
        "0C00004AWR"
      ]
    },
    {
      id: "Cohen & Steers",
      name: "Cohen & Steers",
      value: [
        "0C0000BY7Q"
      ]
    },
    {
      id: "Colchester Global Investors Ltd",
      name: "Colchester Global Investors Ltd",
      value: [
        "0C00001CXK"
      ]
    },
    {
      id: "Columbia Threadneedle",
      name: "Columbia Threadneedle",
      value: [
        "0C0000BPUQ",
        "0C00001TLX",
        "0C0000B0CH",
        "0C0000B9ML"
      ]
    },
    {
      id: "Comgest Asset Management International Limited",
      name: "Comgest Asset Management International Limited",
      value: [
        "0C00001MDH"
      ]
    },
    {
      id: "ConBrio Fund Partners Limited",
      name: "ConBrio Fund Partners Limited",
      value: [
        "0C0000BXZU"
      ]
    },
    {
      id: "Consistent",
      name: "Consistent",
      value: [
        "0C00001MG0"
      ]
    },
    {
      id: "Contrarius Investment Management Ltd",
      name: "Contrarius Investment Management Ltd",
      value: [
        "0C00004HJK"
      ]
    },
    {
      id: "COURTIERS Asset Management Ltd",
      name: "COURTIERS Asset Management Ltd",
      value: [
        "0C0000B1GD"
      ]
    },
    {
      id: "Credo Capital Limited",
      name: "Credo Capital Limited",
      value: [
        "0C00008KRA"
      ]
    },
    {
      id: "CRUX Asset Management",
      name: "CRUX Asset Management",
      value: [
        "0C0000AVQX"
      ]
    },
    {
      id: "Diamond Capital Management (Singapore) Pte Ltd",
      name: "Diamond Capital Management (Singapore) Pte Ltd",
      value: [
        "0C000099AA"
      ]
    },
    {
      id: "Dimensional Fund Advisors Ltd",
      name: "Dimensional Fund Advisors Ltd",
      value: [
        "0C00001CV4"
      ]
    },
    {
      id: "Dodge & Cox",
      name: "Dodge & Cox",
      value: [
        "0C00001MX8"
      ]
    },
    {
      id: "Dragon Capital Management (HK) Limited",
      name: "Dragon Capital Management (HK) Limited",
      value: [
        "0C0000ADAI"
      ]
    },
    {
      id: "Eaton Vance Global Advisors Limited",
      name: "Eaton Vance Global Advisors Limited",
      value: [
        "0C0000BS36"
      ]
    },
    {
      id: "EdenTree",
      name: "EdenTree",
      value: [
        "0C00001N1O"
      ]
    },
    {
      id: "EPIC Funds plc",
      name: "EPIC Funds plc",
      value: [
        "0C000020KS"
      ]
    },
    {
      id: "Equitile",
      name: "Equitile",
      value: [
        "0C0000B2WU"
      ]
    },
    {
      id: "Equity Trustees Limited",
      name: "Equity Trustees Limited",
      value: [
        "0C0000BMAK",
        "0C0000911R"
      ]
    },
    {
      id: "Eurizon SLJ Capital LTD",
      name: "Eurizon SLJ Capital LTD",
      value: [
        "0C0000B52Z"
      ]
    },
    {
      id: "Evelyn Partners",
      name: "Evelyn Partners",
      value: [
        "0C00001UWC"
      ]
    },
    {
      id: "Federated Hermes Investment Management",
      name: "Federated Hermes Investment Management",
      value: [
        "0C000035S5"
      ]
    },
    {
      id: "Ferox Capital LLP",
      name: "Ferox Capital LLP",
      value: [
        "0C00008PA8"
      ]
    },
    {
      id: "Fidelity",
      name: "Fidelity",
      value: [
        "0C00001SZ3",
        "0C000022C9"
      ]
    },
    {
      id: "Fiera Capital",
      name: "Fiera Capital",
      value: [
        "0C00001M47"
      ]
    },
    {
      id: "Findlay Park Partners LLP",
      name: "Findlay Park Partners LLP",
      value: [
        "0C00001NGD"
      ]
    },
    {
      id: "FIL",
      name: "FIL",
      value: [
        "0C00001NF3",
        "0C0000AIY8",
        "0C00001TI9",
        "0C000053WD",
        "0C00001NF4"
      ]
    },
    {
      id: "First Sentier Investments",
      name: "First Sentier Investments",
      value: [
        "0C00002I6X",
        "0C00002I1B",
        "0C0000BQP1"
      ]
    },
    {
      id: "Foresight",
      name: "Foresight",
      value: [
        "0C00009OWE",
        "0C000020KZ"
      ]
    },
    {
      id: "Fortem Capital Limited",
      name: "Fortem Capital Limited",
      value: [
        "0C0000BCV5"
      ]
    },
    {
      id: "Franklin Templeton",
      name: "Franklin Templeton",
      value: [
        "0C0000BIKL",
        "0C0000A3Z2",
        "0C0000AL13",
        "0C0000C7MY"
      ]
    },
    {
      id: "FundRock",
      name: "FundRock",
      value: [
        "0C0000CSBU",
        "0C00001TNZ",
        "0C00001USO"
      ]
    },
    {
      id: "Fundsmith",
      name: "Fundsmith",
      value: [
        "0C00008FGG"
      ]
    },
    {
      id: "GAM",
      name: "GAM",
      value: [
        "0C000049HR",
        "0C00001NRW",
        "0C00001TAG"
      ]
    },
    {
      id: "Garraway Capital Management LL",
      name: "Garraway Capital Management LL",
      value: [
        "0C0000AZ8G"
      ]
    },
    {
      id: "Gemini Capital Management (Ireland) Limited",
      name: "Gemini Capital Management (Ireland) Limited",
      value: [
        "0C0000BFI7"
      ]
    },
    {
      id: "Goldman Sachs",
      name: "Goldman Sachs",
      value: [
        "0C00001OJY",
        "0C0000BNFE",
        "0C00001ETL"
      ]
    },
    {
      id: "Gresham House",
      name: "Gresham House",
      value: [
        "0C0000B0TU"
      ]
    },
    {
      id: "Guinness Asset Management Limited",
      name: "Guinness Asset Management Limited",
      value: [
        "0C00001O33"
      ]
    },
    {
      id: "GuardCap Asset Management Limited",
      name: "GuardCap Asset Management Limited",
      value: [
        "0C0000AX9S"
      ]
    },
    {
      id: "GVQ Investment Management Limited",
      name: "GVQ Investment Management Limited",
      value: [
        "0C000020MS"
      ]
    },
    {
      id: "Handelsbanken ACD Limited",
      name: "Handelsbanken ACD Limited",
      value: [
        "0C0000CAOA"
      ]
    },
    {
      id: "Hargreaves Lansdown",
      name: "Hargreaves Lansdown",
      value: [
        "0C00001O60"
      ]
    },
    {
      id: "Havelock London",
      name: "Havelock London",
      value: [
        "0C0000BHB0"
      ]
    },
    {
      id: "HBOS Investment Fund Managers Limited",
      name: "HBOS Investment Fund Managers Limited",
      value: [
        "0C00001O79"
      ]
    },
    {
      id: "Heptagon Capital Limited",
      name: "Heptagon Capital Limited",
      value: [
        "0C0000AK7I"
      ]
    },
    {
      id: "Herald Investment Fund",
      name: "Herald Investment Fund",
      value: [
        "0C00001O8R"
      ]
    },
    {
      id: "Heritage Capital Management Ltd",
      name: "Heritage Capital Management Ltd",
      value: [
        "0C00009OI3"
      ]
    },
    {
      id: "Hermes Fund Managers Ireland Ltd",
      name: "Hermes Fund Managers Ireland Ltd",
      value: [
        "0C0000BNZ1"
      ]
    },
    {
      id: "HSBC",
      name: "HSBC",
      value: [
        "0C00001OCM",
        "0C00001OD3"
      ]
    },
    {
      id: "Impax Asset Management Ltd",
      name: "Impax Asset Management Ltd",
      value: [
        "0C00000NY9",
        "0C00001OIC"
      ]
    },
    {
      id: "Invesco",
      name: "Invesco",
      value: [
        "0C00001OOC",
        "0C000033PF",
        "0C0000AFFH",
        "0C000033PS"
      ]
    },
    {
      id: "Investment Fund Services Limited",
      name: "Investment Fund Services Limited",
      value: [
        "0C0000185D",
        "0C00009ENX"
      ]
    },
    {
      id: "IQ EQ Fund Management (Ireland) Limited",
      name: "IQ EQ Fund Management (Ireland) Limited",
      value: [
        "0C0000BS4X"
      ]
    },
    {
      id: "Iridian Asset Management LLC",
      name: "Iridian Asset Management LLC",
      value: [
        "0C00001OQH"
      ]
    },
    {
      id: "Janus Henderson",
      name: "Janus Henderson",
      value: [
        "0C0000B9OA",
        "0C00001IR4"
      ]
    },
    {
      id: "JOHCM Funds",
      name: "JOHCM Funds",
      value: [
        "0C0000C1JR",
        "0C0000BMZO"
      ]
    },
    {
      id: "JK Investment Management",
      name: "JK Investment Management",
      value: [
        "0C00006HAO"
      ]
    },
    {
      id: "JPMorgan Asset Management",
      name: "JPMorgan Asset Management",
      value: [
        "0C0000AGS4",
        "0C00008F1P"
      ]
    },
    {
      id: "Jupiter",
      name: "Jupiter",
      value: [
        "0C0000BLZH",
        "0C0000BMY1",
        "0C0000BM1V",
        "0C00009W00",
        "0C00001OX6"
      ]
    },
    {
      id: "KBA Consulting Management Limited",
      name: "KBA Consulting Management Limited",
      value: [
        "0C0000B1BV"
      ]
    },
    {
      id: "KBI Global Investors Ltd",
      name: "KBI Global Investors Ltd",
      value: [
        "0C0000B5C3"
      ]
    },
    {
      id: "Lazard Fund Managers Limited",
      name: "Lazard Fund Managers Limited",
      value: [
        "0C00001P6H",
        "0C0000BN3H"
      ]
    },
    {
      id: "Legal & General",
      name: "Legal & General",
      value: [
        "0C00001P7B"
      ]
    },
    {
      id: "LGT Wealth Management UK LLP",
      name: "LGT Wealth Management UK LLP",
      value: [
        "0C0000B4O6"
      ]
    },
    {
      id: "Lindsell Train",
      name: "Lindsell Train",
      value: [
        "0C00001PAA"
      ]
    },
    {
      id: "Link Asset Services",
      name: "Link Asset Services",
      value: [
        "0C00003J3Q",
        "0C0000BDUH"
      ]
    },
    {
      id: "Liontrust",
      name: "Liontrust",
      value: [
        "0C00006IGC",
        "0C00006IGF",
        "0C0000CRRP"
      ]
    },
    {
      id: "Lord Abbett (Ireland) Ltd",
      name: "Lord Abbett (Ireland) Ltd",
      value: [
        "0C0000BJYW"
      ]
    },
    {
      id: "Lowes Financial Management Limited",
      name: "Lowes Financial Management Limited",
      value: [
        "0C0000B3VG"
      ]
    },
    {
      id: "M&G",
      name: "M&G",
      value: [
        "0C0000BDTY",
        "0C0000BIX5",
        "0C00001PES"
      ]
    },
    {
      id: "Macquarie",
      name: "Macquarie",
      value: [
        "0C0000490Q",
        "0C0000B8MI",
        "0C0000BKAT"
      ]
    },
    {
      id: "Maitland Institutional Services Ltd",
      name: "Maitland Institutional Services Ltd",
      value: [
        "0C0000B4F9"
      ]
    },
    {
      id: "Man Group",
      name: "Man Group",
      value: [
        "0C000035NK",
        "0C00001PGK"
      ]
    },
    {
      id: "Margetts Fund Management",
      name: "Margetts Fund Management",
      value: [
        "0C00001PIN"
      ]
    },
    {
      id: "Marlborough",
      name: "Marlborough",
      value: [
        "0C000033S5"
      ]
    },
    {
      id: "Matthews Intl Capital Management",
      name: "Matthews Intl Capital Management",
      value: [
        "0C000055VG"
      ]
    },
    {
      id: "McInroy & Wood",
      name: "McInroy & Wood",
      value: [
        "0C00001TZ0"
      ]
    },
    {
      id: "MFS International",
      name: "MFS International",
      value: [
        "0C0000BZV7"
      ]
    },
    {
      id: "Mirabaud",
      name: "Mirabaud",
      value: [
        "0C0000927J"
      ]
    },
    {
      id: "MitonOptimal UK Limited",
      name: "MitonOptimal UK Limited",
      value: [
        "0C00001TZA"
      ]
    },
    {
      id: "Montanaro",
      name: "Montanaro",
      value: [
        "0C000033HE"
      ]
    },
    {
      id: "Morant Wright Management Ltd",
      name: "Morant Wright Management Ltd",
      value: [
        "0C0000490R"
      ]
    },
    {
      id: "Morgan Stanley Investment Management",
      name: "Morgan Stanley Investment Management",
      value: [
        "0C00002YV7",
        "0C00001PUD",
        "0C0000ANOX"
      ]
    },
    {
      id: "Mori Capital Management Limited",
      name: "Mori Capital Management Limited",
      value: [
        "0C0000B4DQ"
      ]
    },
    {
      id: "Muzinich",
      name: "Muzinich",
      value: [
        "0C0000AO7E"
      ]
    },
    {
      id: "Natixis Investment Managers S.A.",
      name: "Natixis Investment Managers S.A.",
      value: [
        "0C00001PZ3",
        "0C0000A4NA"
      ]
    },
    {
      id: "NB Asset Management Ireland Ltd",
      name: "NB Asset Management Ireland Ltd",
      value: [
        "0C00003IFY",
        "0C0000BTTC"
      ]
    },
    {
      id: "Nedgroup Investments (IOM) Ltd",
      name: "Nedgroup Investments (IOM) Ltd",
      value: [
        "0C00001PZV"
      ]
    },
    {
      id: "Neuberger Berman",
      name: "Neuberger Berman",
      value: [
        "0C00001EI2",
        "0C00003FIF"
      ]
    },
    {
      id: "New Capital",
      name: "New Capital",
      value: [
        "0C00009EOQ",
        "0C0000BLOT",
        "0C00003HSR"
      ]
    },
    {
      id: "Ninety One",
      name: "Ninety One",
      value: [
        "0C00001OP5",
        "0C00001THB"
      ]
    },
    {
      id: "Nomura Asset Management U.K. Limited",
      name: "Nomura Asset Management U.K. Limited",
      value: [
        "0C00001CX5"
      ]
    },
    {
      id: "Northern Trust Fund Managers (Ireland) Limited",
      name: "Northern Trust Fund Managers (Ireland) Limited",
      value: [
        "0C000021EY"
      ]
    },
    {
      id: "Octopus Investments",
      name: "Octopus Investments",
      value: [
        "0C00001Q7S",
        "0C0000C6R0"
      ]
    },
    {
      id: "Odey",
      name: "Odey",
      value: [
        "0C0000348U"
      ]
    },
    {
      id: "Oldfield",
      name: "Oldfield",
      value: [
        "0C00001Q93"
      ]
    },
    {
      id: "Orbis Investment Management Limited",
      name: "Orbis Investment Management Limited",
      value: [
        "0C00001QBG"
      ]
    },
    {
      id: "Pacific Capital Partners Limited",
      name: "Pacific Capital Partners Limited",
      value: [
        "0C0000AN8E"
      ]
    },
    {
      id: "PGIM, Inc",
      name: "PGIM, Inc",
      value: [
        "0C0000B1UI"
      ]
    },
    {
      id: "Pictet",
      name: "Pictet",
      value: [
        "0C00001QJF"
      ]
    },
    {
      id: "PIMCO",
      name: "PIMCO",
      value: [
        "0C00001QJZ"
      ]
    },
    {
      id: "Polar Capital",
      name: "Polar Capital",
      value: [
        "0C00001D2F"
      ]
    },
    {
      id: "Polen Capital Management, LLC",
      name: "Polen Capital Management, LLC",
      value: [
        "0C00001E3J"
      ]
    },
    {
      id: "Premier Miton",
      name: "Premier Miton",
      value: [
        "0C00001QNA",
        "0C00001QND"
      ]
    },
    {
      id: "Prescient Fund Services (Ireland) Limited",
      name: "Prescient Fund Services (Ireland) Limited",
      value: [
        "0C0000AZC8"
      ]
    },
    {
      id: "Prusik Investment Management LLP",
      name: "Prusik Investment Management LLP",
      value: [
        "0C00001QS7"
      ]
    },
    {
      id: "Pzena Investment Management Europe Limited",
      name: "Pzena Investment Management Europe Limited",
      value: [
        "0C0000CRRY"
      ]
    },
    {
      id: "Quadris Environmental Fund PLC",
      name: "Quadris Environmental Fund PLC",
      value: [
        "0C00001TTH"
      ]
    },
    {
      id: "Quaero Capital LLP",
      name: "Quaero Capital LLP",
      value: [
        "0C00003GBZ"
      ]
    },
    {
      id: "Quilter",
      name: "Quilter",
      value: [
        "0C00009V0Z"
      ]
    },
    {
      id: "Ranmore Fund Management LTD",
      name: "Ranmore Fund Management LTD",
      value: [
        "0C00006BH7"
      ]
    },
    {
      id: "Rathbone Unit Trust Management",
      name: "Rathbone Unit Trust Management",
      value: [
        "0C00001QWO"
      ]
    },
    {
      id: "RBS",
      name: "RBS",
      value: [
        "0C000049LY",
        "0C00001QXE"
      ]
    },
    {
      id: "River & Mercantile",
      name: "River & Mercantile",
      value: [
        "0C00001R17"
      ]
    },
    {
      id: "Royal London",
      name: "Royal London",
      value: [
        "0C00001R4N"
      ]
    },
    {
      id: "Rubrics Asset Management",
      name: "Rubrics Asset Management",
      value: [
        "0C0000BLK2"
      ]
    },
    {
      id: "Ruffer",
      name: "Ruffer",
      value: [
        "0C0000B1X6",
        "0C000033AO",
        "0C0000490W"
      ]
    },
    {
      id: "S. W. Mitchell Capital LLP",
      name: "S. W. Mitchell Capital LLP",
      value: [
        "0C00004J5R"
      ]
    },
    {
      id: "Sand Aire Limited",
      name: "Sand Aire Limited",
      value: [
        "0C00001R80"
      ]
    },
    {
      id: "Sands Capital Management, LLC",
      name: "Sands Capital Management, LLC",
      value: [
        "0C00001GN8"
      ]
    },
    {
      id: "Sanlam Investments",
      name: "Sanlam Investments",
      value: [
        "0C0000AOU1"
      ]
    },
    {
      id: "Santander Asset Management",
      name: "Santander Asset Management",
      value: [
        "0C00001R8N"
      ]
    },
    {
      id: "Sarasin & Partners",
      name: "Sarasin & Partners",
      value: [
        "0C00008WTH",
        "0C00001R9C"
      ]
    },
    {
      id: "Schroders",
      name: "Schroders",
      value: [
        "0C000034II",
        "0C000023PM",
        "0C00008O17",
        "0C000021A9",
        "0C0000CTV8"
      ]
    },
    {
      id: "Scottish Widows",
      name: "Scottish Widows",
      value: [
        "0C0000BVIC",
        "0C00001RCP"
      ]
    },
    {
      id: "Seneca",
      name: "Seneca",
      value: [
        "0C00001PQB",
        "0C0000AXD8"
      ]
    },
    {
      id: "SEI Investments Global Limited",
      name: "SEI Investments Global Limited",
      value: [
        "0C00001REQ"
      ]
    },
    {
      id: "Seilern Inv Mgmt Ireland Ltd",
      name: "Seilern Inv Mgmt Ireland Ltd",
      value: [
        "0C00001REW"
      ]
    },
    {
      id: "SKAGEN AS",
      name: "SKAGEN AS",
      value: [
        "0C00001RL3"
      ]
    },
    {
      id: "Slater Investments",
      name: "Slater Investments",
      value: [
        "0C00001RM2"
      ]
    },
    {
      id: "Smith & Williamson",
      name: "Smith & Williamson",
      value: [
        "0C00004I4R",
        "0C000052MN"
      ]
    },
    {
      id: "SPARX Funds PLC",
      name: "SPARX Funds PLC",
      value: [
        "0C00009F04"
      ]
    },
    {
      id: "Somerset Capital Management",
      name: "Somerset Capital Management",
      value: [
        "0C00003GGY"
      ]
    },
    {
      id: "State Street",
      name: "State Street",
      value: [
        "0C0000C8SV",
        "0C000052GU",
        "0C00001RT4"
      ]
    },
    {
      id: "Stewart Investors",
      name: "Stewart Investors",
      value: [
        "0C0000B4Q6"
      ]
    },
    {
      id: "Stonehage",
      name: "Stonehage",
      value: [
        "0C0000B0DB"
      ]
    },
    {
      id: "SVM",
      name: "SVM",
      value: [
        "0C00001RWL"
      ]
    },
    {
      id: "T. Bailey Fund Managers",
      name: "T. Bailey Fund Managers",
      value: [
        "0C00001RYY"
      ]
    },
    {
      id: "T. Rowe Price",
      name: "T. Rowe Price",
      value: [
        "0C00008QVP",
        "0C0000BPLQ"
      ]
    },
    {
      id: "Threadneedle",
      name: "Threadneedle",
      value: [
        "0C00001S4W",
        "0C00004HUU"
      ]
    },
    {
      id: "Thesis",
      name: "Thesis",
      value: [
        "0C00001S40"
      ]
    },
    {
      id: "Thornbridge",
      name: "Thornbridge",
      value: [
        "0C0000B9ZJ"
      ]
    },
    {
      id: "Tideway Investment Partners LLP",
      name: "Tideway Investment Partners LLP",
      value: [
        "0C000093PF"
      ]
    },
    {
      id: "Triodos",
      name: "Triodos",
      value: [
        "0C000033NG"
      ]
    },
    {
      id: "Trium Ireland Ltd",
      name: "Trium Ireland Ltd",
      value: [
        "0C0000BS3U"
      ]
    },
    {
      id: "Troy Asset Management",
      name: "Troy Asset Management",
      value: [
        "0C00001S8W"
      ]
    },
    {
      id: "TUTMAN LLP",
      name: "TUTMAN LLP",
      value: [
        "0C0000B1GI"
      ]
    },
    {
      id: "TwentyFour",
      name: "TwentyFour",
      value: [
        "0C000054Y4"
      ]
    },
    {
      id: "UBS",
      name: "UBS",
      value: [
        "0C00001SAU",
        "0C00001W1F",
        "0C00001UUQ",
        "0C00008TJR",
        "0C00001SC7",
        "0C00001SCG"
      ]
    },
    {
      id: "Unicorn",
      name: "Unicorn",
      value: [
        "0C00001SD8"
      ]
    },
    {
      id: "UTI International (Singapore) Pvt. Ltd.",
      name: "UTI International (Singapore) Pvt. Ltd.",
      value: [
        "0C000069AI"
      ]
    },
    {
      id: "Valu-Trac Investment Management",
      name: "Valu-Trac Investment Management",
      value: [
        "0C00001SGI"
      ]
    },
    {
      id: "Vanguard",
      name: "Vanguard",
      value: [
        "0C000022HA",
        "0C00003GNE"
      ]
    },
    {
      id: "Veritas Asset Management",
      name: "Veritas Asset Management",
      value: [
        "0C00001SIB"
      ]
    },
    {
      id: "Waverton",
      name: "Waverton",
      value: [
        "0C0000AN5D"
      ]
    },
    {
      id: "Way Fund Managers",
      name: "Way Fund Managers",
      value: [
        "0C00001SMD"
      ]
    },
    {
      id: "Waystone",
      name: "Waystone",
      value: [
        "0C0000B3GM",
        "0C00009UT8",
        "0C0000C6HT",
        "0C000035NI"
      ]
    },
    {
      id: "Winton",
      name: "Winton",
      value: [
        "0C0000C1YY"
      ]
    },
    {
      id: "WisdomTree",
      name: "WisdomTree",
      value: [
        "0C000024EC",
        "0C0000A4AG",
        "0C000099B1",
        "0C00009UKT",
        "0C0000BQUU",
        "0C0000ARAP",
        "0C00004D76",
        "0C00009PFL",
        "0C0000CFFN"
      ]
    },
    {
      id: "Witan Investment Services Limited",
      name: "Witan Investment Services Limited",
      value: [
        "0C00002Z1H"
      ]
    },
    {
      id: "Yealand Fund Services",
      name: "Yealand Fund Services",
      value: [
        "0C000091WB"
      ]
    }
  ]
}, Xu = {
  ScreenType: [
    "Funds"
  ],
  UILabel: "Management Style",
  isAdvancedFilter: !1,
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      name: "Active",
      id: "Active",
      value: "false"
    },
    {
      content: "Active management funds aims to outperform a specific benchmark or index.",
      type: "content"
    },
    {
      name: "Passive",
      id: "Passive",
      value: "true"
    },
    {
      content: "Passive management replicates a specific benchmark or index in order to match its performance.",
      type: "content"
    }
  ]
}, Zu = {
  ScreenType: [
    "Funds"
  ],
  UILabel: "AJ Bell Selection",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      name: "AJ Bell Funds",
      id: "ajbFunds",
      value: [
        "BYW8RV9",
        "BYW8VJ5",
        "BYW8RX1",
        "BYW8VL7",
        "BYW8VG2",
        "BD833W4",
        "BN0S2V9",
        "BH3W788",
        "BH3W799",
        "BH3W744",
        "BH3W755",
        "BN0S2W0"
      ]
    },
    {
      content: "Filter to only see funds managed and provided by AJ Bell.",
      type: "content"
    },
    {
      name: "AJ Bell Favourite funds",
      id: "favoriteFunds",
      value: [
        "B777SP3",
        "BYT2QW8",
        "BKPWGV3",
        "B2PLJR1",
        "BJT0KT2",
        "BMMV510",
        "BMMV576",
        "B61DJ02",
        "3081671",
        "0601113",
        "B7NB1W7",
        "B3Y7MQ7",
        "BCZRNN3",
        "B5ZNJ89",
        "B43FT80",
        "B3L1035",
        "B67DWT6",
        "B67DWR4",
        "B3V1C06",
        "B4RB3Z9",
        "B6Y7NF4",
        "B9SMK77",
        "B8HT715",
        "BJS8SJ3",
        "B469J89",
        "B24HK55",
        "B7BXT54",
        "B7FFF70",
        "BMJJJF9",
        "BN72T68",
        "BJ04DS3",
        "BJ04GD9",
        "BJ04GF1",
        "BYYLQL9",
        "0504245",
        "BF540Y5",
        "BKM4GY5",
        "B521C87",
        "B84DSW8",
        "B6QQ9X9",
        "BRHZ039",
        "B27YCN5",
        "BLH1VN2",
        "B4R1D93",
        "B7C44X9",
        "B5M5KY1",
        "B5N1BC3",
        "B3FJQ59",
        "B235J20",
        "B78FJ53",
        "BZ2YMT7",
        "B6QC0Z6",
        "B4KL9F8",
        "B8QHFR2",
        "BGPFJN7",
        "3003006",
        "3002876",
        "B56BDS0",
        "BFX0551",
        "BD6P6G7",
        "BDF5FQ1",
        "BDF5FP0",
        "B4TL2D8",
        "B0117D3",
        "BFH3NC9",
        "BYSRYZ3",
        "B5339C5",
        "B42W4J8",
        "B3MBXC4",
        "B7SGTR8",
        "0764812",
        "BDD2CM9",
        "BYRJXP3",
        "BNRRPM1",
        "3387476",
        "B7W3061",
        "BDTM8B4",
        "BKTW4R1",
        "BZ6CNS3",
        "BZ6CQ06",
        "BSMTGG8",
        "BSMTGF7",
        "BKXH1T3",
        "BJGTN82",
        "BKXH1S2",
        "BYM2X68",
        "B2NG4R3",
        "BF1QNC4",
        "BD0B7D5"
      ]
    },
    {
      content: "The favourite funds features selected by our  investment specialists for their income and growth potential.",
      type: "content"
    }
  ]
}, zu = {
  ScreenType: [
    "ETF"
  ],
  UILabel: "AJ Bell Selection",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      name: "AJ Bell Favourite funds",
      id: "favoriteFunds",
      value: [
        "B777SP3",
        "BYT2QW8",
        "BKPWGV3",
        "B2PLJR1",
        "BJT0KT2",
        "BMMV510",
        "BMMV576",
        "B61DJ02",
        "3081671",
        "0601113",
        "B7NB1W7",
        "B3Y7MQ7",
        "BCZRNN3",
        "B5ZNJ89",
        "B43FT80",
        "B3L1035",
        "B67DWT6",
        "B67DWR4",
        "B3V1C06",
        "B4RB3Z9",
        "B6Y7NF4",
        "B9SMK77",
        "B8HT715",
        "BJS8SJ3",
        "B469J89",
        "B24HK55",
        "B7BXT54",
        "B7FFF70",
        "BMJJJF9",
        "BN72T68",
        "BJ04DS3",
        "BJ04GD9",
        "BJ04GF1",
        "BYYLQL9",
        "0504245",
        "BF540Y5",
        "BKM4GY5",
        "B521C87",
        "B84DSW8",
        "B6QQ9X9",
        "BRHZ039",
        "B27YCN5",
        "BLH1VN2",
        "B4R1D93",
        "B7C44X9",
        "B5M5KY1",
        "B5N1BC3",
        "B3FJQ59",
        "B235J20",
        "B78FJ53",
        "BZ2YMT7",
        "B6QC0Z6",
        "B4KL9F8",
        "B8QHFR2",
        "BGPFJN7",
        "3003006",
        "3002876",
        "B56BDS0",
        "BFX0551",
        "BD6P6G7",
        "BDF5FQ1",
        "BDF5FP0",
        "B4TL2D8",
        "B0117D3",
        "BFH3NC9",
        "BYSRYZ3",
        "B5339C5",
        "B42W4J8",
        "B3MBXC4",
        "B7SGTR8",
        "0764812",
        "BDD2CM9",
        "BYRJXP3",
        "BNRRPM1",
        "3387476",
        "B7W3061",
        "BDTM8B4",
        "BKTW4R1",
        "BZ6CNS3",
        "BZ6CQ06",
        "BSMTGG8",
        "BSMTGF7",
        "BKXH1T3",
        "BJGTN82",
        "BKXH1S2",
        "BYM2X68",
        "B2NG4R3",
        "BF1QNC4",
        "BD0B7D5"
      ]
    },
    {
      content: "The favourite funds features selected by our  investment specialists for their income and growth potential.",
      type: "content"
    }
  ]
}, Ju = {
  ScreenType: [
    "Investment Trust"
  ],
  UILabel: "AJ Bell Selection",
  isAdvancedFilter: !1,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      name: "Investment trust select list",
      id: "investmentTrustSelectList",
      value: [
        "0295958",
        "0048583",
        "BDFGHW4",
        "BYSRMH1",
        "0199049",
        "B62Z3C7",
        "BK1PKQ9",
        "BWXC7Y9",
        "0453530",
        "BMXWN18",
        "B5ZZY91",
        "3051726",
        "BM8B5H0",
        "0422002",
        "0791887",
        "B09G3N2",
        "0906409",
        "0338530"
      ]
    },
    {
      content: "The investment trust select list is chosen by our investment specialists, looking at number of factors including price,performance and size.",
      type: "content"
    }
  ]
}, Yu = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Geographical region",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "RE_UnitedKingdom",
      name: "United Kingdom"
    },
    {
      id: "RE_UnitedStates",
      name: "United States"
    },
    {
      id: "RE_WesternEuropeEuro",
      name: "Western Europe euro"
    },
    {
      id: "RE_WesternEuropeNonEuroexUK",
      name: "Western Europe non euro ex UK"
    },
    {
      id: "RE_Japan",
      name: "Japan"
    },
    {
      id: "RE_Asia4TigersEmerging",
      name: "Asia 4 tigers emerging"
    },
    {
      id: "RE_Asiaex4TigersEmerging",
      name: "Asia emerging ex 4 tigers"
    },
    {
      id: "RE_Canada",
      name: "Canada"
    },
    {
      id: "RE_Australasia",
      name: "Australasia"
    },
    {
      id: "RE_CentralandEasternEurope",
      name: "Central and eastern Europe"
    },
    {
      id: "RE_CentralandLatinAmericaEmerging",
      name: "Central and Latin America"
    },
    {
      id: "RE_AfricaDeveloped",
      name: "Africa developed"
    },
    {
      id: "RE_AfricaEmerging",
      name: "Africa emerging"
    }
  ]
}, ju = {
  ScreenType: [
    "Funds",
    "ETF"
  ],
  UILabel: "Income or Growth",
  isAdvancedFilter: !0,
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      name: "Income",
      id: "inc"
    },
    {
      content: "Any income the fund produces will be paid into your AJ Bell account as cash. You can then decide what you want to do with it. Usually used by investors whose overall goal is income.",
      type: "content"
    },
    {
      name: "Accumulation",
      id: "acc"
    },
    {
      content: "Any income the fund produces will be reinvested back into the fund by the manager, increasing the price of the units. Usually used by investors whose overall goal is growth.",
      type: "content"
    }
  ]
}, $u = {
  ScreenType: [
    "Funds",
    "ETF",
    "Shares",
    "Investment Trust"
  ],
  UILabel: "Performance",
  isAdvancedFilter: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  isMultipleChoice: !0,
  isSectionBased: !0,
  data: [
    {
      content: "Performance (1 Year)",
      type: "content"
    },
    {
      name: "< 0.5%",
      value: "LTE:0.5",
      id: "Income1",
      section: "0"
    },
    {
      name: "0.5% - 1%",
      value: "BTW:0.5:1",
      id: "Income2",
      section: "0"
    },
    {
      name: "1% - 1.5%",
      value: "BTW:1:1.5",
      id: "Income3",
      section: "0"
    },
    {
      name: "> 1.5%",
      value: "GTE:1.5",
      id: "Income4",
      section: "0"
    },
    {
      content: "Performance (3 Year)",
      type: "content"
    },
    {
      name: "0% to 10%",
      value: "BTW:0:10",
      id: "Income5",
      section: "1"
    },
    {
      name: "10% to 20%",
      value: "BTW:10:20",
      id: "Income6",
      section: "1"
    },
    {
      name: "20% to 30%",
      value: "BTW:20:30",
      id: "Income7",
      section: "1"
    },
    {
      name: "30% +",
      value: "GTE:30",
      id: "Income8",
      section: "1"
    },
    {
      content: "Performance (5 Year)",
      type: "content"
    },
    {
      name: "0% to 20%",
      value: "BTW:0:20",
      id: "Income9",
      section: "2"
    },
    {
      name: "20% to 50%",
      value: "BTW:20:50",
      id: "Income10",
      section: "2"
    },
    {
      name: "50% +",
      value: "GTE:50",
      id: "Income11",
      section: "2"
    }
  ]
}, Qu = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Ongoing fund charge",
  isAdvancedFilter: !0,
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      content: "The % amount you'll pay for holding the fund, including the annual management fee. (This doesn't include additional costs such as transaction and performance fees).",
      type: "content"
    },
    {
      name: "< 0.5%",
      value: "LTE:0.5",
      id: "lessThanHalf"
    },
    {
      name: "0.5% - 1%",
      value: "BTW:0.5:1",
      id: "btwHalfAnd1"
    },
    {
      name: "1% - 1.5%",
      value: "BTW:1:1.5",
      id: "btw1And1Half"
    },
    {
      name: "> 1.5%",
      value: "GTE:1.5",
      id: "moreThan1Half"
    }
  ]
}, Ku = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Risk Rating",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      name: "1",
      id: "1",
      value: 1
    },
    {
      name: "2",
      id: "2",
      value: 2
    },
    {
      name: "3",
      id: "3",
      value: 3
    },
    {
      name: "4",
      id: "4",
      value: 4
    },
    {
      name: "5",
      id: "5",
      value: 5
    },
    {
      name: "6",
      id: "6",
      value: 6
    },
    {
      name: "7",
      id: "7",
      value: 7
    }
  ]
}, qu = {
  ScreenType: [
    "Funds",
    "ETF",
    "Shares",
    "Investment Trust"
  ],
  UILabel: "Yield",
  isAdvancedFilter: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      content: "The income the fund has returned to investors, expressed as a percentage. You can use this to gauge the potential income you could earn from the fund.",
      type: "content"
    },
    {
      name: "0% - 2%",
      value: "BTW:0:2",
      id: "less2"
    },
    {
      name: "2% - 3%",
      value: "BTW:2:3",
      id: "btw2and3"
    },
    {
      name: "3% - 4%",
      value: "BTW:3:4",
      id: "btw3and4"
    },
    {
      name: "4% - 6%",
      value: "BTW:4:6",
      id: "btw4and6"
    },
    {
      name: "6% +",
      value: "GTE:6",
      id: "more6"
    }
  ]
}, ed = {
  ScreenType: [
    "Funds",
    "ETF",
    "Shares",
    "Investment Trust"
  ],
  UILabel: "Asset class",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "$BCG$ALLOC",
      name: "Allocation"
    },
    {
      id: "$BCG$ALTER",
      name: "Alternative"
    },
    {
      id: "$BCG$COMMO",
      name: "Commodities"
    },
    {
      id: "$BCG$CONVT",
      name: "Convertibles"
    },
    {
      id: "$BCG$EQUTY",
      name: "Equity"
    },
    {
      id: "$BCG$FXINC",
      name: "Fixed Income"
    },
    {
      id: "$BCG$MISCL",
      name: "Miscellaneous"
    },
    {
      id: "$BCG$MNMKT",
      name: "Money Market"
    },
    {
      id: "$BCG$PRPTY",
      name: "Property"
    }
  ]
}, td = {
  ScreenType: [
    "Shares"
  ],
  UILabel: "Exchange",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "EX$$$$XLON",
      name: "London stock exchange"
    },
    {
      id: "EX$$$$XNAS",
      name: "NASDAQ"
    },
    {
      id: "EX$$$$XNYS",
      name: "NYS"
    },
    {
      id: "EX$$$$XPAR",
      name: "Euronext Paris"
    },
    {
      id: "EX$$$$XSTO",
      name: "Stockholm Stock Exchange"
    },
    {
      id: "EX$$$$XAMS",
      name: "Euronext Amsterdam"
    },
    {
      id: "EX$$$$XSWX",
      name: "SIX Swiss Exchange"
    },
    {
      id: "EX$$$$XMAD",
      name: "Bolsa de Madrid"
    },
    {
      id: "EX$$$$XMIL",
      name: "Borsa Italiana"
    },
    {
      id: "EX$$$$XETR",
      name: "Xetra"
    },
    {
      id: "EX$$$$XTSE",
      name: "Toronto Stock Exchange"
    },
    {
      id: "EX$$$$XASE",
      name: "American Stock Exchange"
    }
  ]
}, nd = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Fund Size",
  isAdvancedFilter: !0,
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      name: "£0 - £10m",
      value: "LTE:10000000",
      id: "less10m"
    },
    {
      name: "£10m - £50m",
      value: "BTW:10000000:50000000",
      id: "btw10m50m"
    },
    {
      name: "£50m - £100m",
      value: "BTW:50000000:100000000",
      id: "btw50m100m"
    },
    {
      name: "£100m - £500m",
      value: "BTW:100000000:500000000",
      id: "btw100m500m"
    },
    {
      name: "£500m - £1bn",
      value: "BTW:500000000:1000000000",
      id: "btw500m1b"
    },
    {
      name: "£1bn +",
      value: "GTE:1000000000",
      id: "more1b"
    }
  ]
}, id = {
  ScreenType: [
    "ETF"
  ],
  UILabel: "Replication Method",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      content: "How the ETF replicates its index - either fully, partially or synthetically.",
      type: "content"
    },
    {
      name: "Physical Full",
      id: "PhysicalFull",
      value: "Physical Full"
    },
    {
      name: "Physical Sample",
      id: "PhysicalSample",
      value: "Physical Sample"
    },
    {
      name: "Synthetic Replication",
      id: "SyntheticReplication",
      value: "Synthetic Replication"
    }
  ]
}, ad = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Morningstar Rating",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      content: "Morningstar rates investments from one to five stars based on how well they&apos;ve performed in comparison to similar investments, after adjusting for risk and accounting for all relevant sales charges.",
      type: "content"
    },
    {
      name: "1",
      id: "1",
      value: 1
    },
    {
      name: "2",
      id: "2",
      value: 2
    },
    {
      name: "3",
      id: "3",
      value: 3
    },
    {
      name: "4",
      id: "4",
      value: 4
    },
    {
      name: "5",
      id: "5",
      value: 5
    }
  ]
}, ld = {
  ScreenType: [
    "Funds",
    "ETF",
    "Investment Trust"
  ],
  UILabel: "Morningstar sustainability",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      content: "The Morningstar Sustainability Rating is a reliable indicator to see if funds are meeting ESG challenges.",
      type: "content"
    },
    {
      name: "1",
      id: "1",
      value: 1
    },
    {
      name: "2",
      id: "2",
      value: 2
    },
    {
      name: "3",
      id: "3",
      value: 3
    },
    {
      name: "4",
      id: "4",
      value: 4
    },
    {
      name: "5",
      id: "5",
      value: 5
    }
  ]
}, od = {
  ScreenType: [
    "Shares"
  ],
  UILabel: "Industry",
  isAdvancedFilter: !0,
  isMultipleChoice: !0,
  isSectionBased: !1,
  data: [
    {
      id: "IG000DA620",
      name: "Advertising Agencies",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA690",
      name: "Aerospace & Defense",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA150",
      name: "Agricultural Inputs",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA785",
      name: "Airlines",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA780",
      name: "Airports & Air Services",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA180",
      name: "Aluminum",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA255",
      name: "Apparel Manufacturing",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA280",
      name: "Apparel Retail",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA009",
      name: "Asset Management",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA335",
      name: "Asset Management",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA220",
      name: "Auto & Truck Dealerships",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA225",
      name: "Auto Manufacturers",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA230",
      name: "Auto Parts",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA340",
      name: "Banks - Diversified",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA345",
      name: "Banks - Regional",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA470",
      name: "Beverages - Brewers",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA480",
      name: "Beverages - Non-Alcoholic",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA475",
      name: "Beverages - Wineries & Distilleries",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA530",
      name: "Biotechnology",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA630",
      name: "Broadcasting",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA155",
      name: "Building Materials",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA735",
      name: "Building Products & Equipment",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA750",
      name: "Business Equipment & Supplies",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA355",
      name: "Capital Markets",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA160",
      name: "Chemicals",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA210",
      name: "Coking Coal",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA830",
      name: "Communication Equipment",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA835",
      name: "Computer Hardware",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA485",
      name: "Confectioners",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA720",
      name: "Conglomerates",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA700",
      name: "Consulting Services",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA840",
      name: "Consumer Electronics",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA185",
      name: "Copper",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA405",
      name: "Credit Services",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA285",
      name: "Department Stores",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA575",
      name: "Diagnostics & Research",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA510",
      name: "Discount Stores",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA535",
      name: "Drug Manufacturers - General",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA540",
      name: "Drug Manufacturers - Specialty & Generic",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA505",
      name: "Education & Training Services",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA775",
      name: "Electrical Equipment & Parts",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA845",
      name: "Electronic Components",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA645",
      name: "Electronic Gaming & Multimedia",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA850",
      name: "Electronics & Computer Distribution",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA725",
      name: "Engineering & Construction",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA635",
      name: "Entertainment",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA740",
      name: "Farm & Heavy Construction Machinery",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA490",
      name: "Farm Products",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA400",
      name: "Financial Conglomerates",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA360",
      name: "Financial Data & Stock Exchanges",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA515",
      name: "Food Distribution",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA260",
      name: "Footwear & Accessories",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA240",
      name: "Furnishings, Fixtures & Appliances",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA310",
      name: "Gambling",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA195",
      name: "Gold",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA520",
      name: "Grocery Stores",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA560",
      name: "Health Information Services",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA545",
      name: "Healthcare Plans",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA290",
      name: "Home Improvement Retail",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA495",
      name: "Household & Personal Products",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA745",
      name: "Industrial Distribution",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA815",
      name: "Information Technology Services",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA730",
      name: "Infrastructure Operations",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA390",
      name: "Insurance - Diversified",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA365",
      name: "Insurance - Life",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA370",
      name: "Insurance - Property & Casualty",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA375",
      name: "Insurance - Reinsurance",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA380",
      name: "Insurance - Specialty",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA385",
      name: "Insurance Brokers",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA805",
      name: "Integrated Freight & Logistics",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA640",
      name: "Internet Content & Information",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA300",
      name: "Internet Retail",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA315",
      name: "Leisure",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA320",
      name: "Lodging",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA170",
      name: "Lumber & Wood Production",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA295",
      name: "Luxury Goods",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA795",
      name: "Marine Shipping",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA550",
      name: "Medical Care Facilities",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA565",
      name: "Medical Devices",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA580",
      name: "Medical Distribution",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA570",
      name: "Medical Instruments & Supplies",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA760",
      name: "Metal Fabrication",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA350",
      name: "Mortgage Finance",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA650",
      name: "Oil & Gas Drilling",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA655",
      name: "Oil & Gas E&P",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA675",
      name: "Oil & Gas Equipment & Services",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA660",
      name: "Oil & Gas Integrated",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA665",
      name: "Oil & Gas Midstream",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA670",
      name: "Oil & Gas Refining & Marketing",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA190",
      name: "Other Industrial Metals & Mining",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA205",
      name: "Other Precious Metals & Mining",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA500",
      name: "Packaged Foods",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA265",
      name: "Packaging & Containers",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA175",
      name: "Paper & Paper Products",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA270",
      name: "Personal Services",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA555",
      name: "Pharmaceutical Retailers",
      sectorId: "IG000BA005"
    },
    {
      id: "IG000DA765",
      name: "Pollution & Treatment Controls",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA625",
      name: "Publishing",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA790",
      name: "Railroads",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA410",
      name: "Real Estate - Development",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA420",
      name: "Real Estate - Diversified",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA415",
      name: "Real Estate Services",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA235",
      name: "Recreational Vehicles",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA465",
      name: "REIT - Diversified",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA425",
      name: "REIT - Healthcare Facilities",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA430",
      name: "REIT - Hotel & Motel",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA435",
      name: "REIT - Industrial",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA455",
      name: "REIT - Mortgage",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA440",
      name: "REIT - Office",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA445",
      name: "REIT - Residential",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA450",
      name: "REIT - Retail",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA460",
      name: "REIT - Specialty",
      sectorId: "IG000BA007"
    },
    {
      id: "IG000DA705",
      name: "Rental & Leasing Services",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA245",
      name: "Residential Construction",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA325",
      name: "Resorts & Casinos",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA275",
      name: "Restaurants",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA855",
      name: "Scientific & Technical Instruments",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA710",
      name: "Security & Protection Services",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA860",
      name: "Semiconductor Equipment & Materials",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA865",
      name: "Semiconductors",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA395",
      name: "Shell Companies",
      sectorId: "IG000BA010"
    },
    {
      id: "IG000DA200",
      name: "Silver",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA820",
      name: "Software - Application",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA825",
      name: "Software - Infrastructure",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA870",
      name: "Solar",
      sectorId: "IG000BA008"
    },
    {
      id: "IG000DA695",
      name: "Specialty Business Services",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA165",
      name: "Specialty Chemicals",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA755",
      name: "Specialty Industrial Machinery",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA305",
      name: "Specialty Retail",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA715",
      name: "Staffing & Employment Services",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA215",
      name: "Steel",
      sectorId: "IG000BA001"
    },
    {
      id: "IG000DA615",
      name: "Telecom Services",
      sectorId: "IG000BA002"
    },
    {
      id: "IG000DA250",
      name: "Textile Manufacturing",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA680",
      name: "Thermal Coal",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA525",
      name: "Tobacco",
      sectorId: "IG000BA004"
    },
    {
      id: "IG000DA770",
      name: "Tools & Accessories",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA330",
      name: "Travel Services",
      sectorId: "IG000BA003"
    },
    {
      id: "IG000DA800",
      name: "Trucking",
      sectorId: "IG000BA006"
    },
    {
      id: "IG000DA685",
      name: "Uranium",
      sectorId: "IG000BA009"
    },
    {
      id: "IG000DA610",
      name: "Utilities - Diversified",
      sectorId: "IG000BA011"
    },
    {
      id: "IG000DA585",
      name: "Utilities - Independent Power Producers",
      sectorId: "IG000BA011"
    },
    {
      id: "IG000DA600",
      name: "Utilities - Regulated Electric",
      sectorId: "IG000BA011"
    },
    {
      id: "IG000DA605",
      name: "Utilities - Regulated Gas",
      sectorId: "IG000BA011"
    },
    {
      id: "IG000DA595",
      name: "Utilities - Regulated Water",
      sectorId: "IG000BA011"
    },
    {
      id: "IG000DA590",
      name: "Utilities - Renewable",
      sectorId: "IG000BA011"
    },
    {
      id: "IG000DA810",
      name: "Waste Management",
      sectorId: "IG000BA006"
    }
  ]
}, rd = {
  ScreenType: [
    "Shares"
  ],
  UILabel: "P/E ratio",
  isAdvancedFilter: !0,
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      name: "< 0",
      value: "LTE:0",
      id: "lessThanZero"
    },
    {
      name: "0 - 10",
      value: "BTW:0:10",
      id: "btwZeroAndTen"
    },
    {
      name: "10 - 25",
      value: "BTW:10:25",
      id: "btwTenAndTwentyFive"
    },
    {
      name: "25 - 50",
      value: "BTW:25:50",
      id: "btwTwentyFiveAndFifty"
    },
    {
      name: "50 - 100",
      value: "BTW:50:100",
      id: "btwFiftyAndOneHundred"
    },
    {
      name: "100 - 500",
      value: "BTW:100:500",
      id: "btwOneHundredAndFiveHundred"
    },
    {
      name: "> 500",
      value: "GTE:500",
      id: "moreThanFiveHundred"
    }
  ]
}, sd = {
  ScreenType: [
    "Shares"
  ],
  UILabel: "Market Capitalisation",
  isAdvancedFilter: !1,
  isMultipleChoice: !1,
  isSectionBased: !1,
  data: [
    {
      name: "< 150M",
      value: "LTE:150000000",
      id: "lessThan150M"
    },
    {
      name: "150M - 500M",
      value: "BTW:150000000:500000000",
      id: "btw150MAnd500M"
    },
    {
      name: "500M - 1B",
      value: "BTW:500000000:1000000000",
      id: "btw500MAnd1B"
    },
    {
      name: "1B - 10B",
      value: "BTW:1000000000:10000000000",
      id: "btw1BAnd10B"
    },
    {
      name: "> 10B",
      value: "GTE:10000000000",
      id: "moreThan10B"
    }
  ]
}, cd = {
  IMASectorId: Du,
  SectorId: Hu,
  LargestSector: Uu,
  Region: Vu,
  FundManagerMapping: Wu,
  ManagementStyle: Xu,
  AJBellSelectionFunds: Zu,
  AJBellSelectionETF: zu,
  AJBellSelectionInvestmentTrust: Ju,
  LargestRegionNames: Yu,
  IncomeOrGrowth: ju,
  Performance: $u,
  OngoingCharge: Qu,
  SRRI: Ku,
  Yield: qu,
  GlobalAssetClassId: ed,
  Exchange: td,
  FundSize: nd,
  ReplicationMethod: id,
  MorningStarRating: ad,
  MorningSustainabilityRating: ld,
  IndustryId: od,
  PE_RATIO: rd,
  MarketCapitalisation: sd
}, ud = {
  SectorId: [],
  IMASectorId: [],
  LargestSector: [],
  AdministratorCompanyId: [],
  GlobalAssetClassId: [],
  FundTNAV: [],
  Yield_M12: [],
  DividendYield: [],
  Largestregion: [],
  SRRI: [],
  StarRating: [],
  SustainabilityRating: [],
  LatestReportOngoingCharge: [],
  ReturnM12: [],
  ReturnM36: [],
  ReturnM60: [],
  Distribution: [],
  IndexFund: [],
  FundsSelection: [],
  IndexingApproach: [],
  IndustryId: [],
  PERatio: [],
  MarketCap: [],
  ExchangeId: [],
  RegionExchangeId: [],
  currentPage: 1,
  selectedFunds: [],
  search: "",
  sortOrder: null,
  screenerType: "",
  rowsPerPage: 25
}, jt = (t) => Object.keys(t).map((e) => t[e].value), dd = (t) => {
  let e = [];
  return Object.keys(t).map((i) => {
    e = e.concat(t[i].value);
  }), e;
}, va = (t) => Object?.values(t).map((e) => Object?.values(e?.value)), lt = (t) => t.map((e) => e?.value.toString()), md = (t) => {
  if (!Array.isArray(t)) {
    console.error("ERROR: presetFilters is not an array!", t);
    return;
  }
  return [...t].reverse().find((i) => i.filterId === "APISearchTerm")?.value;
}, fd = (t, e, i) => {
  const a = { ...t };
  return a.screenerType = e.ScreenType, a.rowsPerPage = i, a.search = e.SearchTerm, "Sector" in e.Filters && ((e.ScreenType === "Funds" || e.ScreenType === "ETF") && (a.IMASectorId = jt(e.Filters.Sector) ?? []), e.ScreenType === "Shares" && (a.SectorId = jt(e.Filters.Sector) ?? []), e.ScreenType === "Investment Trust" && (a.LargestSector = jt(e.Filters.Sector) ?? [])), "Provider" in e.Filters && (a.AdministratorCompanyId = va(e.Filters.Provider) ?? []), "ManagementStyle" in e.Filters && (a.IndexFund = e.Filters.ManagementStyle[0]?.value ? [e.Filters.ManagementStyle[0]?.value?.toString()] : []), "AJBellSelection" in e.Filters && (a.FundsSelection = jt(e.Filters.AJBellSelection) ?? []), "Geographicalregion" in e.Filters && (a.Largestregion = lt(e.Filters.Geographicalregion) ?? []), "IncomeorGrowth" in e.Filters && (a.Distribution = e.Filters.IncomeorGrowth[0]?.value ? [e.Filters.IncomeorGrowth[0]?.value?.toString()] : []), "Performance" in e.Filters && e.Filters.Performance && e.Filters.Performance.forEach((n) => {
    n.section === "0" && (a.ReturnM12 = [
      n?.value?.toString()
    ]), n.section === "1" && (a.ReturnM36 = [
      n?.value?.toString()
    ]), n.section === "2" && (a.ReturnM60 = [
      n?.value?.toString()
    ]);
  }), "Ongoingfundcharge" in e.Filters && (a.LatestReportOngoingCharge = e.Filters.Ongoingfundcharge[0]?.value ? [e.Filters.Ongoingfundcharge[0]?.value?.toString()] : []), "RiskRating" in e.Filters && (a.SRRI = lt(e.Filters.RiskRating) ?? []), "Yield" in e.Filters && (e.ScreenType !== "Shares" ? a.Yield_M12 = e.Filters.Yield[0]?.value ? [e.Filters.Yield[0]?.value?.toString()] : [] : a.DividendYield = e.Filters.Yield[0]?.value ? [e.Filters.Yield[0]?.value?.toString()] : []), "Assetclass" in e.Filters && (a.GlobalAssetClassId = lt(e.Filters.Assetclass) ?? []), "FundSize" in e.Filters && (a.FundTNAV = e.Filters.FundSize[0]?.value ? [e.Filters.FundSize[0]?.value?.toString()] : []), "MorningstarRating" in e.Filters && (a.StarRating = lt(e.Filters.MorningstarRating) ?? []), "ReplicationMethod" in e.Filters && (a.IndexingApproach = lt(e.Filters.ReplicationMethod) ?? []), "Region" in e.Filters && (a.RegionExchangeId = va(e.Filters.Region) ?? []), "MarketCapitalisation" in e.Filters && (a.MarketCap = e.Filters.MarketCapitalisation[0]?.value ? [e.Filters.MarketCapitalisation[0]?.value?.toString()] : []), "Exchange" in e.Filters && (a.ExchangeId = lt(e.Filters.Exchange) ?? []), "Industry" in e.Filters && (a.IndustryId = lt(e.Filters.Industry) ?? []), "P/Eratio" in e.Filters && (a.PERatio = e.Filters["P/Eratio"][0]?.value ? [e.Filters["P/Eratio"][0]?.value?.toString()] : []), "AJBellSelection" in e.Filters && (a.selectedFunds = dd(e.Filters.AJBellSelection) ?? []), "Morningstarsustainability" in e.Filters && (a.SustainabilityRating = lt(e.Filters.Morningstarsustainability) ?? []), e.SearchTerm && e.ScreenType === "Funds" && (a.search = e.SearchTerm ?? ""), a;
}, pd = ({
  isLoading: t,
  onStateChange: e,
  className: i,
  searchCTA: a,
  ScreenType: n,
  itemsPerPage: l = 10,
  onClick: r,
  optionalHeader: c,
  filterAPI: o,
  autoCompleteOptions: s,
  hasScreenTypeHeaders: u = !0,
  presetFilters: d
}) => {
  const [C, p] = te(!1), [b, f] = te(!1), { dispatch: g, state: h } = ui(), S = ud, [E, A] = te(
    cd
  ), I = [], w = () => {
    Object.keys(E).forEach((T) => {
      const x = E[T];
      Object.keys(h.Filters).forEach((O) => {
        const W = h.Filters[O];
        O.replace(/ /g, "") === x.UILabel.replace(/ /g, "") && W.forEach((M) => {
          x.ScreenType.some(
            (L) => L.toLowerCase() === n.toLowerCase()
          ) && I.push({
            filterId: T,
            value: M.value
          });
        });
      });
    });
  };
  if (ne(() => {
    g({ type: "setScreenType", payload: n });
  }, []), ne(() => {
    t || o && A(o);
  }, [o, t]), ne(() => {
    w(), e?.({
      ComponentState: h,
      preselectedFilterValue: I,
      ScreenerAPIFetchState: fd(
        S,
        h,
        l
      )
    });
  }, [h, l, S]), ne(() => {
    if (!t) {
      p(!1);
      const T = md(
        (b ? [] : d) ?? []
      ) ?? h.SearchTerm;
      g({ type: "setSearchTerm", payload: T });
    }
  }, [h.ScreenType, t, c]), t)
    return /* @__PURE__ */ D(_i, { className: he("ajbl-screener abjl-anti-legacy-style", i), children: [
      /* @__PURE__ */ v(En, { className: "oxum-mb-5" }),
      /* @__PURE__ */ v("div", { className: "ajbl-screener_filters-wrapper oxum-mb-5 oxum-grid oxum-grid-cols-1 oxum-gap-4 md:oxum-grid-cols-2 lg:oxum-grid-cols-4", children: Array.from({ length: 4 }).map((T, x) => /* @__PURE__ */ v(En, { className: "oxum-mb-5" }, x)) }),
      /* @__PURE__ */ v("div", { className: "ajbl-screener_bottom-options oxum-mt-5", children: Array.from({ length: 1 }).map((T, x) => /* @__PURE__ */ v(
        En,
        {
          className: `ajbl-screener-loader-rect-0 oxum-w-100 oxum-mb-5 ${x > 0 && "oxum-float-right oxum-ml-3"}`
        },
        x
      )) })
    ] });
  if (o && !_t(o)) {
    console.error("filterAPI Failed to parse accountData");
    return;
  }
  return /* @__PURE__ */ D(
    _i,
    {
      section: !0,
      className: he("ajbl-screener abjl-anti-legacy-style", i, {
        "is-advanced-active": C
      }),
      children: [
        /* @__PURE__ */ v(
          Pu,
          {
            optionalHeader: c,
            currentScreenType: h.ScreenType ?? n,
            hasScreenTypeHeaders: u,
            dispatch: g
          }
        ),
        /* @__PURE__ */ D("div", { className: "ajbl-screener-fund-input-wrapper", children: [
          /* @__PURE__ */ v(
            ce,
            {
              className: "ajbl-screener__icon",
              icon: Bt
            }
          ),
          /* @__PURE__ */ v(
            "input",
            {
              className: "ajbl-screener__fund-name-input",
              type: "text",
              "aria-label": "search",
              placeholder: `Enter ${h.ScreenType} name`,
              value: h.SearchTerm,
              onChange: (T) => g({ type: "setSearchTerm", payload: T.target?.value })
            }
          ),
          s && s?.length > 0 && /* @__PURE__ */ v("ul", { className: "ajbl-screener__search-autocomplete-container", children: s.map((T, x) => /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v(
            "a",
            {
              className: "ajbl-screener__search-autocomplete-item",
              href: T.link,
              children: /* @__PURE__ */ v(qe, { isDumb: !0, chevron: "right", chevronSide: "right", children: T.label })
            }
          ) }, x)) })
        ] }),
        /* @__PURE__ */ v(
          Ru,
          {
            presetFilters: b ? [] : d,
            filterData: E,
            currentScreenType: h.ScreenType,
            showAdvancedOptions: C
          }
        ),
        /* @__PURE__ */ v(
          Ou,
          {
            searchCTA: a,
            showAdvancedOptions: C,
            setShowAdvancedOptions: p,
            setIsBottomClearAllActivated: f,
            hasAdvancedFilterOnScreen: h.AdvancedOptionAvailability,
            onClick: r,
            dispatch: g
          }
        )
      ]
    }
  );
}, Td = ({
  isLoading: t,
  className: e,
  inTestMode: i,
  searchCTA: a,
  itemsPerPage: n,
  hasScreenTypeHeaders: l,
  onStateChange: r,
  filterAPI: c,
  autoCompleteOptions: o,
  onClick: s,
  optionalHeader: u,
  ScreenType: d,
  presetFilters: C,
  LinkComponent: p
}) => /* @__PURE__ */ v(Gl, { children: /* @__PURE__ */ v(
  pd,
  {
    isLoading: t,
    className: e,
    inTestMode: i,
    optionalHeader: u,
    ScreenType: d ?? "Funds",
    searchCTA: a,
    onStateChange: r,
    onClick: s,
    filterAPI: c,
    autoCompleteOptions: o,
    hasScreenTypeHeaders: l,
    itemsPerPage: n,
    presetFilters: C,
    LinkComponent: p
  }
) }), gd = [
  {
    link: {
      link_path: "",
      link_title: "Portfolio & dealing",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "/platform/overview",
          link_title: "Portfolio overview",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/trade",
          link_title: "Buy and sell",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/orders",
          link_title: "Active orders",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/regularinvestments",
          link_title: "Regular investments",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/drips",
          link_title: "Dividends & income",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/manage-my-pension",
          link_title: "Manage my pension",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/pensionfinder",
          link_title: "Find my pensions",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    link: {
      link_path: "",
      link_title: "Manage payments",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "/platform/singlepayment",
          link_title: "Single payment",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/regularpayments",
          link_title: "Regular payment",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/withdrawcash",
          link_title: "Withdrawals",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/movecash",
          link_title: "Move cash between accounts",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    link: {
      link_path: "",
      link_title: "Documents and statments",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "/platform/history",
          link_title: "Transaction history",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/statements",
          link_title: "Cash statement",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/corporateactions",
          link_title: "Corporate actions",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/documents",
          link_title: "Documents",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    link: {
      link_path: "",
      link_title: "My account management",
      localized_options: {},
      field_component: []
    },
    dropdownsubmenu: !0,
    below: [
      {
        link: {
          link_path: "/platform/transfers",
          link_title: "Transfer an account",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/platform/admin/updatedetails",
          link_title: "Update my details",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      },
      {
        link: {
          link_path: "/myaccount/security",
          link_title: "Security settings",
          localized_options: {},
          field_component: [
            {
              id: "5375",
              field_text_content: "",
              field_plain_title: ""
            }
          ]
        },
        dropdownsubmenu: !1,
        below: []
      }
    ]
  },
  {
    link: {
      link_path: "/platform/securemessages",
      link_title: "Secure messages",
      localized_options: {},
      field_component: [
        {
          id: "5375",
          field_text_content: "",
          field_plain_title: ""
        }
      ],
      showSecureMessagesCount: !0
    },
    dropdownsubmenu: !1,
    below: []
  }
], Sd = {
  signedInNavigation: gd
};
export {
  Ve as Button,
  _i as Card,
  Jc as Checkselect,
  Ed as Footer,
  Sd as HardcodedPlaceholders,
  En as Loadingshimmer,
  Ad as MegaNav,
  qe as NavItem,
  Td as Screener,
  zc as Select
};
